// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AdminBenchmarkStoresApiV1AdminBenchmarkStoresGetData,
  AdminBenchmarkStoresApiV1AdminBenchmarkStoresGetErrors,
  AdminBenchmarkStoresApiV1AdminBenchmarkStoresGetResponses,
  AdminLoginApiV1AdminAuthLoginPostData,
  AdminLoginApiV1AdminAuthLoginPostErrors,
  AdminLoginApiV1AdminAuthLoginPostResponses,
  AdminLoginTestApiV1AdminAuthLoginTestPostData,
  AdminLoginTestApiV1AdminAuthLoginTestPostErrors,
  AdminLoginTestApiV1AdminAuthLoginTestPostResponses,
  AdminLogoutApiV1AdminAuthLogoutPostData,
  AdminLogoutApiV1AdminAuthLogoutPostErrors,
  AdminLogoutApiV1AdminAuthLogoutPostResponses,
  AnalyzePageApiV1DiagnosticAnalyzePostData,
  AnalyzePageApiV1DiagnosticAnalyzePostErrors,
  AnalyzePageApiV1DiagnosticAnalyzePostResponses,
  ApiProductsTopCategorySalesEndpointData,
  ApiProductsTopCategorySalesEndpointErrors,
  ApiProductsTopCategorySalesEndpointResponses,
  ApiV1AcquisitionAudienceQualityGetData,
  ApiV1AcquisitionAudienceQualityGetErrors,
  ApiV1AcquisitionAudienceQualityGetResponses,
  ApiV1AcquisitionGeoTablesGetData,
  ApiV1AcquisitionGeoTablesGetErrors,
  ApiV1AcquisitionGeoTablesGetResponses,
  ApiV1AcquisitionOrdersGetData,
  ApiV1AcquisitionOrdersGetErrors,
  ApiV1AcquisitionOrdersGetResponses,
  ApiV1AdminAiCreditPacksGetData,
  ApiV1AdminAiCreditPacksGetErrors,
  ApiV1AdminAiCreditPacksGetResponses,
  ApiV1AdminAiCreditPacksPackIdDeleteData,
  ApiV1AdminAiCreditPacksPackIdDeleteErrors,
  ApiV1AdminAiCreditPacksPackIdDeleteResponses,
  ApiV1AdminAiCreditPacksPackIdPutData,
  ApiV1AdminAiCreditPacksPackIdPutErrors,
  ApiV1AdminAiCreditPacksPackIdPutResponses,
  ApiV1AdminAiCreditPacksPostData,
  ApiV1AdminAiCreditPacksPostErrors,
  ApiV1AdminAiCreditPacksPostResponses,
  ApiV1AdminAiPromptsGetData,
  ApiV1AdminAiPromptsGetErrors,
  ApiV1AdminAiPromptsGetResponses,
  ApiV1AdminAiPromptsKeyDeleteData,
  ApiV1AdminAiPromptsKeyDeleteErrors,
  ApiV1AdminAiPromptsKeyDeleteResponses,
  ApiV1AdminAiPromptsKeyPutData,
  ApiV1AdminAiPromptsKeyPutErrors,
  ApiV1AdminAiPromptsKeyPutResponses,
  ApiV1AdminAuth2FaBackupCodesPostData,
  ApiV1AdminAuth2FaBackupCodesPostErrors,
  ApiV1AdminAuth2FaBackupCodesPostResponses,
  ApiV1AdminAuth2FaReconfigurePostData,
  ApiV1AdminAuth2FaReconfigurePostErrors,
  ApiV1AdminAuth2FaReconfigurePostResponses,
  ApiV1AdminCouponsRedemptionsGetData,
  ApiV1AdminCouponsRedemptionsGetErrors,
  ApiV1AdminCouponsRedemptionsGetResponses,
  ApiV1AdminFeedbackFeedbackIdPatchData,
  ApiV1AdminFeedbackFeedbackIdPatchErrors,
  ApiV1AdminFeedbackFeedbackIdPatchResponses,
  ApiV1AdminFeedbackGetData,
  ApiV1AdminFeedbackGetErrors,
  ApiV1AdminFeedbackGetResponses,
  ApiV1Auth2FaBackupCodesPostData,
  ApiV1Auth2FaBackupCodesPostErrors,
  ApiV1Auth2FaBackupCodesPostResponses,
  ApiV1FeedbackPostData,
  ApiV1FeedbackPostErrors,
  ApiV1FeedbackPostResponses,
  ApiV1MyAccountAiCreditPacksGetData,
  ApiV1MyAccountAiCreditPacksGetErrors,
  ApiV1MyAccountAiCreditPacksGetResponses,
  ApiV1MyAccountAiCreditPacksPurchasePostData,
  ApiV1MyAccountAiCreditPacksPurchasePostErrors,
  ApiV1MyAccountAiCreditPacksPurchasePostResponses,
  ApiV1MyAccountAiCreditPacksPurchasesInvoiceIdQrGetData,
  ApiV1MyAccountAiCreditPacksPurchasesInvoiceIdQrGetErrors,
  ApiV1MyAccountAiCreditPacksPurchasesInvoiceIdQrGetResponses,
  ApiV1SalesFunnelStage1BreakdownGetData,
  ApiV1SalesFunnelStage1BreakdownGetErrors,
  ApiV1SalesFunnelStage1BreakdownGetResponses,
  ApiV1SeoBrandTermsGetData,
  ApiV1SeoBrandTermsGetErrors,
  ApiV1SeoBrandTermsGetResponses,
  ApiV1SeoBrandTermsPutData,
  ApiV1SeoBrandTermsPutErrors,
  ApiV1SeoBrandTermsPutResponses,
  ApiV1TeamsGetData,
  ApiV1TeamsGetErrors,
  ApiV1TeamsGetResponses,
  ApiV1TeamsMyScopeGetData,
  ApiV1TeamsMyScopeGetErrors,
  ApiV1TeamsMyScopeGetResponses,
  ApiV1TeamsPostData,
  ApiV1TeamsPostErrors,
  ApiV1TeamsPostResponses,
  ApiV1TeamsTeamIdAccountsPutData,
  ApiV1TeamsTeamIdAccountsPutErrors,
  ApiV1TeamsTeamIdAccountsPutResponses,
  ApiV1TeamsTeamIdDeleteData,
  ApiV1TeamsTeamIdDeleteErrors,
  ApiV1TeamsTeamIdDeleteResponses,
  ApiV1TeamsTeamIdGetData,
  ApiV1TeamsTeamIdGetErrors,
  ApiV1TeamsTeamIdGetResponses,
  ApiV1TeamsTeamIdMembersPutData,
  ApiV1TeamsTeamIdMembersPutErrors,
  ApiV1TeamsTeamIdMembersPutResponses,
  ApiV1TeamsTeamIdOverviewGetData,
  ApiV1TeamsTeamIdOverviewGetErrors,
  ApiV1TeamsTeamIdOverviewGetResponses,
  ApiV1TeamsTeamIdPutData,
  ApiV1TeamsTeamIdPutErrors,
  ApiV1TeamsTeamIdPutResponses,
  AskApiV1MediaChatConversationsConversationIdAskPostData,
  AskApiV1MediaChatConversationsConversationIdAskPostErrors,
  AskApiV1MediaChatConversationsConversationIdAskPostResponses,
  AssignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPostData,
  AssignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPostErrors,
  AssignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPostResponses,
  AssignPlanByUserApiV1AdminSubscribersAssignPlanByUserPostData,
  AssignPlanByUserApiV1AdminSubscribersAssignPlanByUserPostErrors,
  AssignPlanByUserApiV1AdminSubscribersAssignPlanByUserPostResponses,
  BulkActionAdminUsersApiV1AdminAdminUsersBulkActionPostData,
  BulkActionAdminUsersApiV1AdminAdminUsersBulkActionPostErrors,
  BulkActionAdminUsersApiV1AdminAdminUsersBulkActionPostResponses,
  BulkActionSubscribersApiV1AdminSubscribersBulkActionPostData,
  BulkActionSubscribersApiV1AdminSubscribersBulkActionPostErrors,
  BulkActionSubscribersApiV1AdminSubscribersBulkActionPostResponses,
  BulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPostData,
  BulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPostErrors,
  BulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPostResponses,
  BulkEnrollStudentsApiV1AdminCoursesBulkEnrollPostData,
  BulkEnrollStudentsApiV1AdminCoursesBulkEnrollPostErrors,
  BulkEnrollStudentsApiV1AdminCoursesBulkEnrollPostResponses,
  ChangePasswordApiV1AdminAuthChangePasswordPostData,
  ChangePasswordApiV1AdminAuthChangePasswordPostErrors,
  ChangePasswordApiV1AdminAuthChangePasswordPostResponses,
  ChangePasswordApiV1AuthChangePasswordPostData,
  ChangePasswordApiV1AuthChangePasswordPostErrors,
  ChangePasswordApiV1AuthChangePasswordPostResponses,
  ClearAccountDataApiV1IntegrationsInstagramInsightsClearDataDeleteData,
  ClearAccountDataApiV1IntegrationsInstagramInsightsClearDataDeleteErrors,
  ClearAccountDataApiV1IntegrationsInstagramInsightsClearDataDeleteResponses,
  ClearAccountDataApiV1IntegrationsMetaAdsClearDataDeleteData,
  ClearAccountDataApiV1IntegrationsMetaAdsClearDataDeleteErrors,
  ClearAccountDataApiV1IntegrationsMetaAdsClearDataDeleteResponses,
  ClearAccountDataApiV1IntegrationsSearchConsoleClearDataDeleteData,
  ClearAccountDataApiV1IntegrationsSearchConsoleClearDataDeleteErrors,
  ClearAccountDataApiV1IntegrationsSearchConsoleClearDataDeleteResponses,
  CloneCourseApiV1AdminCoursesClonePostData,
  CloneCourseApiV1AdminCoursesClonePostErrors,
  CloneCourseApiV1AdminCoursesClonePostResponses,
  CloneCourseEndpointApiV1AdminCoursesCourseIdClonePostData,
  CloneCourseEndpointApiV1AdminCoursesCourseIdClonePostErrors,
  CloneCourseEndpointApiV1AdminCoursesCourseIdClonePostResponses,
  ConfirmPasswordResetApiV1AdminAuthPasswordResetConfirmPostData,
  ConfirmPasswordResetApiV1AdminAuthPasswordResetConfirmPostErrors,
  ConfirmPasswordResetApiV1AdminAuthPasswordResetConfirmPostResponses,
  ContinueAgentChatApiV1AiAgentsChatPostData,
  ContinueAgentChatApiV1AiAgentsChatPostErrors,
  ContinueAgentChatApiV1AiAgentsChatPostResponses,
  ContinueChatApiV1AiInsightsChatPostData,
  ContinueChatApiV1AiInsightsChatPostErrors,
  ContinueChatApiV1AiInsightsChatPostResponses,
  CreateAccountApiV1AccountsPostData,
  CreateAccountApiV1AccountsPostErrors,
  CreateAccountApiV1AccountsPostResponses,
  CreateAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPostData,
  CreateAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPostErrors,
  CreateAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPostResponses,
  CreateAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPostData,
  CreateAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPostErrors,
  CreateAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPostResponses,
  CreateAccountUserApiV1MyAccountUsersPostData,
  CreateAccountUserApiV1MyAccountUsersPostErrors,
  CreateAccountUserApiV1MyAccountUsersPostResponses,
  CreateAdminUserApiV1AdminAdminUsersPost2Data,
  CreateAdminUserApiV1AdminAdminUsersPost2Errors,
  CreateAdminUserApiV1AdminAdminUsersPost2Responses,
  CreateAdminUserApiV1AdminAdminUsersPostData,
  CreateAdminUserApiV1AdminAdminUsersPostErrors,
  CreateAdminUserApiV1AdminAdminUsersPostResponses,
  CreateCouponApiV1AdminBillingCouponsPostData,
  CreateCouponApiV1AdminBillingCouponsPostErrors,
  CreateCouponApiV1AdminBillingCouponsPostResponses,
  CreateCouponApiV1AdminCouponsPostData,
  CreateCouponApiV1AdminCouponsPostErrors,
  CreateCouponApiV1AdminCouponsPostResponses,
  CreateCourseApiV1AdminCoursesPostData,
  CreateCourseApiV1AdminCoursesPostErrors,
  CreateCourseApiV1AdminCoursesPostResponses,
  CreateCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPostData,
  CreateCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPostErrors,
  CreateCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPostResponses,
  CreateCourseModuleApiV1AdminCoursesCourseIdModulesPostData,
  CreateCourseModuleApiV1AdminCoursesCourseIdModulesPostErrors,
  CreateCourseModuleApiV1AdminCoursesCourseIdModulesPostResponses,
  CreateFeatureApiV1AdminFeaturesPostData,
  CreateFeatureApiV1AdminFeaturesPostErrors,
  CreateFeatureApiV1AdminFeaturesPostResponses,
  CreateLessonApiV1AdminCoursesLessonsPostData,
  CreateLessonApiV1AdminCoursesLessonsPostErrors,
  CreateLessonApiV1AdminCoursesLessonsPostResponses,
  CreateLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPostData,
  CreateLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPostErrors,
  CreateLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPostResponses,
  CreateModuleApiV1AdminCoursesModulesPostData,
  CreateModuleApiV1AdminCoursesModulesPostErrors,
  CreateModuleApiV1AdminCoursesModulesPostResponses,
  CreatePlanApiV1AdminPlansPostData,
  CreatePlanApiV1AdminPlansPostErrors,
  CreatePlanApiV1AdminPlansPostResponses,
  CreateProfileApiV1AdminAdminUsersProfilesPostData,
  CreateProfileApiV1AdminAdminUsersProfilesPostErrors,
  CreateProfileApiV1AdminAdminUsersProfilesPostResponses,
  CreateSegmentApiV1AdminBenchmarkSegmentsPostData,
  CreateSegmentApiV1AdminBenchmarkSegmentsPostErrors,
  CreateSegmentApiV1AdminBenchmarkSegmentsPostResponses,
  CreateSubscriberApiV1AdminSubscribersPostData,
  CreateSubscriberApiV1AdminSubscribersPostErrors,
  CreateSubscriberApiV1AdminSubscribersPostResponses,
  DeactivateSubscriberApiV1AdminSubscribersSubscriberIdDeleteData,
  DeactivateSubscriberApiV1AdminSubscribersSubscriberIdDeleteErrors,
  DeactivateSubscriberApiV1AdminSubscribersSubscriberIdDeleteResponses,
  DeleteAccountPermanentlyApiV1AccountsAccountIdDeleteData,
  DeleteAccountPermanentlyApiV1AccountsAccountIdDeleteErrors,
  DeleteAccountPermanentlyApiV1AccountsAccountIdDeleteResponses,
  DeleteAccountUserApiV1MyAccountUsersAccountUserIdDeleteData,
  DeleteAccountUserApiV1MyAccountUsersAccountUserIdDeleteErrors,
  DeleteAccountUserApiV1MyAccountUsersAccountUserIdDeleteResponses,
  DeleteAdminUserApiV1AdminAdminUsersAdminUserIdDeleteData,
  DeleteAdminUserApiV1AdminAdminUsersAdminUserIdDeleteErrors,
  DeleteAdminUserApiV1AdminAdminUsersAdminUserIdDeleteResponses,
  DeleteAnalysisApiV1DiagnosticAnalysesAnalysisIdDeleteData,
  DeleteAnalysisApiV1DiagnosticAnalysesAnalysisIdDeleteErrors,
  DeleteAnalysisApiV1DiagnosticAnalysesAnalysisIdDeleteResponses,
  DeleteAvatarApiV1UsersMeAvatarDeleteData,
  DeleteAvatarApiV1UsersMeAvatarDeleteErrors,
  DeleteAvatarApiV1UsersMeAvatarDeleteResponses,
  DeleteConversationApiV1MediaChatConversationsConversationIdDeleteData,
  DeleteConversationApiV1MediaChatConversationsConversationIdDeleteErrors,
  DeleteConversationApiV1MediaChatConversationsConversationIdDeleteResponses,
  DeleteCouponApiV1AdminCouponsCouponIdDeleteData,
  DeleteCouponApiV1AdminCouponsCouponIdDeleteErrors,
  DeleteCouponApiV1AdminCouponsCouponIdDeleteResponses,
  DeleteCourseApiV1AdminCoursesCourseIdDeleteData,
  DeleteCourseApiV1AdminCoursesCourseIdDeleteErrors,
  DeleteCourseApiV1AdminCoursesCourseIdDeleteResponses,
  DeleteFeatureApiV1AdminFeaturesFeatureIdDeleteData,
  DeleteFeatureApiV1AdminFeaturesFeatureIdDeleteErrors,
  DeleteFeatureApiV1AdminFeaturesFeatureIdDeleteResponses,
  DeleteLessonApiV1AdminCoursesLessonsLessonIdDeleteData,
  DeleteLessonApiV1AdminCoursesLessonsLessonIdDeleteErrors,
  DeleteLessonApiV1AdminCoursesLessonsLessonIdDeleteResponses,
  DeleteLessonMediaApiV1AdminCoursesMediaMediaIdDeleteData,
  DeleteLessonMediaApiV1AdminCoursesMediaMediaIdDeleteErrors,
  DeleteLessonMediaApiV1AdminCoursesMediaMediaIdDeleteResponses,
  DeleteModuleApiV1AdminCoursesModulesModuleIdDeleteData,
  DeleteModuleApiV1AdminCoursesModulesModuleIdDeleteErrors,
  DeleteModuleApiV1AdminCoursesModulesModuleIdDeleteResponses,
  DeleteProfileApiV1AdminAdminUsersProfilesProfileIdDeleteData,
  DeleteProfileApiV1AdminAdminUsersProfilesProfileIdDeleteErrors,
  DeleteProfileApiV1AdminAdminUsersProfilesProfileIdDeleteResponses,
  DeleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDeleteData,
  DeleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDeleteErrors,
  DeleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDeleteResponses,
  DeleteUserConnectionApiV1UsersMeConnectionsDeleteData,
  DeleteUserConnectionApiV1UsersMeConnectionsDeleteErrors,
  DeleteUserConnectionApiV1UsersMeConnectionsDeleteResponses,
  Disable2FaApiV1Auth2FaDisablePostData,
  Disable2FaApiV1Auth2FaDisablePostErrors,
  Disable2FaApiV1Auth2FaDisablePostResponses,
  DisableSyncApiV1AdminSyncDisablePostData,
  DisableSyncApiV1AdminSyncDisablePostErrors,
  DisableSyncApiV1AdminSyncDisablePostResponses,
  DisconnectGoogleAdsApiV1IntegrationsGoogleAdsDisconnectDeleteData,
  DisconnectGoogleAdsApiV1IntegrationsGoogleAdsDisconnectDeleteErrors,
  DisconnectGoogleAdsApiV1IntegrationsGoogleAdsDisconnectDeleteResponses,
  DisconnectGoogleAnalyticsApiV1IntegrationsGoogleAnalyticsDisconnectDeleteData,
  DisconnectGoogleAnalyticsApiV1IntegrationsGoogleAnalyticsDisconnectDeleteErrors,
  DisconnectGoogleAnalyticsApiV1IntegrationsGoogleAnalyticsDisconnectDeleteResponses,
  DisconnectIntegrationApiV1IntegrationsNexusDisconnectDeleteData,
  DisconnectIntegrationApiV1IntegrationsNexusDisconnectDeleteErrors,
  DisconnectIntegrationApiV1IntegrationsNexusDisconnectDeleteResponses,
  Enable2FaApiV1Auth2FaEnablePostData,
  Enable2FaApiV1Auth2FaEnablePostErrors,
  Enable2FaApiV1Auth2FaEnablePostResponses,
  EnableSyncApiV1AdminSyncEnablePostData,
  EnableSyncApiV1AdminSyncEnablePostErrors,
  EnableSyncApiV1AdminSyncEnablePostResponses,
  ExportSubscribersListApiV1AdminSubscribersExportGetData,
  ExportSubscribersListApiV1AdminSubscribersExportGetErrors,
  ExportSubscribersListApiV1AdminSubscribersExportGetResponses,
  ExportTransactionsApiV1AdminBillingExportGetData,
  ExportTransactionsApiV1AdminBillingExportGetErrors,
  ExportTransactionsApiV1AdminBillingExportGetResponses,
  FetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGetData,
  FetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGetErrors,
  FetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGetResponses,
  FetchAgentInsightApiV1AiAgentsPlatformInsightPostData,
  FetchAgentInsightApiV1AiAgentsPlatformInsightPostErrors,
  FetchAgentInsightApiV1AiAgentsPlatformInsightPostResponses,
  FetchAgentInsightGetApiV1AiAgentsPlatformInsightGetData,
  FetchAgentInsightGetApiV1AiAgentsPlatformInsightGetErrors,
  FetchAgentInsightGetApiV1AiAgentsPlatformInsightGetResponses,
  FinalizeUpdateApiV1BenchmarkFinalizeUpdatePostData,
  FinalizeUpdateApiV1BenchmarkFinalizeUpdatePostErrors,
  FinalizeUpdateApiV1BenchmarkFinalizeUpdatePostResponses,
  ForceSyncIntegrationApiV1AdminSyncForceSyncPostData,
  ForceSyncIntegrationApiV1AdminSyncForceSyncPostErrors,
  ForceSyncIntegrationApiV1AdminSyncForceSyncPostResponses,
  ForgotPasswordApiV1AuthForgotPasswordPostData,
  ForgotPasswordApiV1AuthForgotPasswordPostErrors,
  ForgotPasswordApiV1AuthForgotPasswordPostResponses,
  GenerateInsightsApiV1AiInsightsGenerateInsightsPostData,
  GenerateInsightsApiV1AiInsightsGenerateInsightsPostErrors,
  GenerateInsightsApiV1AiInsightsGenerateInsightsPostResponses,
  GetAccountsApiV1IntegrationsInstagramInsightsAccountsGetData,
  GetAccountsApiV1IntegrationsInstagramInsightsAccountsGetErrors,
  GetAccountsApiV1IntegrationsInstagramInsightsAccountsGetResponses,
  GetAccountsApiV1IntegrationsMetaAdsAccountsGetData,
  GetAccountsApiV1IntegrationsMetaAdsAccountsGetErrors,
  GetAccountsApiV1IntegrationsMetaAdsAccountsGetResponses,
  GetAccountsApiV1IntegrationsSearchConsoleAccountsGetData,
  GetAccountsApiV1IntegrationsSearchConsoleAccountsGetErrors,
  GetAccountsApiV1IntegrationsSearchConsoleAccountsGetResponses,
  GetAccountSummaryApiV1IntegrationsInstagramInsightsSummaryGetData,
  GetAccountSummaryApiV1IntegrationsInstagramInsightsSummaryGetErrors,
  GetAccountSummaryApiV1IntegrationsInstagramInsightsSummaryGetResponses,
  GetAccountSummaryApiV1IntegrationsMetaAdsSummaryGetData,
  GetAccountSummaryApiV1IntegrationsMetaAdsSummaryGetErrors,
  GetAccountSummaryApiV1IntegrationsMetaAdsSummaryGetResponses,
  GetAccountSummaryApiV1IntegrationsSearchConsoleSummaryGetData,
  GetAccountSummaryApiV1IntegrationsSearchConsoleSummaryGetErrors,
  GetAccountSummaryApiV1IntegrationsSearchConsoleSummaryGetResponses,
  GetAcquisitionCampaignsApiV1AcquisitionCampaignsGetData,
  GetAcquisitionCampaignsApiV1AcquisitionCampaignsGetErrors,
  GetAcquisitionCampaignsApiV1AcquisitionCampaignsGetResponses,
  GetAcquisitionChannelGroupingApiV1AcquisitionChannelGroupingGetData,
  GetAcquisitionChannelGroupingApiV1AcquisitionChannelGroupingGetErrors,
  GetAcquisitionChannelGroupingApiV1AcquisitionChannelGroupingGetResponses,
  GetAcquisitionDashboardApiV1AcquisitionGetData,
  GetAcquisitionDashboardApiV1AcquisitionGetErrors,
  GetAcquisitionDashboardApiV1AcquisitionGetResponses,
  GetAcquisitionDrilldownApiV1AcquisitionDrilldownGetData,
  GetAcquisitionDrilldownApiV1AcquisitionDrilldownGetErrors,
  GetAcquisitionDrilldownApiV1AcquisitionDrilldownGetResponses,
  GetAcquisitionFullApiV1AcquisitionFullGetData,
  GetAcquisitionFullApiV1AcquisitionFullGetErrors,
  GetAcquisitionFullApiV1AcquisitionFullGetResponses,
  GetAcquisitionGeoUsersApiV1AcquisitionGeoUsersGetData,
  GetAcquisitionGeoUsersApiV1AcquisitionGeoUsersGetErrors,
  GetAcquisitionGeoUsersApiV1AcquisitionGeoUsersGetResponses,
  GetAcquisitionGeoUsersNewByRegionApiV1AcquisitionGeoUsersNewByRegionGetData,
  GetAcquisitionGeoUsersNewByRegionApiV1AcquisitionGeoUsersNewByRegionGetErrors,
  GetAcquisitionGeoUsersNewByRegionApiV1AcquisitionGeoUsersNewByRegionGetResponses,
  GetAcquisitionGeoUsersNewByRegionSourceApiV1AcquisitionGeoUsersNewByRegionSourceGetData,
  GetAcquisitionGeoUsersNewByRegionSourceApiV1AcquisitionGeoUsersNewByRegionSourceGetErrors,
  GetAcquisitionGeoUsersNewByRegionSourceApiV1AcquisitionGeoUsersNewByRegionSourceGetResponses,
  GetAcquisitionGeoUsersReturningByRegionApiV1AcquisitionGeoUsersReturningByRegionGetData,
  GetAcquisitionGeoUsersReturningByRegionApiV1AcquisitionGeoUsersReturningByRegionGetErrors,
  GetAcquisitionGeoUsersReturningByRegionApiV1AcquisitionGeoUsersReturningByRegionGetResponses,
  GetAcquisitionGeoUsersReturningByRegionSourceApiV1AcquisitionGeoUsersReturningByRegionSourceGetData,
  GetAcquisitionGeoUsersReturningByRegionSourceApiV1AcquisitionGeoUsersReturningByRegionSourceGetErrors,
  GetAcquisitionGeoUsersReturningByRegionSourceApiV1AcquisitionGeoUsersReturningByRegionSourceGetResponses,
  GetAcquisitionKpisApiV1AcquisitionKpisGetData,
  GetAcquisitionKpisApiV1AcquisitionKpisGetErrors,
  GetAcquisitionKpisApiV1AcquisitionKpisGetResponses,
  GetAcquisitionNewVsReturningApiV1AcquisitionNewVsReturningGetData,
  GetAcquisitionNewVsReturningApiV1AcquisitionNewVsReturningGetErrors,
  GetAcquisitionNewVsReturningApiV1AcquisitionNewVsReturningGetResponses,
  GetAcquisitionSourceMediumApiV1AcquisitionSourceMediumGetData,
  GetAcquisitionSourceMediumApiV1AcquisitionSourceMediumGetErrors,
  GetAcquisitionSourceMediumApiV1AcquisitionSourceMediumGetResponses,
  GetAcquisitionTimelineApiV1AcquisitionTimelineGetData,
  GetAcquisitionTimelineApiV1AcquisitionTimelineGetErrors,
  GetAcquisitionTimelineApiV1AcquisitionTimelineGetResponses,
  GetAdminStorageApiV1AdminStorageGetData,
  GetAdminStorageApiV1AdminStorageGetErrors,
  GetAdminStorageApiV1AdminStorageGetResponses,
  GetAdminUserDetailsApiV1AdminAdminUsersAdminUserIdGetData,
  GetAdminUserDetailsApiV1AdminAdminUsersAdminUserIdGetErrors,
  GetAdminUserDetailsApiV1AdminAdminUsersAdminUserIdGetResponses,
  GetAdvancedMetricsApiV1IntegrationsGoogleAnalyticsAdvancedMetricsGetData,
  GetAdvancedMetricsApiV1IntegrationsGoogleAnalyticsAdvancedMetricsGetErrors,
  GetAdvancedMetricsApiV1IntegrationsGoogleAnalyticsAdvancedMetricsGetResponses,
  GetAiCreditsApiV1MyAccountAiCreditsGetData,
  GetAiCreditsApiV1MyAccountAiCreditsGetErrors,
  GetAiCreditsApiV1MyAccountAiCreditsGetResponses,
  GetAllPagesApiV1PagesAllPagesGetData,
  GetAllPagesApiV1PagesAllPagesGetErrors,
  GetAllPagesApiV1PagesAllPagesGetResponses,
  GetAnalysisApiV1DiagnosticAnalysesAnalysisIdGetData,
  GetAnalysisApiV1DiagnosticAnalysesAnalysisIdGetErrors,
  GetAnalysisApiV1DiagnosticAnalysesAnalysisIdGetResponses,
  GetAnalyticsOverviewApiV1AnalyticsOverviewGetData,
  GetAnalyticsOverviewApiV1AnalyticsOverviewGetErrors,
  GetAnalyticsOverviewApiV1AnalyticsOverviewGetResponses,
  GetAudienceInsightsApiV1IntegrationsInstagramInsightsAudienceInsightsGetData,
  GetAudienceInsightsApiV1IntegrationsInstagramInsightsAudienceInsightsGetErrors,
  GetAudienceInsightsApiV1IntegrationsInstagramInsightsAudienceInsightsGetResponses,
  GetAuthUrlApiV1IntegrationsInstagramInsightsAuthUrlGetData,
  GetAuthUrlApiV1IntegrationsInstagramInsightsAuthUrlGetErrors,
  GetAuthUrlApiV1IntegrationsInstagramInsightsAuthUrlGetResponses,
  GetAuthUrlApiV1IntegrationsMetaAdsAuthUrlGetData,
  GetAuthUrlApiV1IntegrationsMetaAdsAuthUrlGetErrors,
  GetAuthUrlApiV1IntegrationsMetaAdsAuthUrlGetResponses,
  GetAuthUrlApiV1IntegrationsSearchConsoleAuthUrlGetData,
  GetAuthUrlApiV1IntegrationsSearchConsoleAuthUrlGetErrors,
  GetAuthUrlApiV1IntegrationsSearchConsoleAuthUrlGetResponses,
  GetAvailableAccountsApiV1ExternalAccountsAvailableGetData,
  GetAvailableAccountsApiV1ExternalAccountsAvailableGetErrors,
  GetAvailableAccountsApiV1ExternalAccountsAvailableGetResponses,
  GetAvailableMonthsApiV1BenchmarkAvailableMonthsGetData,
  GetAvailableMonthsApiV1BenchmarkAvailableMonthsGetErrors,
  GetAvailableMonthsApiV1BenchmarkAvailableMonthsGetResponses,
  GetBillingSummaryApiV1AdminBillingSummaryGetData,
  GetBillingSummaryApiV1AdminBillingSummaryGetErrors,
  GetBillingSummaryApiV1AdminBillingSummaryGetResponses,
  GetBillingSummaryFixApiV1AdminBillingSummaryFixGetData,
  GetBillingSummaryFixApiV1AdminBillingSummaryFixGetErrors,
  GetBillingSummaryFixApiV1AdminBillingSummaryFixGetResponses,
  GetCampaignFilterFieldsApiV1CampaignFilterFieldsGetData,
  GetCampaignFilterFieldsApiV1CampaignFilterFieldsGetErrors,
  GetCampaignFilterFieldsApiV1CampaignFilterFieldsGetResponses,
  GetCampaignFiltersApiV1CampaignFiltersGetData,
  GetCampaignFiltersApiV1CampaignFiltersGetErrors,
  GetCampaignFiltersApiV1CampaignFiltersGetResponses,
  GetCampaignFilterSuggestionsApiV1CampaignFilterSuggestionsGetData,
  GetCampaignFilterSuggestionsApiV1CampaignFilterSuggestionsGetErrors,
  GetCampaignFilterSuggestionsApiV1CampaignFilterSuggestionsGetResponses,
  GetCampaignsApiV1IntegrationsMetaAdsCampaignsGetData,
  GetCampaignsApiV1IntegrationsMetaAdsCampaignsGetErrors,
  GetCampaignsApiV1IntegrationsMetaAdsCampaignsGetResponses,
  GetCampaignsCardPagesApiV1AnalyticsCampaignsPagesGetData,
  GetCampaignsCardPagesApiV1AnalyticsCampaignsPagesGetErrors,
  GetCampaignsCardPagesApiV1AnalyticsCampaignsPagesGetResponses,
  GetCategoryByCityApiV1CategoryByCityGetData,
  GetCategoryByCityApiV1CategoryByCityGetErrors,
  GetCategoryByCityApiV1CategoryByCityGetResponses,
  GetCategoryByStateApiV1CategoryByStateGetData,
  GetCategoryByStateApiV1CategoryByStateGetErrors,
  GetCategoryByStateApiV1CategoryByStateGetResponses,
  GetChannelDailyAnalysisApiV1ChannelDailyAnalysisGetData,
  GetChannelDailyAnalysisApiV1ChannelDailyAnalysisGetErrors,
  GetChannelDailyAnalysisApiV1ChannelDailyAnalysisGetResponses,
  GetChannelGroupingCardDataApiV1ChannelGroupingCardGetData,
  GetChannelGroupingCardDataApiV1ChannelGroupingCardGetErrors,
  GetChannelGroupingCardDataApiV1ChannelGroupingCardGetResponses,
  GetChannelMonthlyAnalysisApiV1ChannelMonthlyAnalysisGetData,
  GetChannelMonthlyAnalysisApiV1ChannelMonthlyAnalysisGetErrors,
  GetChannelMonthlyAnalysisApiV1ChannelMonthlyAnalysisGetResponses,
  GetChurnAnalysisApiV1AdminDashboardChurnAnalysisGetData,
  GetChurnAnalysisApiV1AdminDashboardChurnAnalysisGetErrors,
  GetChurnAnalysisApiV1AdminDashboardChurnAnalysisGetResponses,
  GetCompleteDataApiV1IntegrationsGoogleAnalyticsCompleteDataGetData,
  GetCompleteDataApiV1IntegrationsGoogleAnalyticsCompleteDataGetErrors,
  GetCompleteDataApiV1IntegrationsGoogleAnalyticsCompleteDataGetResponses,
  GetCompleteDataApiV1IntegrationsInstagramInsightsCompleteDataGetData,
  GetCompleteDataApiV1IntegrationsInstagramInsightsCompleteDataGetErrors,
  GetCompleteDataApiV1IntegrationsInstagramInsightsCompleteDataGetResponses,
  GetCompleteDataApiV1IntegrationsMetaAdsCompleteDataGetData,
  GetCompleteDataApiV1IntegrationsMetaAdsCompleteDataGetErrors,
  GetCompleteDataApiV1IntegrationsMetaAdsCompleteDataGetResponses,
  GetCompleteDataApiV1IntegrationsSearchConsoleCompleteDataGetData,
  GetCompleteDataApiV1IntegrationsSearchConsoleCompleteDataGetErrors,
  GetCompleteDataApiV1IntegrationsSearchConsoleCompleteDataGetResponses,
  GetCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsCompleteDataGetData,
  GetCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsCompleteDataGetErrors,
  GetCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsCompleteDataGetResponses,
  GetConnectionStatusApiV1IntegrationsInstagramInsightsConnectionStatusGetData,
  GetConnectionStatusApiV1IntegrationsInstagramInsightsConnectionStatusGetErrors,
  GetConnectionStatusApiV1IntegrationsInstagramInsightsConnectionStatusGetResponses,
  GetConnectionStatusApiV1IntegrationsMetaAdsConnectionStatusGetData,
  GetConnectionStatusApiV1IntegrationsMetaAdsConnectionStatusGetErrors,
  GetConnectionStatusApiV1IntegrationsMetaAdsConnectionStatusGetResponses,
  GetConnectionStatusApiV1IntegrationsSearchConsoleConnectionStatusGetData,
  GetConnectionStatusApiV1IntegrationsSearchConsoleConnectionStatusGetErrors,
  GetConnectionStatusApiV1IntegrationsSearchConsoleConnectionStatusGetResponses,
  GetConsolidatedOverviewApiV1IntegrationsGoogleAnalyticsOverviewConsolidatedGetData,
  GetConsolidatedOverviewApiV1IntegrationsGoogleAnalyticsOverviewConsolidatedGetErrors,
  GetConsolidatedOverviewApiV1IntegrationsGoogleAnalyticsOverviewConsolidatedGetResponses,
  GetConversionRateCardsV2ApiV1ConversionRateCardsV2GetData,
  GetConversionRateCardsV2ApiV1ConversionRateCardsV2GetErrors,
  GetConversionRateCardsV2ApiV1ConversionRateCardsV2GetResponses,
  GetConversionRateDashboardApiV1ConversionRateDashboardGetData,
  GetConversionRateDashboardApiV1ConversionRateDashboardGetErrors,
  GetConversionRateDashboardApiV1ConversionRateDashboardGetResponses,
  GetConversionRateDemographicsApiV1ConversionRateDemographicsGetData,
  GetConversionRateDemographicsApiV1ConversionRateDemographicsGetErrors,
  GetConversionRateDemographicsApiV1ConversionRateDemographicsGetResponses,
  GetConversionRateDemographicsV2ApiV1ConversionRateDemographicsV2GetData,
  GetConversionRateDemographicsV2ApiV1ConversionRateDemographicsV2GetErrors,
  GetConversionRateDemographicsV2ApiV1ConversionRateDemographicsV2GetResponses,
  GetConversionRateFullApiV1ConversionRateFullGetData,
  GetConversionRateFullApiV1ConversionRateFullGetErrors,
  GetConversionRateFullApiV1ConversionRateFullGetResponses,
  GetConversionRateUtmCampaignsApiV1ConversionRateUtmCampaignsGetData,
  GetConversionRateUtmCampaignsApiV1ConversionRateUtmCampaignsGetErrors,
  GetConversionRateUtmCampaignsApiV1ConversionRateUtmCampaignsGetResponses,
  GetCoreWebVitalsApiV1IntegrationsSearchConsoleCoreWebVitalsGetData,
  GetCoreWebVitalsApiV1IntegrationsSearchConsoleCoreWebVitalsGetErrors,
  GetCoreWebVitalsApiV1IntegrationsSearchConsoleCoreWebVitalsGetResponses,
  GetCourseDetailsApiV1AdminCoursesCourseIdGetData,
  GetCourseDetailsApiV1AdminCoursesCourseIdGetErrors,
  GetCourseDetailsApiV1AdminCoursesCourseIdGetResponses,
  GetCourseEnrollmentStatsApiV1AdminCoursesCourseIdEnrollmentStatsGetData,
  GetCourseEnrollmentStatsApiV1AdminCoursesCourseIdEnrollmentStatsGetErrors,
  GetCourseEnrollmentStatsApiV1AdminCoursesCourseIdEnrollmentStatsGetResponses,
  GetCoursesSummaryApiV1AdminCoursesSummaryGetData,
  GetCoursesSummaryApiV1AdminCoursesSummaryGetErrors,
  GetCoursesSummaryApiV1AdminCoursesSummaryGetResponses,
  GetCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGetData,
  GetCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGetErrors,
  GetCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGetResponses,
  GetCreativeApiV1IntegrationsMetaAdsCreativeGetData,
  GetCreativeApiV1IntegrationsMetaAdsCreativeGetErrors,
  GetCreativeApiV1IntegrationsMetaAdsCreativeGetResponses,
  GetCurrentAdminApiV1AdminAuthMeGetData,
  GetCurrentAdminApiV1AdminAuthMeGetErrors,
  GetCurrentAdminApiV1AdminAuthMeGetResponses,
  GetCustomerBillingHistoryApiV1AdminBillingCustomersSubscriberIdHistoryGetData,
  GetCustomerBillingHistoryApiV1AdminBillingCustomersSubscriberIdHistoryGetErrors,
  GetCustomerBillingHistoryApiV1AdminBillingCustomersSubscriberIdHistoryGetResponses,
  GetCustomerSyncStatusApiV1SyncStatusGetData,
  GetCustomerSyncStatusApiV1SyncStatusGetErrors,
  GetCustomerSyncStatusApiV1SyncStatusGetResponses,
  GetDailyControlApiV1DailyControlCardGetData,
  GetDailyControlApiV1DailyControlCardGetErrors,
  GetDailyControlApiV1DailyControlCardGetResponses,
  GetDailyForecastSeriesApiV1AdminDashboardForecastDailyGetData,
  GetDailyForecastSeriesApiV1AdminDashboardForecastDailyGetErrors,
  GetDailyForecastSeriesApiV1AdminDashboardForecastDailyGetResponses,
  GetDailyMetricsApiV1IntegrationsInstagramInsightsDailyMetricsGetData,
  GetDailyMetricsApiV1IntegrationsInstagramInsightsDailyMetricsGetErrors,
  GetDailyMetricsApiV1IntegrationsInstagramInsightsDailyMetricsGetResponses,
  GetDailyPerformanceApiV1SalesDailyPerformanceGetData,
  GetDailyPerformanceApiV1SalesDailyPerformanceGetErrors,
  GetDailyPerformanceApiV1SalesDailyPerformanceGetResponses,
  GetDashboardSummaryApiV1AdminDashboardSummaryGetData,
  GetDashboardSummaryApiV1AdminDashboardSummaryGetErrors,
  GetDashboardSummaryApiV1AdminDashboardSummaryGetResponses,
  GetDataApiV1BenchmarkDataPostData,
  GetDataApiV1BenchmarkDataPostErrors,
  GetDataApiV1BenchmarkDataPostResponses,
  GetDemographicsApiV1IntegrationsMetaAdsDemographicsGetData,
  GetDemographicsApiV1IntegrationsMetaAdsDemographicsGetErrors,
  GetDemographicsApiV1IntegrationsMetaAdsDemographicsGetResponses,
  GetDevicesSalesApiV1DevicesSalesGetData,
  GetDevicesSalesApiV1DevicesSalesGetErrors,
  GetDevicesSalesApiV1DevicesSalesGetResponses,
  GetDevicesStatesApiV1DevicesStatesCardGetData,
  GetDevicesStatesApiV1DevicesStatesCardGetErrors,
  GetDevicesStatesApiV1DevicesStatesCardGetResponses,
  GetEligiblePlansApiV1SubscriptionsEligiblePlansGetData,
  GetEligiblePlansApiV1SubscriptionsEligiblePlansGetErrors,
  GetEligiblePlansApiV1SubscriptionsEligiblePlansGetResponses,
  GetEngagementTrendsApiV1IntegrationsInstagramInsightsEngagementTrendsGetData,
  GetEngagementTrendsApiV1IntegrationsInstagramInsightsEngagementTrendsGetErrors,
  GetEngagementTrendsApiV1IntegrationsInstagramInsightsEngagementTrendsGetResponses,
  GetEnrollmentsEvolutionApiV1AdminCoursesChartsEnrollmentsEvolutionGetData,
  GetEnrollmentsEvolutionApiV1AdminCoursesChartsEnrollmentsEvolutionGetErrors,
  GetEnrollmentsEvolutionApiV1AdminCoursesChartsEnrollmentsEvolutionGetResponses,
  GetFeatureDetailsApiV1AdminFeaturesFeatureIdGetData,
  GetFeatureDetailsApiV1AdminFeaturesFeatureIdGetErrors,
  GetFeatureDetailsApiV1AdminFeaturesFeatureIdGetResponses,
  GetGa4PropertiesApiV1AnalyticsGa4PropertiesGetData,
  GetGa4PropertiesApiV1AnalyticsGa4PropertiesGetErrors,
  GetGa4PropertiesApiV1AnalyticsGa4PropertiesGetResponses,
  GetGoogleAdsAccountsApiV1IntegrationsGoogleAdsAccountsGetData,
  GetGoogleAdsAccountsApiV1IntegrationsGoogleAdsAccountsGetErrors,
  GetGoogleAdsAccountsApiV1IntegrationsGoogleAdsAccountsGetResponses,
  GetGoogleAdsAdPerformanceApiV1IntegrationsGoogleAdsAdPerformanceGetData,
  GetGoogleAdsAdPerformanceApiV1IntegrationsGoogleAdsAdPerformanceGetErrors,
  GetGoogleAdsAdPerformanceApiV1IntegrationsGoogleAdsAdPerformanceGetResponses,
  GetGoogleAdsAuthUrlApiV1IntegrationsGoogleAdsAuthUrlGetData,
  GetGoogleAdsAuthUrlApiV1IntegrationsGoogleAdsAuthUrlGetErrors,
  GetGoogleAdsAuthUrlApiV1IntegrationsGoogleAdsAuthUrlGetResponses,
  GetGoogleAdsAuthUrlApiV1IntegrationsNexusGoogleAdsAuthUrlGetData,
  GetGoogleAdsAuthUrlApiV1IntegrationsNexusGoogleAdsAuthUrlGetErrors,
  GetGoogleAdsAuthUrlApiV1IntegrationsNexusGoogleAdsAuthUrlGetResponses,
  GetGoogleAdsCampaignsApiV1IntegrationsGoogleAdsCampaignsGetData,
  GetGoogleAdsCampaignsApiV1IntegrationsGoogleAdsCampaignsGetErrors,
  GetGoogleAdsCampaignsApiV1IntegrationsGoogleAdsCampaignsGetResponses,
  GetGoogleAdsCityMetricsApiV1IntegrationsGoogleAdsCityMetricsGetData,
  GetGoogleAdsCityMetricsApiV1IntegrationsGoogleAdsCityMetricsGetErrors,
  GetGoogleAdsCityMetricsApiV1IntegrationsGoogleAdsCityMetricsGetResponses,
  GetGoogleAdsDemographicsApiV1IntegrationsGoogleAdsDemographicsGetData,
  GetGoogleAdsDemographicsApiV1IntegrationsGoogleAdsDemographicsGetErrors,
  GetGoogleAdsDemographicsApiV1IntegrationsGoogleAdsDemographicsGetResponses,
  GetGoogleAdsDeviceMetricsApiV1IntegrationsGoogleAdsDeviceMetricsGetData,
  GetGoogleAdsDeviceMetricsApiV1IntegrationsGoogleAdsDeviceMetricsGetErrors,
  GetGoogleAdsDeviceMetricsApiV1IntegrationsGoogleAdsDeviceMetricsGetResponses,
  GetGoogleAdsExtensionsPerformanceApiV1IntegrationsGoogleAdsExtensionsGetData,
  GetGoogleAdsExtensionsPerformanceApiV1IntegrationsGoogleAdsExtensionsGetErrors,
  GetGoogleAdsExtensionsPerformanceApiV1IntegrationsGoogleAdsExtensionsGetResponses,
  GetGoogleAdsGeographicPerformanceApiV1IntegrationsGoogleAdsGeographicGetData,
  GetGoogleAdsGeographicPerformanceApiV1IntegrationsGoogleAdsGeographicGetErrors,
  GetGoogleAdsGeographicPerformanceApiV1IntegrationsGoogleAdsGeographicGetResponses,
  GetGoogleAdsHourlyMetricsApiV1IntegrationsGoogleAdsHourlyMetricsGetData,
  GetGoogleAdsHourlyMetricsApiV1IntegrationsGoogleAdsHourlyMetricsGetErrors,
  GetGoogleAdsHourlyMetricsApiV1IntegrationsGoogleAdsHourlyMetricsGetResponses,
  GetGoogleAdsKeywordsApiV1IntegrationsGoogleAdsKeywordsGetData,
  GetGoogleAdsKeywordsApiV1IntegrationsGoogleAdsKeywordsGetErrors,
  GetGoogleAdsKeywordsApiV1IntegrationsGoogleAdsKeywordsGetResponses,
  GetGoogleAdsManagerTotalApiV1GoogleAdsManagerTotalGetData,
  GetGoogleAdsManagerTotalApiV1GoogleAdsManagerTotalGetErrors,
  GetGoogleAdsManagerTotalApiV1GoogleAdsManagerTotalGetResponses,
  GetGoogleAdsMetricsApiV1IntegrationsGoogleAdsMetricsGetData,
  GetGoogleAdsMetricsApiV1IntegrationsGoogleAdsMetricsGetErrors,
  GetGoogleAdsMetricsApiV1IntegrationsGoogleAdsMetricsGetResponses,
  GetGoogleAdsPerformanceInsightsApiV1IntegrationsGoogleAdsPerformanceInsightsGetData,
  GetGoogleAdsPerformanceInsightsApiV1IntegrationsGoogleAdsPerformanceInsightsGetErrors,
  GetGoogleAdsPerformanceInsightsApiV1IntegrationsGoogleAdsPerformanceInsightsGetResponses,
  GetGoogleAdsStatusApiV1IntegrationsGoogleAdsStatusGetData,
  GetGoogleAdsStatusApiV1IntegrationsGoogleAdsStatusGetErrors,
  GetGoogleAdsStatusApiV1IntegrationsGoogleAdsStatusGetResponses,
  GetGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsAccountsGetData,
  GetGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsAccountsGetErrors,
  GetGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsAccountsGetResponses,
  GetGoogleAnalyticsAuthUrlApiV1IntegrationsGoogleAnalyticsAuthUrlGetData,
  GetGoogleAnalyticsAuthUrlApiV1IntegrationsGoogleAnalyticsAuthUrlGetErrors,
  GetGoogleAnalyticsAuthUrlApiV1IntegrationsGoogleAnalyticsAuthUrlGetResponses,
  GetGoogleAnalyticsAuthUrlApiV1IntegrationsNexusGoogleAnalyticsAuthUrlGetData,
  GetGoogleAnalyticsAuthUrlApiV1IntegrationsNexusGoogleAnalyticsAuthUrlGetErrors,
  GetGoogleAnalyticsAuthUrlApiV1IntegrationsNexusGoogleAnalyticsAuthUrlGetResponses,
  GetGoogleAnalyticsConversionRateCardsKpisApiV1GoogleAnalyticsConversionRateCardsKpisGetData,
  GetGoogleAnalyticsConversionRateCardsKpisApiV1GoogleAnalyticsConversionRateCardsKpisGetErrors,
  GetGoogleAnalyticsConversionRateCardsKpisApiV1GoogleAnalyticsConversionRateCardsKpisGetResponses,
  GetGoogleAnalyticsGeographyApiV1IntegrationsGoogleAnalyticsGeographyGetData,
  GetGoogleAnalyticsGeographyApiV1IntegrationsGoogleAnalyticsGeographyGetErrors,
  GetGoogleAnalyticsGeographyApiV1IntegrationsGoogleAnalyticsGeographyGetResponses,
  GetGoogleAnalyticsMetricsApiV1IntegrationsGoogleAnalyticsMetricsGetData,
  GetGoogleAnalyticsMetricsApiV1IntegrationsGoogleAnalyticsMetricsGetErrors,
  GetGoogleAnalyticsMetricsApiV1IntegrationsGoogleAnalyticsMetricsGetResponses,
  GetGoogleAnalyticsOverviewApiV1IntegrationsGoogleAnalyticsOverviewGetData,
  GetGoogleAnalyticsOverviewApiV1IntegrationsGoogleAnalyticsOverviewGetErrors,
  GetGoogleAnalyticsOverviewApiV1IntegrationsGoogleAnalyticsOverviewGetResponses,
  GetGoogleAnalyticsPageMetricsApiV1IntegrationsGoogleAnalyticsPagesGetData,
  GetGoogleAnalyticsPageMetricsApiV1IntegrationsGoogleAnalyticsPagesGetErrors,
  GetGoogleAnalyticsPageMetricsApiV1IntegrationsGoogleAnalyticsPagesGetResponses,
  GetGoogleAnalyticsRealtimeApiV1IntegrationsGoogleAnalyticsRealtimeGetData,
  GetGoogleAnalyticsRealtimeApiV1IntegrationsGoogleAnalyticsRealtimeGetErrors,
  GetGoogleAnalyticsRealtimeApiV1IntegrationsGoogleAnalyticsRealtimeGetResponses,
  GetGoogleAnalyticsStatusApiV1IntegrationsGoogleAnalyticsStatusGetData,
  GetGoogleAnalyticsStatusApiV1IntegrationsGoogleAnalyticsStatusGetErrors,
  GetGoogleAnalyticsStatusApiV1IntegrationsGoogleAnalyticsStatusGetResponses,
  GetGoogleAnalyticsTechnologyApiV1IntegrationsGoogleAnalyticsTechnologyGetData,
  GetGoogleAnalyticsTechnologyApiV1IntegrationsGoogleAnalyticsTechnologyGetErrors,
  GetGoogleAnalyticsTechnologyApiV1IntegrationsGoogleAnalyticsTechnologyGetResponses,
  GetGrowthMetricsApiV1AdminDashboardGrowthGetData,
  GetGrowthMetricsApiV1AdminDashboardGrowthGetErrors,
  GetGrowthMetricsApiV1AdminDashboardGrowthGetResponses,
  GetHashtagMetricsApiV1IntegrationsInstagramInsightsHashtagMetricsGetData,
  GetHashtagMetricsApiV1IntegrationsInstagramInsightsHashtagMetricsGetErrors,
  GetHashtagMetricsApiV1IntegrationsInstagramInsightsHashtagMetricsGetResponses,
  GetHistoricalAdsPerformanceApiV1HistoricalAdsPerformanceGetData,
  GetHistoricalAdsPerformanceApiV1HistoricalAdsPerformanceGetErrors,
  GetHistoricalAdsPerformanceApiV1HistoricalAdsPerformanceGetResponses,
  GetHistoricalDataApiV1BenchmarkHistoricalDataPostData,
  GetHistoricalDataApiV1BenchmarkHistoricalDataPostErrors,
  GetHistoricalDataApiV1BenchmarkHistoricalDataPostResponses,
  GetHistoricalGoogleAdsChartApiV1HistoricalGoogleAdsChartGetData,
  GetHistoricalGoogleAdsChartApiV1HistoricalGoogleAdsChartGetErrors,
  GetHistoricalGoogleAdsChartApiV1HistoricalGoogleAdsChartGetResponses,
  GetHistoricalGoogleAdsTableApiV1HistoricalGoogleAdsTableGetData,
  GetHistoricalGoogleAdsTableApiV1HistoricalGoogleAdsTableGetErrors,
  GetHistoricalGoogleAdsTableApiV1HistoricalGoogleAdsTableGetResponses,
  GetHistoricalMetaAdsChartApiV1HistoricalMetaAdsChartGetData,
  GetHistoricalMetaAdsChartApiV1HistoricalMetaAdsChartGetErrors,
  GetHistoricalMetaAdsChartApiV1HistoricalMetaAdsChartGetResponses,
  GetHistoricalMetaAdsTableApiV1HistoricalMetaAdsTableGetData,
  GetHistoricalMetaAdsTableApiV1HistoricalMetaAdsTableGetErrors,
  GetHistoricalMetaAdsTableApiV1HistoricalMetaAdsTableGetResponses,
  GetHistoryApiV1MediaChatConversationsConversationIdHistoryGetData,
  GetHistoryApiV1MediaChatConversationsConversationIdHistoryGetErrors,
  GetHistoryApiV1MediaChatConversationsConversationIdHistoryGetResponses,
  GetImplementationStepsApiV1AiInsightsImplementationStepsPostData,
  GetImplementationStepsApiV1AiInsightsImplementationStepsPostErrors,
  GetImplementationStepsApiV1AiInsightsImplementationStepsPostResponses,
  GetIndexCoverageApiV1IntegrationsSearchConsoleIndexCoverageGetData,
  GetIndexCoverageApiV1IntegrationsSearchConsoleIndexCoverageGetErrors,
  GetIndexCoverageApiV1IntegrationsSearchConsoleIndexCoverageGetResponses,
  GetInstagramCardMetricApiV1InstagramCardsMetricSlugGetData,
  GetInstagramCardMetricApiV1InstagramCardsMetricSlugGetErrors,
  GetInstagramCardMetricApiV1InstagramCardsMetricSlugGetResponses,
  GetInstagramDemographicsApiV1InstagramDemographicsGetData,
  GetInstagramDemographicsApiV1InstagramDemographicsGetErrors,
  GetInstagramDemographicsApiV1InstagramDemographicsGetResponses,
  GetInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGetData,
  GetInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGetErrors,
  GetInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGetResponses,
  GetInstagramEngagementApiV1InstagramEngagementGetData,
  GetInstagramEngagementApiV1InstagramEngagementGetErrors,
  GetInstagramEngagementApiV1InstagramEngagementGetResponses,
  GetInstagramInsightsAuthUrlApiV1IntegrationsNexusInstagramInsightsAuthUrlGetData,
  GetInstagramInsightsAuthUrlApiV1IntegrationsNexusInstagramInsightsAuthUrlGetErrors,
  GetInstagramInsightsAuthUrlApiV1IntegrationsNexusInstagramInsightsAuthUrlGetResponses,
  GetInstagramKpisCompleteApiV1InstagramKpisCompleteGetData,
  GetInstagramKpisCompleteApiV1InstagramKpisCompleteGetErrors,
  GetInstagramKpisCompleteApiV1InstagramKpisCompleteGetResponses,
  GetInstagramPostsApiV1InstagramPostsGetData,
  GetInstagramPostsApiV1InstagramPostsGetErrors,
  GetInstagramPostsApiV1InstagramPostsGetResponses,
  GetInstagramProfileMetricsApiV1InstagramProfileMetricsGetData,
  GetInstagramProfileMetricsApiV1InstagramProfileMetricsGetErrors,
  GetInstagramProfileMetricsApiV1InstagramProfileMetricsGetResponses,
  GetInstagramStoriesApiV1InstagramStoriesGetData,
  GetInstagramStoriesApiV1InstagramStoriesGetErrors,
  GetInstagramStoriesApiV1InstagramStoriesGetResponses,
  GetInstagramTimeseriesCompleteApiV1InstagramTimeseriesCompleteGetData,
  GetInstagramTimeseriesCompleteApiV1InstagramTimeseriesCompleteGetErrors,
  GetInstagramTimeseriesCompleteApiV1InstagramTimeseriesCompleteGetResponses,
  GetInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGetData,
  GetInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGetErrors,
  GetInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGetResponses,
  GetIntegrationAuthUrlApiV1IntegrationsNexusAuthUrlGetData,
  GetIntegrationAuthUrlApiV1IntegrationsNexusAuthUrlGetErrors,
  GetIntegrationAuthUrlApiV1IntegrationsNexusAuthUrlGetResponses,
  GetIntegrationTypesApiV1AdminSyncIntegrationsGetData,
  GetIntegrationTypesApiV1AdminSyncIntegrationsGetErrors,
  GetIntegrationTypesApiV1AdminSyncIntegrationsGetResponses,
  GetInterestsApiV1IntegrationsMetaAdsInterestsGetData,
  GetInterestsApiV1IntegrationsMetaAdsInterestsGetErrors,
  GetInterestsApiV1IntegrationsMetaAdsInterestsGetResponses,
  GetInternalSearchApiV1InternalSearchCardGetData,
  GetInternalSearchApiV1InternalSearchCardGetErrors,
  GetInternalSearchApiV1InternalSearchCardGetResponses,
  GetInvoiceDetailApiV1MyAccountInvoicesInvoiceIdGetData,
  GetInvoiceDetailApiV1MyAccountInvoicesInvoiceIdGetErrors,
  GetInvoiceDetailApiV1MyAccountInvoicesInvoiceIdGetResponses,
  GetInvoiceDetailsApiV1AdminBillingInvoicesInvoiceIdGetData,
  GetInvoiceDetailsApiV1AdminBillingInvoicesInvoiceIdGetErrors,
  GetInvoiceDetailsApiV1AdminBillingInvoicesInvoiceIdGetResponses,
  GetJobStatusApiV1DiagnosticJobsJobIdGetData,
  GetJobStatusApiV1DiagnosticJobsJobIdGetErrors,
  GetJobStatusApiV1DiagnosticJobsJobIdGetResponses,
  GetJobStatusApiV1MediaChatJobsJobIdGetData,
  GetJobStatusApiV1MediaChatJobsJobIdGetErrors,
  GetJobStatusApiV1MediaChatJobsJobIdGetResponses,
  GetLandingPagesApiV1PagesLandingPageGetData,
  GetLandingPagesApiV1PagesLandingPageGetErrors,
  GetLandingPagesApiV1PagesLandingPageGetResponses,
  GetLessonDetailsApiV1AdminCoursesLessonsLessonIdGetData,
  GetLessonDetailsApiV1AdminCoursesLessonsLessonIdGetErrors,
  GetLessonDetailsApiV1AdminCoursesLessonsLessonIdGetResponses,
  GetLojaVirtualAnalyticsApiV1LojaVirtualAnalyticsGetData,
  GetLojaVirtualAnalyticsApiV1LojaVirtualAnalyticsGetErrors,
  GetLojaVirtualAnalyticsApiV1LojaVirtualAnalyticsGetResponses,
  GetMaintenanceStatusApiV1AdminSettingsMaintenanceModeStatusGetData,
  GetMaintenanceStatusApiV1AdminSettingsMaintenanceModeStatusGetErrors,
  GetMaintenanceStatusApiV1AdminSettingsMaintenanceModeStatusGetResponses,
  GetMediaPerformanceAovConversionApiV1MediaPerformanceAovConversionGetData,
  GetMediaPerformanceAovConversionApiV1MediaPerformanceAovConversionGetErrors,
  GetMediaPerformanceAovConversionApiV1MediaPerformanceAovConversionGetResponses,
  GetMediaPerformanceCardsApiV1MediaPerformanceCardsGetData,
  GetMediaPerformanceCardsApiV1MediaPerformanceCardsGetErrors,
  GetMediaPerformanceCardsApiV1MediaPerformanceCardsGetResponses,
  GetMediaPerformanceChannelGroupsApiV1MediaPerformanceChannelGroupsGetData,
  GetMediaPerformanceChannelGroupsApiV1MediaPerformanceChannelGroupsGetErrors,
  GetMediaPerformanceChannelGroupsApiV1MediaPerformanceChannelGroupsGetResponses,
  GetMediaPerformanceGeneralPerformanceApiV1MediaPerformanceGeneralPerformanceGetData,
  GetMediaPerformanceGeneralPerformanceApiV1MediaPerformanceGeneralPerformanceGetErrors,
  GetMediaPerformanceGeneralPerformanceApiV1MediaPerformanceGeneralPerformanceGetResponses,
  GetMediaPerformanceInvestmentCpsApiV1MediaPerformanceInvestmentCpsGetData,
  GetMediaPerformanceInvestmentCpsApiV1MediaPerformanceInvestmentCpsGetErrors,
  GetMediaPerformanceInvestmentCpsApiV1MediaPerformanceInvestmentCpsGetResponses,
  GetMediaPerformanceInvestmentRevenueApiV1MediaPerformanceInvestmentRevenueGetData,
  GetMediaPerformanceInvestmentRevenueApiV1MediaPerformanceInvestmentRevenueGetErrors,
  GetMediaPerformanceInvestmentRevenueApiV1MediaPerformanceInvestmentRevenueGetResponses,
  GetMediaPerformanceInvestmentRoasApiV1MediaPerformanceInvestmentRoasGetData,
  GetMediaPerformanceInvestmentRoasApiV1MediaPerformanceInvestmentRoasGetErrors,
  GetMediaPerformanceInvestmentRoasApiV1MediaPerformanceInvestmentRoasGetResponses,
  GetMediaPerformanceInvestmentSessionsApiV1MediaPerformanceInvestmentSessionsGetData,
  GetMediaPerformanceInvestmentSessionsApiV1MediaPerformanceInvestmentSessionsGetErrors,
  GetMediaPerformanceInvestmentSessionsApiV1MediaPerformanceInvestmentSessionsGetResponses,
  GetMediaPerformanceRevenueConversionApiV1MediaPerformanceRevenueConversionGetData,
  GetMediaPerformanceRevenueConversionApiV1MediaPerformanceRevenueConversionGetErrors,
  GetMediaPerformanceRevenueConversionApiV1MediaPerformanceRevenueConversionGetResponses,
  GetMediaPerformanceSessionOriginMediaApiV1MediaPerformanceSessionOriginMediaGetData,
  GetMediaPerformanceSessionOriginMediaApiV1MediaPerformanceSessionOriginMediaGetErrors,
  GetMediaPerformanceSessionOriginMediaApiV1MediaPerformanceSessionOriginMediaGetResponses,
  GetMediaPerformanceSessionsAovApiV1MediaPerformanceSessionsAovGetData,
  GetMediaPerformanceSessionsAovApiV1MediaPerformanceSessionsAovGetErrors,
  GetMediaPerformanceSessionsAovApiV1MediaPerformanceSessionsAovGetResponses,
  GetMediaPerformanceSessionsBreakdownApiV1MediaPerformanceSessionsBreakdownGetData,
  GetMediaPerformanceSessionsBreakdownApiV1MediaPerformanceSessionsBreakdownGetErrors,
  GetMediaPerformanceSessionsBreakdownApiV1MediaPerformanceSessionsBreakdownGetResponses,
  GetMediaPerformanceSessionsConversionApiV1MediaPerformanceSessionsConversionGetData,
  GetMediaPerformanceSessionsConversionApiV1MediaPerformanceSessionsConversionGetErrors,
  GetMediaPerformanceSessionsConversionApiV1MediaPerformanceSessionsConversionGetResponses,
  GetMediaPerformanceSessionsRevenueApiV1MediaPerformanceSessionsRevenueGetData,
  GetMediaPerformanceSessionsRevenueApiV1MediaPerformanceSessionsRevenueGetErrors,
  GetMediaPerformanceSessionsRevenueApiV1MediaPerformanceSessionsRevenueGetResponses,
  GetMediaPerformanceSessionsRoasApiV1MediaPerformanceSessionsRoasGetData,
  GetMediaPerformanceSessionsRoasApiV1MediaPerformanceSessionsRoasGetErrors,
  GetMediaPerformanceSessionsRoasApiV1MediaPerformanceSessionsRoasGetResponses,
  GetMetaAdsAdPerformanceApiV1IntegrationsMetaAdsAdPerformanceGetData,
  GetMetaAdsAdPerformanceApiV1IntegrationsMetaAdsAdPerformanceGetErrors,
  GetMetaAdsAdPerformanceApiV1IntegrationsMetaAdsAdPerformanceGetResponses,
  GetMetaAdsAuthUrlApiV1IntegrationsNexusMetaAdsAuthUrlGetData,
  GetMetaAdsAuthUrlApiV1IntegrationsNexusMetaAdsAuthUrlGetErrors,
  GetMetaAdsAuthUrlApiV1IntegrationsNexusMetaAdsAuthUrlGetResponses,
  GetMetaAdsFeaturedAdsetsApiV1IntegrationsMetaAdsFeaturedAdsetsGetData,
  GetMetaAdsFeaturedAdsetsApiV1IntegrationsMetaAdsFeaturedAdsetsGetErrors,
  GetMetaAdsFeaturedAdsetsApiV1IntegrationsMetaAdsFeaturedAdsetsGetResponses,
  GetMetaAdsHourlyMetricsApiV1IntegrationsMetaAdsHourlyMetricsGetData,
  GetMetaAdsHourlyMetricsApiV1IntegrationsMetaAdsHourlyMetricsGetErrors,
  GetMetaAdsHourlyMetricsApiV1IntegrationsMetaAdsHourlyMetricsGetResponses,
  GetMetaAdsInstagramKpiApiV1MetaAdsInstagramKpiGetData,
  GetMetaAdsInstagramKpiApiV1MetaAdsInstagramKpiGetErrors,
  GetMetaAdsInstagramKpiApiV1MetaAdsInstagramKpiGetResponses,
  GetMetaAdsInstagramTimeseriesApiV1MetaAdsInstagramTimeseriesGetData,
  GetMetaAdsInstagramTimeseriesApiV1MetaAdsInstagramTimeseriesGetErrors,
  GetMetaAdsInstagramTimeseriesApiV1MetaAdsInstagramTimeseriesGetResponses,
  GetMetaAdsManagerTotalApiV1MetaAdsManagerTotalGetData,
  GetMetaAdsManagerTotalApiV1MetaAdsManagerTotalGetErrors,
  GetMetaAdsManagerTotalApiV1MetaAdsManagerTotalGetResponses,
  GetMetaAdsPlatformMetricsApiV1IntegrationsMetaAdsPlatformMetricsGetData,
  GetMetaAdsPlatformMetricsApiV1IntegrationsMetaAdsPlatformMetricsGetErrors,
  GetMetaAdsPlatformMetricsApiV1IntegrationsMetaAdsPlatformMetricsGetResponses,
  GetMetricsApiV1IntegrationsMetaAdsMetricsGetData,
  GetMetricsApiV1IntegrationsMetaAdsMetricsGetErrors,
  GetMetricsApiV1IntegrationsMetaAdsMetricsGetResponses,
  GetMetricsApiV1IntegrationsSearchConsoleMetricsGetData,
  GetMetricsApiV1IntegrationsSearchConsoleMetricsGetErrors,
  GetMetricsApiV1IntegrationsSearchConsoleMetricsGetResponses,
  GetModuleDetailsApiV1AdminCoursesModulesModuleIdGetData,
  GetModuleDetailsApiV1AdminCoursesModulesModuleIdGetErrors,
  GetModuleDetailsApiV1AdminCoursesModulesModuleIdGetResponses,
  GetMyPlanFeaturesApiV1PlansMyPlanFeaturesGetData,
  GetMyPlanFeaturesApiV1PlansMyPlanFeaturesGetErrors,
  GetMyPlanFeaturesApiV1PlansMyPlanFeaturesGetResponses,
  GetMyProfileApiV1UsersMeGetData,
  GetMyProfileApiV1UsersMeGetErrors,
  GetMyProfileApiV1UsersMeGetResponses,
  GetMySessionsApiV1UsersMeSessionsGetData,
  GetMySessionsApiV1UsersMeSessionsGetErrors,
  GetMySessionsApiV1UsersMeSessionsGetResponses,
  GetNewSubscribersChartApiV1AdminSubscribersChartsNewSubscribersGetData,
  GetNewSubscribersChartApiV1AdminSubscribersChartsNewSubscribersGetErrors,
  GetNewSubscribersChartApiV1AdminSubscribersChartsNewSubscribersGetResponses,
  GetOauthAuthUrlApiV1OauthAuthUrlGetData,
  GetOauthAuthUrlApiV1OauthAuthUrlGetErrors,
  GetOauthAuthUrlApiV1OauthAuthUrlGetResponses,
  GetPagesSourceMediumApiV1PagesSourceMediumGetData,
  GetPagesSourceMediumApiV1PagesSourceMediumGetErrors,
  GetPagesSourceMediumApiV1PagesSourceMediumGetResponses,
  GetParticipationReportApiV1BenchmarkParticipationReportPostData,
  GetParticipationReportApiV1BenchmarkParticipationReportPostErrors,
  GetParticipationReportApiV1BenchmarkParticipationReportPostResponses,
  GetPaymentStatusApiV1MyAccountPaymentStatusGatewayPaymentIdGetData,
  GetPaymentStatusApiV1MyAccountPaymentStatusGatewayPaymentIdGetErrors,
  GetPaymentStatusApiV1MyAccountPaymentStatusGatewayPaymentIdGetResponses,
  GetPerformanceInsightsApiV1IntegrationsGoogleAnalyticsPerformanceInsightsGetData,
  GetPerformanceInsightsApiV1IntegrationsGoogleAnalyticsPerformanceInsightsGetErrors,
  GetPerformanceInsightsApiV1IntegrationsGoogleAnalyticsPerformanceInsightsGetResponses,
  GetPerformanceInsightsApiV1IntegrationsInstagramInsightsPerformanceInsightsGetData,
  GetPerformanceInsightsApiV1IntegrationsInstagramInsightsPerformanceInsightsGetErrors,
  GetPerformanceInsightsApiV1IntegrationsInstagramInsightsPerformanceInsightsGetResponses,
  GetPerformanceInsightsApiV1IntegrationsMetaAdsPerformanceInsightsGetData,
  GetPerformanceInsightsApiV1IntegrationsMetaAdsPerformanceInsightsGetErrors,
  GetPerformanceInsightsApiV1IntegrationsMetaAdsPerformanceInsightsGetResponses,
  GetPerformanceInsightsApiV1IntegrationsSearchConsolePerformanceInsightsGetData,
  GetPerformanceInsightsApiV1IntegrationsSearchConsolePerformanceInsightsGetErrors,
  GetPerformanceInsightsApiV1IntegrationsSearchConsolePerformanceInsightsGetResponses,
  GetPlacementApiV1IntegrationsMetaAdsPlacementGetData,
  GetPlacementApiV1IntegrationsMetaAdsPlacementGetErrors,
  GetPlacementApiV1IntegrationsMetaAdsPlacementGetResponses,
  GetPlanDetailsApiV1AdminPlansPlanIdGetData,
  GetPlanDetailsApiV1AdminPlansPlanIdGetErrors,
  GetPlanDetailsApiV1AdminPlansPlanIdGetResponses,
  GetPlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesGetData,
  GetPlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesGetErrors,
  GetPlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesGetResponses,
  GetPostsMetricsApiV1IntegrationsInstagramInsightsPostsGetData,
  GetPostsMetricsApiV1IntegrationsInstagramInsightsPostsGetErrors,
  GetPostsMetricsApiV1IntegrationsInstagramInsightsPostsGetResponses,
  GetProductsCardsApiV1ProductsCardsGetData,
  GetProductsCardsApiV1ProductsCardsGetErrors,
  GetProductsCardsApiV1ProductsCardsGetResponses,
  GetProductsDashboardFullApiV1ProductsDashboardGetData,
  GetProductsDashboardFullApiV1ProductsDashboardGetErrors,
  GetProductsDashboardFullApiV1ProductsDashboardGetResponses,
  GetProductsGeneralItemPerformanceApiV1ProductsGeneralItemPerformanceGetData,
  GetProductsGeneralItemPerformanceApiV1ProductsGeneralItemPerformanceGetErrors,
  GetProductsGeneralItemPerformanceApiV1ProductsGeneralItemPerformanceGetResponses,
  GetProductsRevenueTrendApiV1ProductsRevenueTrendGetData,
  GetProductsRevenueTrendApiV1ProductsRevenueTrendGetErrors,
  GetProductsRevenueTrendApiV1ProductsRevenueTrendGetResponses,
  GetProductsTopCategoriesRevenueTrendApiV1ProductsTopCategoriesRevenueTrendGetData,
  GetProductsTopCategoriesRevenueTrendApiV1ProductsTopCategoriesRevenueTrendGetErrors,
  GetProductsTopCategoriesRevenueTrendApiV1ProductsTopCategoriesRevenueTrendGetResponses,
  GetQuarterlyRevenueByPlanApiV1AdminBillingChartsQuarterlyByPlanGetData,
  GetQuarterlyRevenueByPlanApiV1AdminBillingChartsQuarterlyByPlanGetErrors,
  GetQuarterlyRevenueByPlanApiV1AdminBillingChartsQuarterlyByPlanGetResponses,
  GetRecentActivitiesApiV1AdminDashboardActivitiesGetData,
  GetRecentActivitiesApiV1AdminDashboardActivitiesGetErrors,
  GetRecentActivitiesApiV1AdminDashboardActivitiesGetResponses,
  GetRecentAlertsApiV1AdminDashboardAlertsGetData,
  GetRecentAlertsApiV1AdminDashboardAlertsGetErrors,
  GetRecentAlertsApiV1AdminDashboardAlertsGetResponses,
  GetReelsMetricsApiV1IntegrationsInstagramInsightsReelsGetData,
  GetReelsMetricsApiV1IntegrationsInstagramInsightsReelsGetErrors,
  GetReelsMetricsApiV1IntegrationsInstagramInsightsReelsGetResponses,
  GetRegionsProductsByCityApiV1RegionsProductsByCityGetData,
  GetRegionsProductsByCityApiV1RegionsProductsByCityGetErrors,
  GetRegionsProductsByCityApiV1RegionsProductsByCityGetResponses,
  GetRegionsSalesApiV1RegionsSalesGetData,
  GetRegionsSalesApiV1RegionsSalesGetErrors,
  GetRegionsSalesApiV1RegionsSalesGetResponses,
  GetRegionsSalesByCityApiV1RegionsSalesByCityGetData,
  GetRegionsSalesByCityApiV1RegionsSalesByCityGetErrors,
  GetRegionsSalesByCityApiV1RegionsSalesByCityGetResponses,
  GetRegionsSalesByStateApiV1RegionsSalesByStateGetData,
  GetRegionsSalesByStateApiV1RegionsSalesByStateGetErrors,
  GetRegionsSalesByStateApiV1RegionsSalesByStateGetResponses,
  GetRegionsSalesOverviewApiV1RegionsSalesOverviewGetData,
  GetRegionsSalesOverviewApiV1RegionsSalesOverviewGetErrors,
  GetRegionsSalesOverviewApiV1RegionsSalesOverviewGetResponses,
  GetRevenueDashboardApiV1RevenueDashboardGetData,
  GetRevenueDashboardApiV1RevenueDashboardGetErrors,
  GetRevenueDashboardApiV1RevenueDashboardGetResponses,
  GetRevenueEvolutionByPlanApiV1AdminBillingChartsRevenueEvolutionGetData,
  GetRevenueEvolutionByPlanApiV1AdminBillingChartsRevenueEvolutionGetErrors,
  GetRevenueEvolutionByPlanApiV1AdminBillingChartsRevenueEvolutionGetResponses,
  GetRevenueMetricsApiV1AdminDashboardRevenueGetData,
  GetRevenueMetricsApiV1AdminDashboardRevenueGetErrors,
  GetRevenueMetricsApiV1AdminDashboardRevenueGetResponses,
  GetRichResultsApiV1IntegrationsSearchConsoleRichResultsGetData,
  GetRichResultsApiV1IntegrationsSearchConsoleRichResultsGetErrors,
  GetRichResultsApiV1IntegrationsSearchConsoleRichResultsGetResponses,
  GetSalesByChannelApiV1SalesByChannelGetData,
  GetSalesByChannelApiV1SalesByChannelGetErrors,
  GetSalesByChannelApiV1SalesByChannelGetResponses,
  GetSalesByDeviceApiV1SalesByDeviceGetData,
  GetSalesByDeviceApiV1SalesByDeviceGetErrors,
  GetSalesByDeviceApiV1SalesByDeviceGetResponses,
  GetSalesByGeographyApiV1SalesByGeographyGetData,
  GetSalesByGeographyApiV1SalesByGeographyGetErrors,
  GetSalesByGeographyApiV1SalesByGeographyGetResponses,
  GetSalesFunnelApiV1SalesFunnelCardGetData,
  GetSalesFunnelApiV1SalesFunnelCardGetErrors,
  GetSalesFunnelApiV1SalesFunnelCardGetResponses,
  GetSalesMetricsApiV1SalesMetricsGetData,
  GetSalesMetricsApiV1SalesMetricsGetErrors,
  GetSalesMetricsApiV1SalesMetricsGetResponses,
  GetSalesOverviewApiV1SalesOverviewGetData,
  GetSalesOverviewApiV1SalesOverviewGetErrors,
  GetSalesOverviewApiV1SalesOverviewGetResponses,
  GetSalesTrendsApiV1SalesTrendsGetData,
  GetSalesTrendsApiV1SalesTrendsGetErrors,
  GetSalesTrendsApiV1SalesTrendsGetResponses,
  GetSearchConsoleAuthUrlApiV1IntegrationsNexusSearchConsoleAuthUrlGetData,
  GetSearchConsoleAuthUrlApiV1IntegrationsNexusSearchConsoleAuthUrlGetErrors,
  GetSearchConsoleAuthUrlApiV1IntegrationsNexusSearchConsoleAuthUrlGetResponses,
  GetSegmentsApiV1BenchmarkSegmentsGetData,
  GetSegmentsApiV1BenchmarkSegmentsGetErrors,
  GetSegmentsApiV1BenchmarkSegmentsGetResponses,
  GetSelectedAccountsApiV1ExternalAccountsSelectedGetData,
  GetSelectedAccountsApiV1ExternalAccountsSelectedGetErrors,
  GetSelectedAccountsApiV1ExternalAccountsSelectedGetResponses,
  GetSeoCardsDataApiV1SeoCardsGetData,
  GetSeoCardsDataApiV1SeoCardsGetErrors,
  GetSeoCardsDataApiV1SeoCardsGetResponses,
  GetSeoDevicesApiV1SeoDevicesGetData,
  GetSeoDevicesApiV1SeoDevicesGetErrors,
  GetSeoDevicesApiV1SeoDevicesGetResponses,
  GetSettingsApiV1AdminSettingsGet2Data,
  GetSettingsApiV1AdminSettingsGet2Errors,
  GetSettingsApiV1AdminSettingsGet2Responses,
  GetSettingsApiV1AdminSettingsGetData,
  GetSettingsApiV1AdminSettingsGetErrors,
  GetSettingsApiV1AdminSettingsGetResponses,
  GetSourceAnalysisCardApiV1SourceAnalysisCardGetData,
  GetSourceAnalysisCardApiV1SourceAnalysisCardGetErrors,
  GetSourceAnalysisCardApiV1SourceAnalysisCardGetResponses,
  GetStatusApiV1IntegrationsInstagramInsightsStatusGetData,
  GetStatusApiV1IntegrationsInstagramInsightsStatusGetErrors,
  GetStatusApiV1IntegrationsInstagramInsightsStatusGetResponses,
  GetStatusApiV1IntegrationsSearchConsoleStatusGetData,
  GetStatusApiV1IntegrationsSearchConsoleStatusGetErrors,
  GetStatusApiV1IntegrationsSearchConsoleStatusGetResponses,
  GetStorageUsageApiV1StorageUsageGetData,
  GetStorageUsageApiV1StorageUsageGetErrors,
  GetStorageUsageApiV1StorageUsageGetResponses,
  GetStoriesMetricsApiV1IntegrationsInstagramInsightsStoriesGetData,
  GetStoriesMetricsApiV1IntegrationsInstagramInsightsStoriesGetErrors,
  GetStoriesMetricsApiV1IntegrationsInstagramInsightsStoriesGetResponses,
  GetStudentsProgressApiV1AdminCoursesCourseIdStudentsGetData,
  GetStudentsProgressApiV1AdminCoursesCourseIdStudentsGetErrors,
  GetStudentsProgressApiV1AdminCoursesCourseIdStudentsGetResponses,
  GetSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGetData,
  GetSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGetErrors,
  GetSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGetResponses,
  GetSubscriberDetailsApiV1AdminSubscribersSubscriberIdGetData,
  GetSubscriberDetailsApiV1AdminSubscribersSubscriberIdGetErrors,
  GetSubscriberDetailsApiV1AdminSubscribersSubscriberIdGetResponses,
  GetSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGetData,
  GetSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGetErrors,
  GetSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGetResponses,
  GetSubscribersDistributionByPlanApiV1AdminSubscribersChartsDistributionByPlanGetData,
  GetSubscribersDistributionByPlanApiV1AdminSubscribersChartsDistributionByPlanGetErrors,
  GetSubscribersDistributionByPlanApiV1AdminSubscribersChartsDistributionByPlanGetResponses,
  GetSubscribersSummaryApiV1AdminSubscribersSummaryGetData,
  GetSubscribersSummaryApiV1AdminSubscribersSummaryGetErrors,
  GetSubscribersSummaryApiV1AdminSubscribersSummaryGetResponses,
  GetSubscriptionDistributionApiV1AdminDashboardSubscriptionsDistributionGetData,
  GetSubscriptionDistributionApiV1AdminDashboardSubscriptionsDistributionGetErrors,
  GetSubscriptionDistributionApiV1AdminDashboardSubscriptionsDistributionGetResponses,
  GetSubscriptionInfoApiV1MyAccountSubscriptionGetData,
  GetSubscriptionInfoApiV1MyAccountSubscriptionGetErrors,
  GetSubscriptionInfoApiV1MyAccountSubscriptionGetResponses,
  GetSubscriptionMetricsApiV1AdminDashboardSubscriptionsGetData,
  GetSubscriptionMetricsApiV1AdminDashboardSubscriptionsGetErrors,
  GetSubscriptionMetricsApiV1AdminDashboardSubscriptionsGetResponses,
  GetSyncHealthApiV1AdminSyncHealthGetData,
  GetSyncHealthApiV1AdminSyncHealthGetErrors,
  GetSyncHealthApiV1AdminSyncHealthGetResponses,
  GetSyncJobStatusApiV1SyncJobIdGetData,
  GetSyncJobStatusApiV1SyncJobIdGetErrors,
  GetSyncJobStatusApiV1SyncJobIdGetResponses,
  GetSyncStatsApiV1AdminSyncStatsGetData,
  GetSyncStatsApiV1AdminSyncStatsGetErrors,
  GetSyncStatsApiV1AdminSyncStatsGetResponses,
  GetSyncStatusApiV1AdminSyncStatusGetData,
  GetSyncStatusApiV1AdminSyncStatusGetErrors,
  GetSyncStatusApiV1AdminSyncStatusGetResponses,
  GetSystemHealthApiV1AdminDashboardHealthGetData,
  GetSystemHealthApiV1AdminDashboardHealthGetErrors,
  GetSystemHealthApiV1AdminDashboardHealthGetResponses,
  GetTestDataApiV1IntegrationsMetaAdsTestDataGetData,
  GetTestDataApiV1IntegrationsMetaAdsTestDataGetErrors,
  GetTestDataApiV1IntegrationsMetaAdsTestDataGetResponses,
  GetTopCategorySalesApiV1TopCategorySalesGetData,
  GetTopCategorySalesApiV1TopCategorySalesGetErrors,
  GetTopCategorySalesApiV1TopCategorySalesGetResponses,
  GetTopCoursesApiV1AdminCoursesChartsTopCoursesGetData,
  GetTopCoursesApiV1AdminCoursesChartsTopCoursesGetErrors,
  GetTopCoursesApiV1AdminCoursesChartsTopCoursesGetResponses,
  GetTopPagesApiV1IntegrationsSearchConsoleTopPagesGetData,
  GetTopPagesApiV1IntegrationsSearchConsoleTopPagesGetErrors,
  GetTopPagesApiV1IntegrationsSearchConsoleTopPagesGetResponses,
  GetTopPlansApiV1AdminDashboardTopPlansGetData,
  GetTopPlansApiV1AdminDashboardTopPlansGetErrors,
  GetTopPlansApiV1AdminDashboardTopPlansGetResponses,
  GetTopPostsApiV1IntegrationsInstagramInsightsTopPostsGetData,
  GetTopPostsApiV1IntegrationsInstagramInsightsTopPostsGetErrors,
  GetTopPostsApiV1IntegrationsInstagramInsightsTopPostsGetResponses,
  GetTopQueriesApiV1IntegrationsSearchConsoleTopQueriesGetData,
  GetTopQueriesApiV1IntegrationsSearchConsoleTopQueriesGetErrors,
  GetTopQueriesApiV1IntegrationsSearchConsoleTopQueriesGetResponses,
  GetTopSellingProductsApiV1TopSellingProductsGetData,
  GetTopSellingProductsApiV1TopSellingProductsGetErrors,
  GetTopSellingProductsApiV1TopSellingProductsGetResponses,
  GetTransactionDetailsApiV1AdminBillingTransactionsTransactionIdGetData,
  GetTransactionDetailsApiV1AdminBillingTransactionsTransactionIdGetErrors,
  GetTransactionDetailsApiV1AdminBillingTransactionsTransactionIdGetResponses,
  GetUpdateQueueApiV1BenchmarkUpdateQueuePostData,
  GetUpdateQueueApiV1BenchmarkUpdateQueuePostErrors,
  GetUpdateQueueApiV1BenchmarkUpdateQueuePostResponses,
  GetUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGetData,
  GetUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGetErrors,
  GetUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGetResponses,
  GetUserConnectionsApiV1UsersMeConnectionsGetData,
  GetUserConnectionsApiV1UsersMeConnectionsGetErrors,
  GetUserConnectionsApiV1UsersMeConnectionsGetResponses,
  GetUserIntegrationsApiV1UsersMeIntegrationsGetData,
  GetUserIntegrationsApiV1UsersMeIntegrationsGetErrors,
  GetUserIntegrationsApiV1UsersMeIntegrationsGetResponses,
  GetUserMetricsApiV1AdminDashboardUsersGetData,
  GetUserMetricsApiV1AdminDashboardUsersGetErrors,
  GetUserMetricsApiV1AdminDashboardUsersGetResponses,
  GetUtmAdContentApiV1UtmAdContentGetData,
  GetUtmAdContentApiV1UtmAdContentGetErrors,
  GetUtmAdContentApiV1UtmAdContentGetResponses,
  GetUtmCampaignsApiV1UtmCampaignsGetData,
  GetUtmCampaignsApiV1UtmCampaignsGetErrors,
  GetUtmCampaignsApiV1UtmCampaignsGetResponses,
  GetUtmCardsApiV1UtmCardsGetData,
  GetUtmCardsApiV1UtmCardsGetErrors,
  GetUtmCardsApiV1UtmCardsGetResponses,
  GetUtmMediumApiV1UtmMediumGetData,
  GetUtmMediumApiV1UtmMediumGetErrors,
  GetUtmMediumApiV1UtmMediumGetResponses,
  GetUtmSessionSourceApiV1UtmSessionSourceGetData,
  GetUtmSessionSourceApiV1UtmSessionSourceGetErrors,
  GetUtmSessionSourceApiV1UtmSessionSourceGetResponses,
  GoogleAdsOauthCallbackApiV1IntegrationsGoogleAdsCallbackGetData,
  GoogleAdsOauthCallbackApiV1IntegrationsGoogleAdsCallbackGetErrors,
  GoogleAnalyticsOauthCallbackApiV1IntegrationsGoogleAnalyticsCallbackGetData,
  GoogleAnalyticsOauthCallbackApiV1IntegrationsGoogleAnalyticsCallbackGetErrors,
  HardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDeleteData,
  HardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDeleteErrors,
  HardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDeleteResponses,
  HealthCheckHealthGetData,
  HealthCheckHealthGetErrors,
  HealthCheckHealthGetResponses,
  InactivateCouponApiV1AdminCouponsCouponIdInactivatePostData,
  InactivateCouponApiV1AdminCouponsCouponIdInactivatePostErrors,
  InactivateCouponApiV1AdminCouponsCouponIdInactivatePostResponses,
  InitiateUpgradeApiV1SubscriptionsUpgradePostData,
  InitiateUpgradeApiV1SubscriptionsUpgradePostErrors,
  InitiateUpgradeApiV1SubscriptionsUpgradePostResponses,
  IntegrationOauthCallbackApiV1IntegrationsNexusCallbackGetData,
  IntegrationOauthCallbackApiV1IntegrationsNexusCallbackGetErrors,
  ListAccountsApiV1AccountsGetData,
  ListAccountsApiV1AccountsGetErrors,
  ListAccountsApiV1AccountsGetResponses,
  ListAccountUsersApiV1MyAccountUsersGetData,
  ListAccountUsersApiV1MyAccountUsersGetErrors,
  ListAccountUsersApiV1MyAccountUsersGetResponses,
  ListAdminUsersApiV1AdminAdminUsersGet2Data,
  ListAdminUsersApiV1AdminAdminUsersGet2Errors,
  ListAdminUsersApiV1AdminAdminUsersGet2Responses,
  ListAdminUsersApiV1AdminAdminUsersGetData,
  ListAdminUsersApiV1AdminAdminUsersGetErrors,
  ListAdminUsersApiV1AdminAdminUsersGetResponses,
  ListAnalysesApiV1DiagnosticAnalysesGetData,
  ListAnalysesApiV1DiagnosticAnalysesGetErrors,
  ListAnalysesApiV1DiagnosticAnalysesGetResponses,
  ListCategoriesApiV1AdminFeaturesCategoriesGetData,
  ListCategoriesApiV1AdminFeaturesCategoriesGetErrors,
  ListCategoriesApiV1AdminFeaturesCategoriesGetResponses,
  ListConversationsApiV1MediaChatConversationsGetData,
  ListConversationsApiV1MediaChatConversationsGetErrors,
  ListConversationsApiV1MediaChatConversationsGetResponses,
  ListCouponsApiV1AdminBillingCouponsGetData,
  ListCouponsApiV1AdminBillingCouponsGetErrors,
  ListCouponsApiV1AdminBillingCouponsGetResponses,
  ListCouponsApiV1AdminCouponsGet2Data,
  ListCouponsApiV1AdminCouponsGet2Errors,
  ListCouponsApiV1AdminCouponsGet2Responses,
  ListCouponsApiV1AdminCouponsGetData,
  ListCouponsApiV1AdminCouponsGetErrors,
  ListCouponsApiV1AdminCouponsGetResponses,
  ListCoursesApiV1AdminCoursesGet2Data,
  ListCoursesApiV1AdminCoursesGet2Errors,
  ListCoursesApiV1AdminCoursesGet2Responses,
  ListCoursesApiV1AdminCoursesGetData,
  ListCoursesApiV1AdminCoursesGetErrors,
  ListCoursesApiV1AdminCoursesGetResponses,
  ListDataDeletionRequestsApiV1AdminDataDeletionGet2Data,
  ListDataDeletionRequestsApiV1AdminDataDeletionGet2Errors,
  ListDataDeletionRequestsApiV1AdminDataDeletionGet2Responses,
  ListDataDeletionRequestsApiV1AdminDataDeletionGetData,
  ListDataDeletionRequestsApiV1AdminDataDeletionGetErrors,
  ListDataDeletionRequestsApiV1AdminDataDeletionGetResponses,
  ListFeaturesApiV1AdminFeaturesGet2Data,
  ListFeaturesApiV1AdminFeaturesGet2Errors,
  ListFeaturesApiV1AdminFeaturesGet2Responses,
  ListFeaturesApiV1AdminFeaturesGetData,
  ListFeaturesApiV1AdminFeaturesGetErrors,
  ListFeaturesApiV1AdminFeaturesGetResponses,
  ListHardDeletesApiV1AdminSubscribersHardDeletesGetData,
  ListHardDeletesApiV1AdminSubscribersHardDeletesGetErrors,
  ListHardDeletesApiV1AdminSubscribersHardDeletesGetResponses,
  ListInvoicesApiV1AdminBillingInvoicesGetData,
  ListInvoicesApiV1AdminBillingInvoicesGetErrors,
  ListInvoicesApiV1AdminBillingInvoicesGetResponses,
  ListInvoicesApiV1MyAccountInvoicesGetData,
  ListInvoicesApiV1MyAccountInvoicesGetErrors,
  ListInvoicesApiV1MyAccountInvoicesGetResponses,
  ListLessonMediaApiV1AdminCoursesLessonsLessonIdMediaGetData,
  ListLessonMediaApiV1AdminCoursesLessonsLessonIdMediaGetErrors,
  ListLessonMediaApiV1AdminCoursesLessonsLessonIdMediaGetResponses,
  ListPlansApiV1AdminPlansGet2Data,
  ListPlansApiV1AdminPlansGet2Errors,
  ListPlansApiV1AdminPlansGet2Responses,
  ListPlansApiV1AdminPlansGetData,
  ListPlansApiV1AdminPlansGetErrors,
  ListPlansApiV1AdminPlansGetResponses,
  ListProfilesApiV1AdminAdminUsersProfilesGetData,
  ListProfilesApiV1AdminAdminUsersProfilesGetErrors,
  ListProfilesApiV1AdminAdminUsersProfilesGetResponses,
  ListPublicPlansApiV1PublicPlansGetData,
  ListPublicPlansApiV1PublicPlansGetErrors,
  ListPublicPlansApiV1PublicPlansGetResponses,
  ListSegmentsApiV1AdminBenchmarkSegmentsGetData,
  ListSegmentsApiV1AdminBenchmarkSegmentsGetErrors,
  ListSegmentsApiV1AdminBenchmarkSegmentsGetResponses,
  ListSegmentsApiV1SegmentsGetData,
  ListSegmentsApiV1SegmentsGetErrors,
  ListSegmentsApiV1SegmentsGetResponses,
  ListSubscribersApiV1AdminSubscribersGet2Data,
  ListSubscribersApiV1AdminSubscribersGet2Errors,
  ListSubscribersApiV1AdminSubscribersGet2Responses,
  ListSubscribersApiV1AdminSubscribersGetData,
  ListSubscribersApiV1AdminSubscribersGetErrors,
  ListSubscribersApiV1AdminSubscribersGetResponses,
  ListTransactionsApiV1AdminBillingTransactionsGetData,
  ListTransactionsApiV1AdminBillingTransactionsGetErrors,
  ListTransactionsApiV1AdminBillingTransactionsGetResponses,
  LoginApiV1AuthLoginPostData,
  LoginApiV1AuthLoginPostErrors,
  LoginApiV1AuthLoginPostResponses,
  LogoutApiV1AuthLogoutPostData,
  LogoutApiV1AuthLogoutPostErrors,
  LogoutApiV1AuthLogoutPostResponses,
  MarkAlertAsReadApiV1AdminBillingAlertsAlertIdReadPutData,
  MarkAlertAsReadApiV1AdminBillingAlertsAlertIdReadPutErrors,
  MarkAlertAsReadApiV1AdminBillingAlertsAlertIdReadPutResponses,
  OauthCallbackApiV1IntegrationsInstagramInsightsCallbackGetData,
  OauthCallbackApiV1IntegrationsInstagramInsightsCallbackGetErrors,
  OauthCallbackApiV1IntegrationsInstagramInsightsCallbackGetResponses,
  OauthCallbackApiV1IntegrationsMetaAdsCallbackGetData,
  OauthCallbackApiV1IntegrationsMetaAdsCallbackGetErrors,
  OauthCallbackApiV1IntegrationsMetaAdsCallbackGetResponses,
  OauthCallbackApiV1IntegrationsSearchConsoleCallbackGetData,
  OauthCallbackApiV1IntegrationsSearchConsoleCallbackGetErrors,
  OauthCallbackApiV1IntegrationsSearchConsoleCallbackGetResponses,
  OauthCallbackProxyApiV1OauthCallbackGetData,
  OauthCallbackProxyApiV1OauthCallbackGetErrors,
  ProcessRefundApiV1AdminBillingPaymentsPaymentIdRefundPostData,
  ProcessRefundApiV1AdminBillingPaymentsPaymentIdRefundPostErrors,
  ProcessRefundApiV1AdminBillingPaymentsPaymentIdRefundPostResponses,
  ProxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGetData,
  ProxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGetErrors,
  ProxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGetResponses,
  ProxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGetData,
  ProxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGetErrors,
  ProxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGetResponses,
  ProxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGetData,
  ProxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGetErrors,
  ProxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGetResponses,
  ProxyRegionsCategoriesApiV1RegionsDashboardCategoriesGetData,
  ProxyRegionsCategoriesApiV1RegionsDashboardCategoriesGetErrors,
  ProxyRegionsCategoriesApiV1RegionsDashboardCategoriesGetResponses,
  ProxyRegionsCategoryMatrixApiV1RegionsDashboardCategoryMatrixGetData,
  ProxyRegionsCategoryMatrixApiV1RegionsDashboardCategoryMatrixGetErrors,
  ProxyRegionsCategoryMatrixApiV1RegionsDashboardCategoryMatrixGetResponses,
  ProxyRegionsCitiesApiV1RegionsDashboardCitiesGetData,
  ProxyRegionsCitiesApiV1RegionsDashboardCitiesGetErrors,
  ProxyRegionsCitiesApiV1RegionsDashboardCitiesGetResponses,
  ProxyRegionsItemsApiV1RegionsDashboardItemsGetData,
  ProxyRegionsItemsApiV1RegionsDashboardItemsGetErrors,
  ProxyRegionsItemsApiV1RegionsDashboardItemsGetResponses,
  ProxyRegionsStatesApiV1RegionsDashboardStatesGetData,
  ProxyRegionsStatesApiV1RegionsDashboardStatesGetErrors,
  ProxyRegionsStatesApiV1RegionsDashboardStatesGetResponses,
  ProxyRegionsSummaryApiV1RegionsDashboardSummaryGetData,
  ProxyRegionsSummaryApiV1RegionsDashboardSummaryGetErrors,
  ProxyRegionsSummaryApiV1RegionsDashboardSummaryGetResponses,
  ReactivateAdminUserApiV1AdminAdminUsersAdminUserIdReactivatePostData,
  ReactivateAdminUserApiV1AdminAdminUsersAdminUserIdReactivatePostErrors,
  ReactivateAdminUserApiV1AdminAdminUsersAdminUserIdReactivatePostResponses,
  ReactivatePlanApiV1AdminPlansPlanIdReactivatePostData,
  ReactivatePlanApiV1AdminPlansPlanIdReactivatePostErrors,
  ReactivatePlanApiV1AdminPlansPlanIdReactivatePostResponses,
  ReactivateSubscriberApiV1AdminSubscribersSubscriberIdReactivatePostData,
  ReactivateSubscriberApiV1AdminSubscribersSubscriberIdReactivatePostErrors,
  ReactivateSubscriberApiV1AdminSubscribersSubscriberIdReactivatePostResponses,
  ReadinessCheckReadyGetData,
  ReadinessCheckReadyGetErrors,
  ReadinessCheckReadyGetResponses,
  ReadRetentionStatusApiV1SubscriptionsRetentionStatusGetData,
  ReadRetentionStatusApiV1SubscriptionsRetentionStatusGetErrors,
  ReadRetentionStatusApiV1SubscriptionsRetentionStatusGetResponses,
  ReceiveAsaasWebhookApiV1WebhooksAsaasPostData,
  ReceiveAsaasWebhookApiV1WebhooksAsaasPostErrors,
  ReceiveAsaasWebhookApiV1WebhooksAsaasPostResponses,
  RefreshIntegrationTokenApiV1IntegrationsNexusRefreshTokenPostData,
  RefreshIntegrationTokenApiV1IntegrationsNexusRefreshTokenPostErrors,
  RefreshIntegrationTokenApiV1IntegrationsNexusRefreshTokenPostResponses,
  RefreshOauthTokenApiV1OauthRefreshPostData,
  RefreshOauthTokenApiV1OauthRefreshPostErrors,
  RefreshOauthTokenApiV1OauthRefreshPostResponses,
  RefreshTokenApiV1AdminAuthRefreshPostData,
  RefreshTokenApiV1AdminAuthRefreshPostErrors,
  RefreshTokenApiV1AdminAuthRefreshPostResponses,
  RefreshTokenApiV1AuthRefreshPostData,
  RefreshTokenApiV1AuthRefreshPostErrors,
  RefreshTokenApiV1AuthRefreshPostResponses,
  RegisterApiV1AuthRegisterPostData,
  RegisterApiV1AuthRegisterPostErrors,
  RegisterApiV1AuthRegisterPostResponses,
  RegisterPaymentApiV1AdminBillingPaymentsPostData,
  RegisterPaymentApiV1AdminBillingPaymentsPostErrors,
  RegisterPaymentApiV1AdminBillingPaymentsPostResponses,
  RenameConversationApiV1MediaChatConversationsConversationIdPatchData,
  RenameConversationApiV1MediaChatConversationsConversationIdPatchErrors,
  RenameConversationApiV1MediaChatConversationsConversationIdPatchResponses,
  ReorderLessonsApiV1AdminCoursesLessonsReorderPostData,
  ReorderLessonsApiV1AdminCoursesLessonsReorderPostErrors,
  ReorderLessonsApiV1AdminCoursesLessonsReorderPostResponses,
  ReorderMediaApiV1AdminCoursesMediaReorderPostData,
  ReorderMediaApiV1AdminCoursesMediaReorderPostErrors,
  ReorderMediaApiV1AdminCoursesMediaReorderPostResponses,
  ReorderModulesApiV1AdminCoursesModulesReorderPostData,
  ReorderModulesApiV1AdminCoursesModulesReorderPostErrors,
  ReorderModulesApiV1AdminCoursesModulesReorderPostResponses,
  RequestDataDeletionApiV1DataDeletionPostData,
  RequestDataDeletionApiV1DataDeletionPostErrors,
  RequestDataDeletionApiV1DataDeletionPostResponses,
  RequestPasswordResetApiV1AdminAuthPasswordResetRequestPostData,
  RequestPasswordResetApiV1AdminAuthPasswordResetRequestPostErrors,
  RequestPasswordResetApiV1AdminAuthPasswordResetRequestPostResponses,
  RequestPasswordResetEndpointApiV1AdminAuthRequestPasswordResetPostData,
  RequestPasswordResetEndpointApiV1AdminAuthRequestPasswordResetPostErrors,
  RequestPasswordResetEndpointApiV1AdminAuthRequestPasswordResetPostResponses,
  RequestPasswordResetNonexistentApiV1AdminAuthPasswordResetRequestNonexistentPostData,
  RequestPasswordResetNonexistentApiV1AdminAuthPasswordResetRequestNonexistentPostErrors,
  RequestPasswordResetNonexistentApiV1AdminAuthPasswordResetRequestNonexistentPostResponses,
  Reset2FaApiV1AdminAuth2FaResetPostData,
  Reset2FaApiV1AdminAuth2FaResetPostErrors,
  Reset2FaApiV1AdminAuth2FaResetPostResponses,
  ResetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPostData,
  ResetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPostErrors,
  ResetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPostResponses,
  ResetPasswordApiV1AdminAdminUsersPasswordResetPostData,
  ResetPasswordApiV1AdminAdminUsersPasswordResetPostErrors,
  ResetPasswordApiV1AdminAdminUsersPasswordResetPostResponses,
  ResetPasswordApiV1AuthResetPasswordPostData,
  ResetPasswordApiV1AuthResetPasswordPostErrors,
  ResetPasswordApiV1AuthResetPasswordPostResponses,
  ResolveConversationApiV1MediaChatConversationGetData,
  ResolveConversationApiV1MediaChatConversationGetErrors,
  ResolveConversationApiV1MediaChatConversationGetResponses,
  RevokeAllSessionsApiV1UsersMeSessionsDeleteData,
  RevokeAllSessionsApiV1UsersMeSessionsDeleteErrors,
  RevokeAllSessionsApiV1UsersMeSessionsDeleteResponses,
  RevokeSessionApiV1UsersMeSessionsSessionIdDeleteData,
  RevokeSessionApiV1UsersMeSessionsSessionIdDeleteErrors,
  RevokeSessionApiV1UsersMeSessionsSessionIdDeleteResponses,
  RevokeSessionsApiV1AdminAdminUsersAdminUserIdSessionsRevokePostData,
  RevokeSessionsApiV1AdminAdminUsersAdminUserIdSessionsRevokePostErrors,
  RevokeSessionsApiV1AdminAdminUsersAdminUserIdSessionsRevokePostResponses,
  RootGetData,
  RootGetErrors,
  RootGetResponses,
  SelectAccountsApiV1ExternalAccountsSelectPostData,
  SelectAccountsApiV1ExternalAccountsSelectPostErrors,
  SelectAccountsApiV1ExternalAccountsSelectPostResponses,
  SetStorageLimitsApiV1AdminStorageLimitsPostData,
  SetStorageLimitsApiV1AdminStorageLimitsPostErrors,
  SetStorageLimitsApiV1AdminStorageLimitsPostResponses,
  Setup2FaApiV1AdminAuth2FaSetupPostData,
  Setup2FaApiV1AdminAuth2FaSetupPostErrors,
  Setup2FaApiV1AdminAuth2FaSetupPostResponses,
  Setup2FaApiV1Auth2FaSetupPostData,
  Setup2FaApiV1Auth2FaSetupPostErrors,
  Setup2FaApiV1Auth2FaSetupPostResponses,
  Setup2FaInitialApiV1AdminAuth2FaSetupInitialPostData,
  Setup2FaInitialApiV1AdminAuth2FaSetupInitialPostErrors,
  Setup2FaInitialApiV1AdminAuth2FaSetupInitialPostResponses,
  SoftDeletePlanApiV1AdminPlansPlanIdDeleteData,
  SoftDeletePlanApiV1AdminPlansPlanIdDeleteErrors,
  SoftDeletePlanApiV1AdminPlansPlanIdDeleteResponses,
  StartConversationApiV1MediaChatConversationsPostData,
  StartConversationApiV1MediaChatConversationsPostErrors,
  StartConversationApiV1MediaChatConversationsPostResponses,
  SuspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPostData,
  SuspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPostErrors,
  SuspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPostResponses,
  SwitchToAccountApiV1AccountsSwitchAccountPostData,
  SwitchToAccountApiV1AccountsSwitchAccountPostErrors,
  SwitchToAccountApiV1AccountsSwitchAccountPostResponses,
  SyncAccountApiV1BenchmarkSyncAccountPostData,
  SyncAccountApiV1BenchmarkSyncAccountPostErrors,
  SyncAccountApiV1BenchmarkSyncAccountPostResponses,
  SyncAdvancedDataApiV1IntegrationsGoogleAnalyticsSyncAdvancedPostData,
  SyncAdvancedDataApiV1IntegrationsGoogleAnalyticsSyncAdvancedPostErrors,
  SyncAdvancedDataApiV1IntegrationsGoogleAnalyticsSyncAdvancedPostResponses,
  SyncAllPropertiesApiV1IntegrationsGoogleAnalyticsSyncAllPostData,
  SyncAllPropertiesApiV1IntegrationsGoogleAnalyticsSyncAllPostErrors,
  SyncAllPropertiesApiV1IntegrationsGoogleAnalyticsSyncAllPostResponses,
  SyncBasicMetricsApiV1IntegrationsInstagramInsightsSyncPostData,
  SyncBasicMetricsApiV1IntegrationsInstagramInsightsSyncPostErrors,
  SyncBasicMetricsApiV1IntegrationsInstagramInsightsSyncPostResponses,
  SyncCompleteDataApiV1IntegrationsGoogleAnalyticsSyncCompletePostData,
  SyncCompleteDataApiV1IntegrationsGoogleAnalyticsSyncCompletePostErrors,
  SyncCompleteDataApiV1IntegrationsGoogleAnalyticsSyncCompletePostResponses,
  SyncCompleteDataApiV1IntegrationsInstagramInsightsSyncCompletePostData,
  SyncCompleteDataApiV1IntegrationsInstagramInsightsSyncCompletePostErrors,
  SyncCompleteDataApiV1IntegrationsInstagramInsightsSyncCompletePostResponses,
  SyncCompleteDataApiV1IntegrationsMetaAdsSyncCompletePostData,
  SyncCompleteDataApiV1IntegrationsMetaAdsSyncCompletePostErrors,
  SyncCompleteDataApiV1IntegrationsMetaAdsSyncCompletePostResponses,
  SyncCompleteDataApiV1IntegrationsSearchConsoleSyncCompletePostData,
  SyncCompleteDataApiV1IntegrationsSearchConsoleSyncCompletePostErrors,
  SyncCompleteDataApiV1IntegrationsSearchConsoleSyncCompletePostResponses,
  SyncCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsSyncCompletePostData,
  SyncCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsSyncCompletePostErrors,
  SyncCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsSyncCompletePostResponses,
  SyncGoogleAdsDataApiV1IntegrationsGoogleAdsSyncPostData,
  SyncGoogleAdsDataApiV1IntegrationsGoogleAdsSyncPostErrors,
  SyncGoogleAdsDataApiV1IntegrationsGoogleAdsSyncPostResponses,
  SyncGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsSyncAccountsPostData,
  SyncGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsSyncAccountsPostErrors,
  SyncGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsSyncAccountsPostResponses,
  SyncGoogleAnalyticsDataApiV1IntegrationsGoogleAnalyticsSyncPostData,
  SyncGoogleAnalyticsDataApiV1IntegrationsGoogleAnalyticsSyncPostErrors,
  SyncGoogleAnalyticsDataApiV1IntegrationsGoogleAnalyticsSyncPostResponses,
  SyncMetricsApiV1IntegrationsMetaAdsSyncPostData,
  SyncMetricsApiV1IntegrationsMetaAdsSyncPostErrors,
  SyncMetricsApiV1IntegrationsMetaAdsSyncPostResponses,
  SyncMetricsApiV1IntegrationsSearchConsoleSyncPostData,
  SyncMetricsApiV1IntegrationsSearchConsoleSyncPostErrors,
  SyncMetricsApiV1IntegrationsSearchConsoleSyncPostResponses,
  TestAccountsApiV1TestAccountsGetData,
  TestAccountsApiV1TestAccountsGetErrors,
  TestAccountsApiV1TestAccountsGetResponses,
  ToggleMaintenanceModeApiV1AdminSettingsMaintenanceModeTogglePostData,
  ToggleMaintenanceModeApiV1AdminSettingsMaintenanceModeTogglePostErrors,
  ToggleMaintenanceModeApiV1AdminSettingsMaintenanceModeTogglePostResponses,
  TriggerSyncApiV1SyncPostData,
  TriggerSyncApiV1SyncPostErrors,
  TriggerSyncApiV1SyncPostResponses,
  UpdateAccountApiV1AccountsAccountIdPutData,
  UpdateAccountApiV1AccountsAccountIdPutErrors,
  UpdateAccountApiV1AccountsAccountIdPutResponses,
  UpdateAccountApiV1BenchmarkUpdateAccountPostData,
  UpdateAccountApiV1BenchmarkUpdateAccountPostErrors,
  UpdateAccountApiV1BenchmarkUpdateAccountPostResponses,
  UpdateAccountStatusApiV1AccountsAccountIdStatusPatchData,
  UpdateAccountStatusApiV1AccountsAccountIdStatusPatchErrors,
  UpdateAccountStatusApiV1AccountsAccountIdStatusPatchResponses,
  UpdateAccountUserApiV1MyAccountUsersAccountUserIdPutData,
  UpdateAccountUserApiV1MyAccountUsersAccountUserIdPutErrors,
  UpdateAccountUserApiV1MyAccountUsersAccountUserIdPutResponses,
  UpdateAdminUserApiV1AdminAdminUsersAdminUserIdPutData,
  UpdateAdminUserApiV1AdminAdminUsersAdminUserIdPutErrors,
  UpdateAdminUserApiV1AdminAdminUsersAdminUserIdPutResponses,
  UpdateCampaignFiltersApiV1CampaignFiltersPutData,
  UpdateCampaignFiltersApiV1CampaignFiltersPutErrors,
  UpdateCampaignFiltersApiV1CampaignFiltersPutResponses,
  UpdateCheckoutDataApiV1AuthCheckoutDataPostData,
  UpdateCheckoutDataApiV1AuthCheckoutDataPostErrors,
  UpdateCheckoutDataApiV1AuthCheckoutDataPostResponses,
  UpdateCouponApiV1AdminBillingCouponsCouponIdPutData,
  UpdateCouponApiV1AdminBillingCouponsCouponIdPutErrors,
  UpdateCouponApiV1AdminBillingCouponsCouponIdPutResponses,
  UpdateCouponApiV1AdminCouponsCouponIdPutData,
  UpdateCouponApiV1AdminCouponsCouponIdPutErrors,
  UpdateCouponApiV1AdminCouponsCouponIdPutResponses,
  UpdateCourseApiV1AdminCoursesCourseIdPutData,
  UpdateCourseApiV1AdminCoursesCourseIdPutErrors,
  UpdateCourseApiV1AdminCoursesCourseIdPutResponses,
  UpdateDailyMetricsApiV1AdminDashboardMetricsUpdatePostData,
  UpdateDailyMetricsApiV1AdminDashboardMetricsUpdatePostErrors,
  UpdateDailyMetricsApiV1AdminDashboardMetricsUpdatePostResponses,
  UpdateFeatureApiV1AdminFeaturesFeatureIdPutData,
  UpdateFeatureApiV1AdminFeaturesFeatureIdPutErrors,
  UpdateFeatureApiV1AdminFeaturesFeatureIdPutResponses,
  UpdateInvoiceApiV1AdminBillingInvoicesInvoiceIdPutData,
  UpdateInvoiceApiV1AdminBillingInvoicesInvoiceIdPutErrors,
  UpdateInvoiceApiV1AdminBillingInvoicesInvoiceIdPutResponses,
  UpdateLessonApiV1AdminCoursesLessonsLessonIdPutData,
  UpdateLessonApiV1AdminCoursesLessonsLessonIdPutErrors,
  UpdateLessonApiV1AdminCoursesLessonsLessonIdPutResponses,
  UpdateLessonMediaApiV1AdminCoursesMediaMediaIdPutData,
  UpdateLessonMediaApiV1AdminCoursesMediaMediaIdPutErrors,
  UpdateLessonMediaApiV1AdminCoursesMediaMediaIdPutResponses,
  UpdateModuleApiV1AdminCoursesModulesModuleIdPutData,
  UpdateModuleApiV1AdminCoursesModulesModuleIdPutErrors,
  UpdateModuleApiV1AdminCoursesModulesModuleIdPutResponses,
  UpdateMyProfileApiV1UsersMePutData,
  UpdateMyProfileApiV1UsersMePutErrors,
  UpdateMyProfileApiV1UsersMePutResponses,
  UpdatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPutData,
  UpdatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPutErrors,
  UpdatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPutResponses,
  UpdatePlanApiV1AdminPlansPlanIdPutData,
  UpdatePlanApiV1AdminPlansPlanIdPutErrors,
  UpdatePlanApiV1AdminPlansPlanIdPutResponses,
  UpdatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPutData,
  UpdatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPutErrors,
  UpdatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPutResponses,
  UpdatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPutData,
  UpdatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPutErrors,
  UpdatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPutResponses,
  UpdateProfileApiV1AdminAdminUsersProfilesProfileIdPutData,
  UpdateProfileApiV1AdminAdminUsersProfilesProfileIdPutErrors,
  UpdateProfileApiV1AdminAdminUsersProfilesProfileIdPutResponses,
  UpdateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPutData,
  UpdateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPutErrors,
  UpdateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPutResponses,
  UpdateSettingsApiV1AdminSettingsPut2Data,
  UpdateSettingsApiV1AdminSettingsPut2Errors,
  UpdateSettingsApiV1AdminSettingsPut2Responses,
  UpdateSettingsApiV1AdminSettingsPutData,
  UpdateSettingsApiV1AdminSettingsPutErrors,
  UpdateSettingsApiV1AdminSettingsPutResponses,
  UpdateSubscriberApiV1AdminSubscribersSubscriberIdPutData,
  UpdateSubscriberApiV1AdminSubscribersSubscriberIdPutErrors,
  UpdateSubscriberApiV1AdminSubscribersSubscriberIdPutResponses,
  UpdateSyncConfigApiV1AdminSyncConfigPutData,
  UpdateSyncConfigApiV1AdminSyncConfigPutErrors,
  UpdateSyncConfigApiV1AdminSyncConfigPutResponses,
  UploadAvatarApiV1UsersMeAvatarPostData,
  UploadAvatarApiV1UsersMeAvatarPostErrors,
  UploadAvatarApiV1UsersMeAvatarPostResponses,
  UploadFileApiV1AdminCoursesUploadPostData,
  UploadFileApiV1AdminCoursesUploadPostErrors,
  UploadFileApiV1AdminCoursesUploadPostResponses,
  UploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostData,
  UploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostErrors,
  UploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostResponses,
  UsageTimeseriesApiV1AdminCouponsUsageTimeseriesGetData,
  UsageTimeseriesApiV1AdminCouponsUsageTimeseriesGetErrors,
  UsageTimeseriesApiV1AdminCouponsUsageTimeseriesGetResponses,
  ValidateCouponApiV1PublicCouponsValidateGetData,
  ValidateCouponApiV1PublicCouponsValidateGetErrors,
  ValidateCouponApiV1PublicCouponsValidateGetResponses,
  Verify2FaApiV1AdminAuth2FaVerifyPostData,
  Verify2FaApiV1AdminAuth2FaVerifyPostErrors,
  Verify2FaApiV1AdminAuth2FaVerifyPostResponses,
  Verify2FaApiV1Auth2FaVerifyPostData,
  Verify2FaApiV1Auth2FaVerifyPostErrors,
  Verify2FaApiV1Auth2FaVerifyPostResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Root
 */
export const rootGet = <ThrowOnError extends boolean = false>(
  options?: Options<RootGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    RootGetResponses,
    RootGetErrors,
    ThrowOnError
  >({ url: "/", ...options });

/**
 * Test Accounts
 */
export const testAccountsApiV1TestAccountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<TestAccountsApiV1TestAccountsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    TestAccountsApiV1TestAccountsGetResponses,
    TestAccountsApiV1TestAccountsGetErrors,
    ThrowOnError
  >({ url: "/api/v1/test-accounts", ...options });

/**
 * Health Check
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckHealthGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    HealthCheckHealthGetResponses,
    HealthCheckHealthGetErrors,
    ThrowOnError
  >({ url: "/health", ...options });

/**
 * Readiness Check
 */
export const readinessCheckReadyGet = <ThrowOnError extends boolean = false>(
  options?: Options<ReadinessCheckReadyGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ReadinessCheckReadyGetResponses,
    ReadinessCheckReadyGetErrors,
    ThrowOnError
  >({ url: "/ready", ...options });

/**
 * Regenerate 2Fa Backup Codes
 */
export const apiV1Auth2FaBackupCodesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1Auth2FaBackupCodesPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApiV1Auth2FaBackupCodesPostResponses,
    ApiV1Auth2FaBackupCodesPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/2fa/backup-codes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Disable 2Fa
 *
 * Disable 2FA
 */
export const disable2FaApiV1Auth2FaDisablePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<Disable2FaApiV1Auth2FaDisablePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    Disable2FaApiV1Auth2FaDisablePostResponses,
    Disable2FaApiV1Auth2FaDisablePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/2fa/disable",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Enable 2Fa
 *
 * Enable 2FA after verifying code
 */
export const enable2FaApiV1Auth2FaEnablePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<Enable2FaApiV1Auth2FaEnablePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    Enable2FaApiV1Auth2FaEnablePostResponses,
    Enable2FaApiV1Auth2FaEnablePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/2fa/enable",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Setup 2Fa
 *
 * Setup 2FA for user account
 */
export const setup2FaApiV1Auth2FaSetupPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<Setup2FaApiV1Auth2FaSetupPostData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    Setup2FaApiV1Auth2FaSetupPostResponses,
    Setup2FaApiV1Auth2FaSetupPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/2fa/setup",
    ...options,
  });

/**
 * Verify 2Fa
 *
 * Verify 2FA code and complete login
 */
export const verify2FaApiV1Auth2FaVerifyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<Verify2FaApiV1Auth2FaVerifyPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    Verify2FaApiV1Auth2FaVerifyPostResponses,
    Verify2FaApiV1Auth2FaVerifyPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/2fa/verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change Password
 *
 * Change user password
 */
export const changePasswordApiV1AuthChangePasswordPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ChangePasswordApiV1AuthChangePasswordPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ChangePasswordApiV1AuthChangePasswordPostResponses,
    ChangePasswordApiV1AuthChangePasswordPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/change-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Checkout Data
 *
 * Update user data during checkout process
 */
export const updateCheckoutDataApiV1AuthCheckoutDataPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateCheckoutDataApiV1AuthCheckoutDataPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    UpdateCheckoutDataApiV1AuthCheckoutDataPostResponses,
    UpdateCheckoutDataApiV1AuthCheckoutDataPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/checkout-data",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Forgot Password
 *
 * Send password reset code to user email
 */
export const forgotPasswordApiV1AuthForgotPasswordPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ForgotPasswordApiV1AuthForgotPasswordPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ForgotPasswordApiV1AuthForgotPasswordPostResponses,
    ForgotPasswordApiV1AuthForgotPasswordPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/auth/forgot-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Login
 *
 * Login with email and password
 */
export const loginApiV1AuthLoginPost = <ThrowOnError extends boolean = false>(
  options: Options<LoginApiV1AuthLoginPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LoginApiV1AuthLoginPostResponses,
    LoginApiV1AuthLoginPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Logout
 *
 * Logout and invalidate refresh token
 */
export const logoutApiV1AuthLogoutPost = <ThrowOnError extends boolean = false>(
  options: Options<LogoutApiV1AuthLogoutPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LogoutApiV1AuthLogoutPostResponses,
    LogoutApiV1AuthLogoutPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/auth/logout",
    ...options,
  });

/**
 * Refresh Token
 *
 * Refresh access token using refresh token
 */
export const refreshTokenApiV1AuthRefreshPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RefreshTokenApiV1AuthRefreshPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RefreshTokenApiV1AuthRefreshPostResponses,
    RefreshTokenApiV1AuthRefreshPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/auth/refresh",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Register
 *
 * Register a new user - Always available even in maintenance mode
 */
export const registerApiV1AuthRegisterPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RegisterApiV1AuthRegisterPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RegisterApiV1AuthRegisterPostResponses,
    RegisterApiV1AuthRegisterPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/auth/register",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reset Password
 *
 * Reset password using code from email
 */
export const resetPasswordApiV1AuthResetPasswordPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResetPasswordApiV1AuthResetPasswordPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ResetPasswordApiV1AuthResetPasswordPostResponses,
    ResetPasswordApiV1AuthResetPasswordPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/auth/reset-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get My Profile
 *
 * Get current user profile
 */
export const getMyProfileApiV1UsersMeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetMyProfileApiV1UsersMeGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetMyProfileApiV1UsersMeGetResponses,
    GetMyProfileApiV1UsersMeGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me",
    ...options,
  });

/**
 * Update My Profile
 *
 * Update current user profile
 */
export const updateMyProfileApiV1UsersMePut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateMyProfileApiV1UsersMePutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateMyProfileApiV1UsersMePutResponses,
    UpdateMyProfileApiV1UsersMePutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Avatar
 *
 * Delete user avatar
 */
export const deleteAvatarApiV1UsersMeAvatarDelete = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeleteAvatarApiV1UsersMeAvatarDeleteData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    DeleteAvatarApiV1UsersMeAvatarDeleteResponses,
    DeleteAvatarApiV1UsersMeAvatarDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me/avatar",
    ...options,
  });

/**
 * Upload Avatar
 *
 * Upload user avatar
 */
export const uploadAvatarApiV1UsersMeAvatarPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadAvatarApiV1UsersMeAvatarPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadAvatarApiV1UsersMeAvatarPostResponses,
    UploadAvatarApiV1UsersMeAvatarPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me/avatar",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Delete User Connection
 *
 * Desconecta uma integração removendo credenciais e limpando dados de métricas.
 */
export const deleteUserConnectionApiV1UsersMeConnectionsDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteUserConnectionApiV1UsersMeConnectionsDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteUserConnectionApiV1UsersMeConnectionsDeleteResponses,
    DeleteUserConnectionApiV1UsersMeConnectionsDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me/connections",
    ...options,
  });

/**
 * Get User Connections
 *
 * Obter status das conexões do usuário atual
 */
export const getUserConnectionsApiV1UsersMeConnectionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetUserConnectionsApiV1UsersMeConnectionsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetUserConnectionsApiV1UsersMeConnectionsGetResponses,
    GetUserConnectionsApiV1UsersMeConnectionsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me/connections",
    ...options,
  });

/**
 * Get User Integrations
 *
 * Obter integrações do usuário atual
 */
export const getUserIntegrationsApiV1UsersMeIntegrationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetUserIntegrationsApiV1UsersMeIntegrationsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetUserIntegrationsApiV1UsersMeIntegrationsGetResponses,
    GetUserIntegrationsApiV1UsersMeIntegrationsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me/integrations",
    ...options,
  });

/**
 * Revoke All Sessions
 *
 * Revoke all user sessions except current
 */
export const revokeAllSessionsApiV1UsersMeSessionsDelete = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    RevokeAllSessionsApiV1UsersMeSessionsDeleteData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).delete<
    RevokeAllSessionsApiV1UsersMeSessionsDeleteResponses,
    RevokeAllSessionsApiV1UsersMeSessionsDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me/sessions",
    ...options,
  });

/**
 * Get My Sessions
 *
 * Get user's active sessions
 */
export const getMySessionsApiV1UsersMeSessionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetMySessionsApiV1UsersMeSessionsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetMySessionsApiV1UsersMeSessionsGetResponses,
    GetMySessionsApiV1UsersMeSessionsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me/sessions",
    ...options,
  });

/**
 * Revoke Session
 *
 * Revoke a specific session
 */
export const revokeSessionApiV1UsersMeSessionsSessionIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RevokeSessionApiV1UsersMeSessionsSessionIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    RevokeSessionApiV1UsersMeSessionsSessionIdDeleteResponses,
    RevokeSessionApiV1UsersMeSessionsSessionIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/users/me/sessions/{session_id}",
    ...options,
  });

/**
 * List AI Credit Packs
 */
export const apiV1MyAccountAiCreditPacksGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ApiV1MyAccountAiCreditPacksGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiV1MyAccountAiCreditPacksGetResponses,
    ApiV1MyAccountAiCreditPacksGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/ai-credit-packs",
    ...options,
  });

/**
 * Purchase AI Credit Pack
 */
export const apiV1MyAccountAiCreditPacksPurchasePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1MyAccountAiCreditPacksPurchasePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApiV1MyAccountAiCreditPacksPurchasePostResponses,
    ApiV1MyAccountAiCreditPacksPurchasePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/ai-credit-packs/purchase",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get AI Credit Purchase PIX QR
 */
export const apiV1MyAccountAiCreditPacksPurchasesInvoiceIdQrGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ApiV1MyAccountAiCreditPacksPurchasesInvoiceIdQrGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ApiV1MyAccountAiCreditPacksPurchasesInvoiceIdQrGetResponses,
    ApiV1MyAccountAiCreditPacksPurchasesInvoiceIdQrGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/ai-credit-packs/purchases/{invoice_id}/qr",
    ...options,
  });

/**
 * Get Ai Credits
 *
 * Saldo de créditos de IA da CONTA selecionada (customer_uuid).
 *
 * O saldo é por conta/subconta (sem pool). Sem `customer_uuid` ou sem
 * assinatura ativa, responde 0 para a UI não quebrar.
 */
export const getAiCreditsApiV1MyAccountAiCreditsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAiCreditsApiV1MyAccountAiCreditsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetAiCreditsApiV1MyAccountAiCreditsGetResponses,
    GetAiCreditsApiV1MyAccountAiCreditsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/ai-credits",
    ...options,
  });

/**
 * List Invoices
 *
 * Lista as faturas da assinatura do usuário logado, incluindo info de trial.
 */
export const listInvoicesApiV1MyAccountInvoicesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListInvoicesApiV1MyAccountInvoicesGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListInvoicesApiV1MyAccountInvoicesGetResponses,
    ListInvoicesApiV1MyAccountInvoicesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/invoices",
    ...options,
  });

/**
 * Get Invoice Detail
 *
 * Retorna o detalhamento completo de uma fatura específica.
 */
export const getInvoiceDetailApiV1MyAccountInvoicesInvoiceIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInvoiceDetailApiV1MyAccountInvoicesInvoiceIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInvoiceDetailApiV1MyAccountInvoicesInvoiceIdGetResponses,
    GetInvoiceDetailApiV1MyAccountInvoicesInvoiceIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/invoices/{invoice_id}",
    ...options,
  });

/**
 * Get Payment Status
 *
 * Status da cobrança do assinante (usado pelo checkout para saber quando o PIX foi pago).
 */
export const getPaymentStatusApiV1MyAccountPaymentStatusGatewayPaymentIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPaymentStatusApiV1MyAccountPaymentStatusGatewayPaymentIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetPaymentStatusApiV1MyAccountPaymentStatusGatewayPaymentIdGetResponses,
    GetPaymentStatusApiV1MyAccountPaymentStatusGatewayPaymentIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/payment-status/{gateway_payment_id}",
    ...options,
  });

/**
 * Get Subscription Info
 *
 * Retorna o plano atual do assinante e os planos disponíveis.
 */
export const getSubscriptionInfoApiV1MyAccountSubscriptionGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetSubscriptionInfoApiV1MyAccountSubscriptionGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetSubscriptionInfoApiV1MyAccountSubscriptionGetResponses,
    GetSubscriptionInfoApiV1MyAccountSubscriptionGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/subscription",
    ...options,
  });

/**
 * List Account Users
 *
 * Lista todos os usuários vinculados à conta do assinante logado.
 */
export const listAccountUsersApiV1MyAccountUsersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListAccountUsersApiV1MyAccountUsersGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListAccountUsersApiV1MyAccountUsersGetResponses,
    ListAccountUsersApiV1MyAccountUsersGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/users",
    ...options,
  });

/**
 * Create Account User
 *
 * Cria um novo usuário na conta do assinante, permitindo login imediato.
 */
export const createAccountUserApiV1MyAccountUsersPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAccountUserApiV1MyAccountUsersPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateAccountUserApiV1MyAccountUsersPostResponses,
    CreateAccountUserApiV1MyAccountUsersPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Account User
 *
 * Desativa (soft-delete) um usuário da conta.
 */
export const deleteAccountUserApiV1MyAccountUsersAccountUserIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAccountUserApiV1MyAccountUsersAccountUserIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAccountUserApiV1MyAccountUsersAccountUserIdDeleteResponses,
    DeleteAccountUserApiV1MyAccountUsersAccountUserIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/users/{account_user_id}",
    ...options,
  });

/**
 * Update Account User
 *
 * Atualiza dados de um usuário da conta.
 */
export const updateAccountUserApiV1MyAccountUsersAccountUserIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAccountUserApiV1MyAccountUsersAccountUserIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateAccountUserApiV1MyAccountUsersAccountUserIdPutResponses,
    UpdateAccountUserApiV1MyAccountUsersAccountUserIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/my-account/users/{account_user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get My Plan Features
 */
export const getMyPlanFeaturesApiV1PlansMyPlanFeaturesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMyPlanFeaturesApiV1PlansMyPlanFeaturesGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetMyPlanFeaturesApiV1PlansMyPlanFeaturesGetResponses,
    GetMyPlanFeaturesApiV1PlansMyPlanFeaturesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/plans/my-plan/features",
    ...options,
  });

/**
 * List Accounts
 *
 * List all accounts for the current subscriber
 */
export const listAccountsApiV1AccountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListAccountsApiV1AccountsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListAccountsApiV1AccountsGetResponses,
    ListAccountsApiV1AccountsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/accounts",
    ...options,
  });

/**
 * Create Account
 *
 * Create account for the current user - DUPLICADO COM ROUTER
 */
export const createAccountApiV1AccountsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAccountApiV1AccountsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateAccountApiV1AccountsPostResponses,
    CreateAccountApiV1AccountsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/accounts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Switch To Account
 *
 * Switch to a subaccount (generates token for subaccount user)
 */
export const switchToAccountApiV1AccountsSwitchAccountPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SwitchToAccountApiV1AccountsSwitchAccountPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SwitchToAccountApiV1AccountsSwitchAccountPostResponses,
    SwitchToAccountApiV1AccountsSwitchAccountPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/accounts/switch-account",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Account Permanently
 *
 * Delete account permanently with all related data
 */
export const deleteAccountPermanentlyApiV1AccountsAccountIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAccountPermanentlyApiV1AccountsAccountIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAccountPermanentlyApiV1AccountsAccountIdDeleteResponses,
    DeleteAccountPermanentlyApiV1AccountsAccountIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/accounts/{account_id}",
    ...options,
  });

/**
 * Update Account
 *
 * Update account for the current user
 */
export const updateAccountApiV1AccountsAccountIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAccountApiV1AccountsAccountIdPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateAccountApiV1AccountsAccountIdPutResponses,
    UpdateAccountApiV1AccountsAccountIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/accounts/{account_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Account Status
 *
 * Update account status
 */
export const updateAccountStatusApiV1AccountsAccountIdStatusPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAccountStatusApiV1AccountsAccountIdStatusPatchData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    UpdateAccountStatusApiV1AccountsAccountIdStatusPatchResponses,
    UpdateAccountStatusApiV1AccountsAccountIdStatusPatchErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/accounts/{account_id}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Request Data Deletion
 */
export const requestDataDeletionApiV1DataDeletionPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RequestDataDeletionApiV1DataDeletionPostData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    RequestDataDeletionApiV1DataDeletionPostResponses,
    RequestDataDeletionApiV1DataDeletionPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/data-deletion",
    ...options,
  });

/**
 * Get Storage Usage
 *
 * Return the authenticated user's storage limit and current usage.
 *
 * Combines the plan's storage limit (from the local DB) with Nexus-reported
 * usage to provide:
 * - Plan limit (max_storage_bytes)
 * - Current usage (total_bytes_used) and breakdown by integration
 * - Derived flags: is_near_limit (< 50 MB remaining), is_exceeded,
 * usage_percentage
 */
export const getStorageUsageApiV1StorageUsageGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetStorageUsageApiV1StorageUsageGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetStorageUsageApiV1StorageUsageGetResponses,
    GetStorageUsageApiV1StorageUsageGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/storage/usage",
    ...options,
  });

/**
 * Get Eligible Plans
 *
 * Return plans the authenticated user can upgrade to, with proration preview.
 */
export const getEligiblePlansApiV1SubscriptionsEligiblePlansGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetEligiblePlansApiV1SubscriptionsEligiblePlansGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetEligiblePlansApiV1SubscriptionsEligiblePlansGetResponses,
    GetEligiblePlansApiV1SubscriptionsEligiblePlansGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/subscriptions/eligible-plans",
    ...options,
  });

/**
 * Read Retention Status
 *
 * Return the current trial retention status for the authenticated user.
 *
 * Possible statuses:
 * - active_trial: user is on an active trial
 * - in_retention: trial ended, data preserved but deletion is scheduled
 * - pending_deletion: retention period expired, data is being deleted
 * - none: no trial or retention in progress
 */
export const readRetentionStatusApiV1SubscriptionsRetentionStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ReadRetentionStatusApiV1SubscriptionsRetentionStatusGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ReadRetentionStatusApiV1SubscriptionsRetentionStatusGetResponses,
    ReadRetentionStatusApiV1SubscriptionsRetentionStatusGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/subscriptions/retention-status",
    ...options,
  });

/**
 * Initiate Upgrade
 *
 * Initiate a plan upgrade: validate, create invoice, charge via Asaas.
 */
export const initiateUpgradeApiV1SubscriptionsUpgradePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    InitiateUpgradeApiV1SubscriptionsUpgradePostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    InitiateUpgradeApiV1SubscriptionsUpgradePostResponses,
    InitiateUpgradeApiV1SubscriptionsUpgradePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/subscriptions/upgrade",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Upgrade Pix Qr
 *
 * Re-fetch the PIX QR code for a pending upgrade invoice.
 */
export const getUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGetResponses,
    GetUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/subscriptions/upgrade/{invoice_id}/qr",
    ...options,
  });

/**
 * Regenerate Admin 2Fa Backup Codes
 */
export const apiV1AdminAuth2FaBackupCodesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1AdminAuth2FaBackupCodesPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApiV1AdminAuth2FaBackupCodesPostResponses,
    ApiV1AdminAuth2FaBackupCodesPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/auth/2fa/backup-codes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reconfigure Admin 2Fa
 */
export const apiV1AdminAuth2FaReconfigurePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1AdminAuth2FaReconfigurePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApiV1AdminAuth2FaReconfigurePostResponses,
    ApiV1AdminAuth2FaReconfigurePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/auth/2fa/reconfigure",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reset 2Fa
 *
 * Reset 2FA para usuário existente - apenas para desenvolvimento
 */
export const reset2FaApiV1AdminAuth2FaResetPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<Reset2FaApiV1AdminAuth2FaResetPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    Reset2FaApiV1AdminAuth2FaResetPostResponses,
    Reset2FaApiV1AdminAuth2FaResetPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/admin/auth/2fa/reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Setup 2Fa
 *
 * Configura 2FA para o admin atual
 */
export const setup2FaApiV1AdminAuth2FaSetupPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<Setup2FaApiV1AdminAuth2FaSetupPostData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    Setup2FaApiV1AdminAuth2FaSetupPostResponses,
    Setup2FaApiV1AdminAuth2FaSetupPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/auth/2fa/setup",
    ...options,
  });

/**
 * Setup 2Fa Initial
 *
 * Configura 2FA no primeiro acesso usando session_token
 */
export const setup2FaInitialApiV1AdminAuth2FaSetupInitialPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    Setup2FaInitialApiV1AdminAuth2FaSetupInitialPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    Setup2FaInitialApiV1AdminAuth2FaSetupInitialPostResponses,
    Setup2FaInitialApiV1AdminAuth2FaSetupInitialPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/admin/auth/2fa/setup-initial",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Verify 2Fa
 *
 * Segundo passo do login - verifica código 2FA
 */
export const verify2FaApiV1AdminAuth2FaVerifyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<Verify2FaApiV1AdminAuth2FaVerifyPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    Verify2FaApiV1AdminAuth2FaVerifyPostResponses,
    Verify2FaApiV1AdminAuth2FaVerifyPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/admin/auth/2fa/verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change Password
 *
 * Altera senha do admin atual
 */
export const changePasswordApiV1AdminAuthChangePasswordPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ChangePasswordApiV1AdminAuthChangePasswordPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ChangePasswordApiV1AdminAuthChangePasswordPostResponses,
    ChangePasswordApiV1AdminAuthChangePasswordPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/auth/change-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Login
 *
 * Primeiro passo do login admin - valida credenciais
 */
export const adminLoginApiV1AdminAuthLoginPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminLoginApiV1AdminAuthLoginPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminLoginApiV1AdminAuthLoginPostResponses,
    AdminLoginApiV1AdminAuthLoginPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/admin/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Login Test
 *
 * Endpoint de login simplificado para testes
 */
export const adminLoginTestApiV1AdminAuthLoginTestPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminLoginTestApiV1AdminAuthLoginTestPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AdminLoginTestApiV1AdminAuthLoginTestPostResponses,
    AdminLoginTestApiV1AdminAuthLoginTestPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/admin/auth/login-test",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Logout
 *
 * Faz logout do admin
 */
export const adminLogoutApiV1AdminAuthLogoutPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminLogoutApiV1AdminAuthLogoutPostData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    AdminLogoutApiV1AdminAuthLogoutPostResponses,
    AdminLogoutApiV1AdminAuthLogoutPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/auth/logout",
    ...options,
  });

/**
 * Get Current Admin
 *
 * Obtém informações do admin atual
 */
export const getCurrentAdminApiV1AdminAuthMeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCurrentAdminApiV1AdminAuthMeGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetCurrentAdminApiV1AdminAuthMeGetResponses,
    GetCurrentAdminApiV1AdminAuthMeGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/auth/me",
    ...options,
  });

/**
 * Confirm Password Reset
 *
 * Confirma reset de senha com novo password
 */
export const confirmPasswordResetApiV1AdminAuthPasswordResetConfirmPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ConfirmPasswordResetApiV1AdminAuthPasswordResetConfirmPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ConfirmPasswordResetApiV1AdminAuthPasswordResetConfirmPostResponses,
    ConfirmPasswordResetApiV1AdminAuthPasswordResetConfirmPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/admin/auth/password/reset-confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Request Password Reset
 *
 * Solicita reset de senha
 */
export const requestPasswordResetApiV1AdminAuthPasswordResetRequestPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RequestPasswordResetApiV1AdminAuthPasswordResetRequestPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    RequestPasswordResetApiV1AdminAuthPasswordResetRequestPostResponses,
    RequestPasswordResetApiV1AdminAuthPasswordResetRequestPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/admin/auth/password/reset-request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Request Password Reset Nonexistent
 *
 * Solicita reset de senha para email inexistente (para testes)
 */
export const requestPasswordResetNonexistentApiV1AdminAuthPasswordResetRequestNonexistentPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RequestPasswordResetNonexistentApiV1AdminAuthPasswordResetRequestNonexistentPostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      RequestPasswordResetNonexistentApiV1AdminAuthPasswordResetRequestNonexistentPostResponses,
      RequestPasswordResetNonexistentApiV1AdminAuthPasswordResetRequestNonexistentPostErrors,
      ThrowOnError
    >({
      url: "/api/v1/admin/auth/password/reset-request-nonexistent",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Refresh Token
 *
 * Renova token de acesso
 */
export const refreshTokenApiV1AdminAuthRefreshPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RefreshTokenApiV1AdminAuthRefreshPostData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    RefreshTokenApiV1AdminAuthRefreshPostResponses,
    RefreshTokenApiV1AdminAuthRefreshPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/auth/refresh",
    ...options,
  });

/**
 * Request Password Reset Endpoint
 *
 * Endpoint para solicitar reset de senha
 */
export const requestPasswordResetEndpointApiV1AdminAuthRequestPasswordResetPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RequestPasswordResetEndpointApiV1AdminAuthRequestPasswordResetPostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      RequestPasswordResetEndpointApiV1AdminAuthRequestPasswordResetPostResponses,
      RequestPasswordResetEndpointApiV1AdminAuthRequestPasswordResetPostErrors,
      ThrowOnError
    >({
      url: "/api/v1/admin/auth/request-password-reset",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * List Admin Users
 *
 * Lista usuários admin
 */
export const listAdminUsersApiV1AdminAdminUsersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListAdminUsersApiV1AdminAdminUsersGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListAdminUsersApiV1AdminAdminUsersGetResponses,
    ListAdminUsersApiV1AdminAdminUsersGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users",
    ...options,
  });

/**
 * Create Admin User
 *
 * Cria novo usuário admin
 */
export const createAdminUserApiV1AdminAdminUsersPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAdminUserApiV1AdminAdminUsersPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateAdminUserApiV1AdminAdminUsersPostResponses,
    CreateAdminUserApiV1AdminAdminUsersPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Admin Users
 *
 * Lista usuários admin
 */
export const listAdminUsersApiV1AdminAdminUsersGet2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListAdminUsersApiV1AdminAdminUsersGet2Data, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListAdminUsersApiV1AdminAdminUsersGet2Responses,
    ListAdminUsersApiV1AdminAdminUsersGet2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/",
    ...options,
  });

/**
 * Create Admin User
 *
 * Cria novo usuário admin
 */
export const createAdminUserApiV1AdminAdminUsersPost2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAdminUserApiV1AdminAdminUsersPost2Data, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateAdminUserApiV1AdminAdminUsersPost2Responses,
    CreateAdminUserApiV1AdminAdminUsersPost2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Bulk Action Admin Users
 *
 * Executa ação em lote em usuários admin
 */
export const bulkActionAdminUsersApiV1AdminAdminUsersBulkActionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkActionAdminUsersApiV1AdminAdminUsersBulkActionPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    BulkActionAdminUsersApiV1AdminAdminUsersBulkActionPostResponses,
    BulkActionAdminUsersApiV1AdminAdminUsersBulkActionPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/bulk-action",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reset Password
 *
 * Reset de senha por admin
 */
export const resetPasswordApiV1AdminAdminUsersPasswordResetPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ResetPasswordApiV1AdminAdminUsersPasswordResetPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ResetPasswordApiV1AdminAdminUsersPasswordResetPostResponses,
    ResetPasswordApiV1AdminAdminUsersPasswordResetPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/password/reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Profiles
 *
 * Lista perfis de permissões
 */
export const listProfilesApiV1AdminAdminUsersProfilesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListProfilesApiV1AdminAdminUsersProfilesGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ListProfilesApiV1AdminAdminUsersProfilesGetResponses,
    ListProfilesApiV1AdminAdminUsersProfilesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/profiles",
    ...options,
  });

/**
 * Create Profile
 *
 * Cria novo perfil de permissões
 */
export const createProfileApiV1AdminAdminUsersProfilesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateProfileApiV1AdminAdminUsersProfilesPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    CreateProfileApiV1AdminAdminUsersProfilesPostResponses,
    CreateProfileApiV1AdminAdminUsersProfilesPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/profiles/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Profile
 *
 * Deleta perfil de permissões
 */
export const deleteProfileApiV1AdminAdminUsersProfilesProfileIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteProfileApiV1AdminAdminUsersProfilesProfileIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteProfileApiV1AdminAdminUsersProfilesProfileIdDeleteResponses,
    DeleteProfileApiV1AdminAdminUsersProfilesProfileIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/profiles/{profile_id}",
    ...options,
  });

/**
 * Update Profile
 *
 * Atualiza perfil de permissões
 */
export const updateProfileApiV1AdminAdminUsersProfilesProfileIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateProfileApiV1AdminAdminUsersProfilesProfileIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateProfileApiV1AdminAdminUsersProfilesProfileIdPutResponses,
    UpdateProfileApiV1AdminAdminUsersProfilesProfileIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/profiles/{profile_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Admin User
 *
 * Desativa usuário admin
 */
export const deleteAdminUserApiV1AdminAdminUsersAdminUserIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminUserApiV1AdminAdminUsersAdminUserIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminUserApiV1AdminAdminUsersAdminUserIdDeleteResponses,
    DeleteAdminUserApiV1AdminAdminUsersAdminUserIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/{admin_user_id}",
    ...options,
  });

/**
 * Get Admin User Details
 *
 * Obtém detalhes do usuário admin
 */
export const getAdminUserDetailsApiV1AdminAdminUsersAdminUserIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminUserDetailsApiV1AdminAdminUsersAdminUserIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminUserDetailsApiV1AdminAdminUsersAdminUserIdGetResponses,
    GetAdminUserDetailsApiV1AdminAdminUsersAdminUserIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/{admin_user_id}",
    ...options,
  });

/**
 * Update Admin User
 *
 * Atualiza usuário admin
 */
export const updateAdminUserApiV1AdminAdminUsersAdminUserIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAdminUserApiV1AdminAdminUsersAdminUserIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateAdminUserApiV1AdminAdminUsersAdminUserIdPutResponses,
    UpdateAdminUserApiV1AdminAdminUsersAdminUserIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/{admin_user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Password
 *
 * Atualiza própria senha
 */
export const updatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPutResponses,
    UpdatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/{admin_user_id}/password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reactivate Admin User
 *
 * Reativa usuário admin
 */
export const reactivateAdminUserApiV1AdminAdminUsersAdminUserIdReactivatePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReactivateAdminUserApiV1AdminAdminUsersAdminUserIdReactivatePostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      ReactivateAdminUserApiV1AdminAdminUsersAdminUserIdReactivatePostResponses,
      ReactivateAdminUserApiV1AdminAdminUsersAdminUserIdReactivatePostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/admin/users/{admin_user_id}/reactivate",
      ...options,
    });

/**
 * Reset Admin User Password
 *
 * Reset de senha de usuário admin
 */
export const resetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ResetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      ResetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPostResponses,
      ResetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/admin/users/{admin_user_id}/reset-password",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Revoke Sessions
 *
 * Revoga todas as sessões do usuário
 */
export const revokeSessionsApiV1AdminAdminUsersAdminUserIdSessionsRevokePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RevokeSessionsApiV1AdminAdminUsersAdminUserIdSessionsRevokePostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    RevokeSessionsApiV1AdminAdminUsersAdminUserIdSessionsRevokePostResponses,
    RevokeSessionsApiV1AdminAdminUsersAdminUserIdSessionsRevokePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/admin/users/{admin_user_id}/sessions/revoke",
    ...options,
  });

/**
 * List Subscribers
 *
 * Lista assinantes com filtros e paginação
 */
export const listSubscribersApiV1AdminSubscribersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListSubscribersApiV1AdminSubscribersGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListSubscribersApiV1AdminSubscribersGetResponses,
    ListSubscribersApiV1AdminSubscribersGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers",
    ...options,
  });

/**
 * List Subscribers
 *
 * Lista assinantes com filtros e paginação
 */
export const listSubscribersApiV1AdminSubscribersGet2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListSubscribersApiV1AdminSubscribersGet2Data, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListSubscribersApiV1AdminSubscribersGet2Responses,
    ListSubscribersApiV1AdminSubscribersGet2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/",
    ...options,
  });

/**
 * Create Subscriber
 *
 * Cria novo assinante
 */
export const createSubscriberApiV1AdminSubscribersPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateSubscriberApiV1AdminSubscribersPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateSubscriberApiV1AdminSubscribersPostResponses,
    CreateSubscriberApiV1AdminSubscribersPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Assign Plan By User
 *
 * Assign a plan to a user (by user_id), creating a subscriber profile if needed.
 */
export const assignPlanByUserApiV1AdminSubscribersAssignPlanByUserPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AssignPlanByUserApiV1AdminSubscribersAssignPlanByUserPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AssignPlanByUserApiV1AdminSubscribersAssignPlanByUserPostResponses,
    AssignPlanByUserApiV1AdminSubscribersAssignPlanByUserPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/assign-plan-by-user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Bulk Action Subscribers
 *
 * Executa ação em lote em assinantes
 */
export const bulkActionSubscribersApiV1AdminSubscribersBulkActionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkActionSubscribersApiV1AdminSubscribersBulkActionPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    BulkActionSubscribersApiV1AdminSubscribersBulkActionPostResponses,
    BulkActionSubscribersApiV1AdminSubscribersBulkActionPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/bulk-action",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Subscribers Distribution By Plan
 *
 * Distribuição de assinaturas ativas por plano (contagem).
 */
export const getSubscribersDistributionByPlanApiV1AdminSubscribersChartsDistributionByPlanGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetSubscribersDistributionByPlanApiV1AdminSubscribersChartsDistributionByPlanGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetSubscribersDistributionByPlanApiV1AdminSubscribersChartsDistributionByPlanGetResponses,
      GetSubscribersDistributionByPlanApiV1AdminSubscribersChartsDistributionByPlanGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/subscribers/charts/distribution-by-plan",
      ...options,
    });

/**
 * Get New Subscribers Chart
 *
 * Série temporal: novos assinantes por mês (últimos N meses).
 */
export const getNewSubscribersChartApiV1AdminSubscribersChartsNewSubscribersGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetNewSubscribersChartApiV1AdminSubscribersChartsNewSubscribersGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetNewSubscribersChartApiV1AdminSubscribersChartsNewSubscribersGetResponses,
      GetNewSubscribersChartApiV1AdminSubscribersChartsNewSubscribersGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/subscribers/charts/new-subscribers",
      ...options,
    });

/**
 * Export Subscribers List
 *
 * Exporta lista de assinantes
 */
export const exportSubscribersListApiV1AdminSubscribersExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportSubscribersListApiV1AdminSubscribersExportGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ExportSubscribersListApiV1AdminSubscribersExportGetResponses,
    ExportSubscribersListApiV1AdminSubscribersExportGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/export",
    ...options,
  });

/**
 * List Hard Deletes
 *
 * Paginated audit log of admin hard deletions.
 */
export const listHardDeletesApiV1AdminSubscribersHardDeletesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListHardDeletesApiV1AdminSubscribersHardDeletesGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ListHardDeletesApiV1AdminSubscribersHardDeletesGetResponses,
    ListHardDeletesApiV1AdminSubscribersHardDeletesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/hard-deletes",
    ...options,
  });

/**
 * Get Subscribers Summary
 *
 * Obtém resumo de KPIs de assinantes (dados reais).
 */
export const getSubscribersSummaryApiV1AdminSubscribersSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetSubscribersSummaryApiV1AdminSubscribersSummaryGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetSubscribersSummaryApiV1AdminSubscribersSummaryGetResponses,
    GetSubscribersSummaryApiV1AdminSubscribersSummaryGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/summary",
    ...options,
  });

/**
 * Deactivate Subscriber
 *
 * Desativa assinante
 */
export const deactivateSubscriberApiV1AdminSubscribersSubscriberIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeactivateSubscriberApiV1AdminSubscribersSubscriberIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeactivateSubscriberApiV1AdminSubscribersSubscriberIdDeleteResponses,
    DeactivateSubscriberApiV1AdminSubscribersSubscriberIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/{subscriber_id}",
    ...options,
  });

/**
 * Get Subscriber Details
 *
 * Obtém detalhes completos do assinante
 */
export const getSubscriberDetailsApiV1AdminSubscribersSubscriberIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetSubscriberDetailsApiV1AdminSubscribersSubscriberIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetSubscriberDetailsApiV1AdminSubscribersSubscriberIdGetResponses,
    GetSubscriberDetailsApiV1AdminSubscribersSubscriberIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/{subscriber_id}",
    ...options,
  });

/**
 * Update Subscriber
 *
 * Atualiza dados do assinante
 */
export const updateSubscriberApiV1AdminSubscribersSubscriberIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateSubscriberApiV1AdminSubscribersSubscriberIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateSubscriberApiV1AdminSubscribersSubscriberIdPutResponses,
    UpdateSubscriberApiV1AdminSubscribersSubscriberIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/{subscriber_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Account For Subscriber
 *
 * Cria conta para assinante
 */
export const createAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      CreateAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPostResponses,
      CreateAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/subscribers/{subscriber_id}/accounts",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Subscriber Activity Log
 *
 * Obtém log de atividades do assinante
 */
export const getSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGetResponses,
      GetSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/subscribers/{subscriber_id}/activity",
      ...options,
    });

/**
 * Assign Plan
 *
 * Assign a plan to a subscriber, activating it immediately.
 */
export const assignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AssignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AssignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPostResponses,
    AssignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/{subscriber_id}/assign-plan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Account For Subscriber Alt
 *
 * Cria conta para assinante (rota alternativa)
 */
export const createAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      CreateAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPostResponses,
      CreateAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/subscribers/{subscriber_id}/create-account",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Hard Delete Subscriber Data
 *
 * Permanently delete a subscriber and all associated data.
 *
 * Requires the admin to retype the subscriber ID as confirmation.
 * Blocked for subscribers with an active or trial subscription.
 * Nexus data cleanup runs in the background.
 */
export const hardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      HardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDeleteData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).delete<
      HardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDeleteResponses,
      HardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDeleteErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/subscribers/{subscriber_id}/hard-delete",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Subscriber Invoices
 *
 * Lista faturas do assinante
 */
export const getSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGetResponses,
      GetSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/subscribers/{subscriber_id}/invoices",
      ...options,
    });

/**
 * Reactivate Subscriber
 *
 * Reativa assinante
 */
export const reactivateSubscriberApiV1AdminSubscribersSubscriberIdReactivatePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReactivateSubscriberApiV1AdminSubscribersSubscriberIdReactivatePostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      ReactivateSubscriberApiV1AdminSubscribersSubscriberIdReactivatePostResponses,
      ReactivateSubscriberApiV1AdminSubscribersSubscriberIdReactivatePostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/subscribers/{subscriber_id}/reactivate",
      ...options,
    });

/**
 * Suspend Subscriber
 *
 * Suspende assinante
 */
export const suspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SuspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SuspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPostResponses,
    SuspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/subscribers/{subscriber_id}/suspend",
    ...options,
  });

/**
 * List Courses
 *
 * Lista cursos com filtros
 */
export const listCoursesApiV1AdminCoursesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListCoursesApiV1AdminCoursesGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListCoursesApiV1AdminCoursesGetResponses,
    ListCoursesApiV1AdminCoursesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses",
    ...options,
  });

/**
 * List Courses
 *
 * Lista cursos com filtros
 */
export const listCoursesApiV1AdminCoursesGet2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListCoursesApiV1AdminCoursesGet2Data, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListCoursesApiV1AdminCoursesGet2Responses,
    ListCoursesApiV1AdminCoursesGet2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/",
    ...options,
  });

/**
 * Create Course
 *
 * Cria novo curso
 */
export const createCourseApiV1AdminCoursesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateCourseApiV1AdminCoursesPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateCourseApiV1AdminCoursesPostResponses,
    CreateCourseApiV1AdminCoursesPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Bulk Enroll Students
 *
 * Matricula alunos em lote
 */
export const bulkEnrollStudentsApiV1AdminCoursesBulkEnrollPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkEnrollStudentsApiV1AdminCoursesBulkEnrollPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    BulkEnrollStudentsApiV1AdminCoursesBulkEnrollPostResponses,
    BulkEnrollStudentsApiV1AdminCoursesBulkEnrollPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/bulk-enroll",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Enrollments Evolution
 *
 * Evolução mensal de matrículas (agregado).
 */
export const getEnrollmentsEvolutionApiV1AdminCoursesChartsEnrollmentsEvolutionGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetEnrollmentsEvolutionApiV1AdminCoursesChartsEnrollmentsEvolutionGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetEnrollmentsEvolutionApiV1AdminCoursesChartsEnrollmentsEvolutionGetResponses,
      GetEnrollmentsEvolutionApiV1AdminCoursesChartsEnrollmentsEvolutionGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/courses/charts/enrollments-evolution",
      ...options,
    });

/**
 * Get Top Courses
 *
 * Top cursos por matrículas no período.
 */
export const getTopCoursesApiV1AdminCoursesChartsTopCoursesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetTopCoursesApiV1AdminCoursesChartsTopCoursesGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetTopCoursesApiV1AdminCoursesChartsTopCoursesGetResponses,
    GetTopCoursesApiV1AdminCoursesChartsTopCoursesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/charts/top-courses",
    ...options,
  });

/**
 * Clone Course
 *
 * Clona um curso
 */
export const cloneCourseApiV1AdminCoursesClonePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CloneCourseApiV1AdminCoursesClonePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CloneCourseApiV1AdminCoursesClonePostResponses,
    CloneCourseApiV1AdminCoursesClonePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/clone",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Lesson
 *
 * Cria aula
 */
export const createLessonApiV1AdminCoursesLessonsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateLessonApiV1AdminCoursesLessonsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateLessonApiV1AdminCoursesLessonsPostResponses,
    CreateLessonApiV1AdminCoursesLessonsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/lessons",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reorder Lessons
 *
 * Reordena aulas de um módulo
 */
export const reorderLessonsApiV1AdminCoursesLessonsReorderPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReorderLessonsApiV1AdminCoursesLessonsReorderPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ReorderLessonsApiV1AdminCoursesLessonsReorderPostResponses,
    ReorderLessonsApiV1AdminCoursesLessonsReorderPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/lessons/reorder",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Lesson
 *
 * Deleta aula (soft delete)
 */
export const deleteLessonApiV1AdminCoursesLessonsLessonIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteLessonApiV1AdminCoursesLessonsLessonIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteLessonApiV1AdminCoursesLessonsLessonIdDeleteResponses,
    DeleteLessonApiV1AdminCoursesLessonsLessonIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/lessons/{lesson_id}",
    ...options,
  });

/**
 * Get Lesson Details
 *
 * Obtém detalhes da aula
 */
export const getLessonDetailsApiV1AdminCoursesLessonsLessonIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetLessonDetailsApiV1AdminCoursesLessonsLessonIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetLessonDetailsApiV1AdminCoursesLessonsLessonIdGetResponses,
    GetLessonDetailsApiV1AdminCoursesLessonsLessonIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/lessons/{lesson_id}",
    ...options,
  });

/**
 * Update Lesson
 *
 * Atualiza aula
 */
export const updateLessonApiV1AdminCoursesLessonsLessonIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateLessonApiV1AdminCoursesLessonsLessonIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateLessonApiV1AdminCoursesLessonsLessonIdPutResponses,
    UpdateLessonApiV1AdminCoursesLessonsLessonIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/lessons/{lesson_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Lesson Media
 *
 * Lista multimídias da aula
 */
export const listLessonMediaApiV1AdminCoursesLessonsLessonIdMediaGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListLessonMediaApiV1AdminCoursesLessonsLessonIdMediaGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ListLessonMediaApiV1AdminCoursesLessonsLessonIdMediaGetResponses,
    ListLessonMediaApiV1AdminCoursesLessonsLessonIdMediaGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/lessons/{lesson_id}/media",
    ...options,
  });

/**
 * Create Lesson Media
 *
 * Cria multimídia da aula
 */
export const createLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    CreateLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPostResponses,
    CreateLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/lessons/{lesson_id}/media",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload Lesson Media
 *
 * Upload de multimídia para uma aula
 */
export const uploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      UploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostResponses,
      UploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/courses/lessons/{lesson_id}/upload-media",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });

/**
 * Reorder Media
 *
 * Reordena multimídias de uma aula
 */
export const reorderMediaApiV1AdminCoursesMediaReorderPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReorderMediaApiV1AdminCoursesMediaReorderPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ReorderMediaApiV1AdminCoursesMediaReorderPostResponses,
    ReorderMediaApiV1AdminCoursesMediaReorderPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/media/reorder",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Lesson Media
 *
 * Deleta multimídia da aula
 */
export const deleteLessonMediaApiV1AdminCoursesMediaMediaIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteLessonMediaApiV1AdminCoursesMediaMediaIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteLessonMediaApiV1AdminCoursesMediaMediaIdDeleteResponses,
    DeleteLessonMediaApiV1AdminCoursesMediaMediaIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/media/{media_id}",
    ...options,
  });

/**
 * Update Lesson Media
 *
 * Atualiza multimídia da aula
 */
export const updateLessonMediaApiV1AdminCoursesMediaMediaIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateLessonMediaApiV1AdminCoursesMediaMediaIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateLessonMediaApiV1AdminCoursesMediaMediaIdPutResponses,
    UpdateLessonMediaApiV1AdminCoursesMediaMediaIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/media/{media_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Module
 *
 * Cria módulo do curso
 */
export const createModuleApiV1AdminCoursesModulesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateModuleApiV1AdminCoursesModulesPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateModuleApiV1AdminCoursesModulesPostResponses,
    CreateModuleApiV1AdminCoursesModulesPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/modules",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reorder Modules
 *
 * Reordena módulos de um curso
 */
export const reorderModulesApiV1AdminCoursesModulesReorderPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReorderModulesApiV1AdminCoursesModulesReorderPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ReorderModulesApiV1AdminCoursesModulesReorderPostResponses,
    ReorderModulesApiV1AdminCoursesModulesReorderPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/modules/reorder",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Module
 *
 * Deleta módulo (soft delete)
 */
export const deleteModuleApiV1AdminCoursesModulesModuleIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteModuleApiV1AdminCoursesModulesModuleIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteModuleApiV1AdminCoursesModulesModuleIdDeleteResponses,
    DeleteModuleApiV1AdminCoursesModulesModuleIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/modules/{module_id}",
    ...options,
  });

/**
 * Get Module Details
 *
 * Obtém detalhes do módulo
 */
export const getModuleDetailsApiV1AdminCoursesModulesModuleIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetModuleDetailsApiV1AdminCoursesModulesModuleIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetModuleDetailsApiV1AdminCoursesModulesModuleIdGetResponses,
    GetModuleDetailsApiV1AdminCoursesModulesModuleIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/modules/{module_id}",
    ...options,
  });

/**
 * Update Module
 *
 * Atualiza módulo
 */
export const updateModuleApiV1AdminCoursesModulesModuleIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateModuleApiV1AdminCoursesModulesModuleIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateModuleApiV1AdminCoursesModulesModuleIdPutResponses,
    UpdateModuleApiV1AdminCoursesModulesModuleIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/modules/{module_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Courses Summary
 *
 * Resumo de KPIs de cursos.
 */
export const getCoursesSummaryApiV1AdminCoursesSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetCoursesSummaryApiV1AdminCoursesSummaryGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetCoursesSummaryApiV1AdminCoursesSummaryGetResponses,
    GetCoursesSummaryApiV1AdminCoursesSummaryGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/summary",
    ...options,
  });

/**
 * Upload File
 *
 * Upload de arquivo para curso
 */
export const uploadFileApiV1AdminCoursesUploadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadFileApiV1AdminCoursesUploadPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadFileApiV1AdminCoursesUploadPostResponses,
    UploadFileApiV1AdminCoursesUploadPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Delete Course
 *
 * Desativa curso
 */
export const deleteCourseApiV1AdminCoursesCourseIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteCourseApiV1AdminCoursesCourseIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteCourseApiV1AdminCoursesCourseIdDeleteResponses,
    DeleteCourseApiV1AdminCoursesCourseIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/{course_id}",
    ...options,
  });

/**
 * Get Course Details
 *
 * Obtém detalhes do curso
 */
export const getCourseDetailsApiV1AdminCoursesCourseIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCourseDetailsApiV1AdminCoursesCourseIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCourseDetailsApiV1AdminCoursesCourseIdGetResponses,
    GetCourseDetailsApiV1AdminCoursesCourseIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/{course_id}",
    ...options,
  });

/**
 * Update Course
 *
 * Atualiza curso
 */
export const updateCourseApiV1AdminCoursesCourseIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCourseApiV1AdminCoursesCourseIdPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateCourseApiV1AdminCoursesCourseIdPutResponses,
    UpdateCourseApiV1AdminCoursesCourseIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/{course_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Bulk Enroll Course Students
 *
 * Matricula alunos em lote no curso
 */
export const bulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    BulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPostResponses,
    BulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/{course_id}/bulk-enroll",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Clone Course Endpoint
 *
 * Clona um curso
 */
export const cloneCourseEndpointApiV1AdminCoursesCourseIdClonePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CloneCourseEndpointApiV1AdminCoursesCourseIdClonePostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    CloneCourseEndpointApiV1AdminCoursesCourseIdClonePostResponses,
    CloneCourseEndpointApiV1AdminCoursesCourseIdClonePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/{course_id}/clone",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Course Enrollment Stats
 *
 * Obtém estatísticas de matrícula do curso
 */
export const getCourseEnrollmentStatsApiV1AdminCoursesCourseIdEnrollmentStatsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetCourseEnrollmentStatsApiV1AdminCoursesCourseIdEnrollmentStatsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetCourseEnrollmentStatsApiV1AdminCoursesCourseIdEnrollmentStatsGetResponses,
      GetCourseEnrollmentStatsApiV1AdminCoursesCourseIdEnrollmentStatsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/courses/{course_id}/enrollment-stats",
      ...options,
    });

/**
 * Create Course Module
 *
 * Cria módulo do curso
 */
export const createCourseModuleApiV1AdminCoursesCourseIdModulesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateCourseModuleApiV1AdminCoursesCourseIdModulesPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    CreateCourseModuleApiV1AdminCoursesCourseIdModulesPostResponses,
    CreateCourseModuleApiV1AdminCoursesCourseIdModulesPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/{course_id}/modules",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Course Lesson
 *
 * Cria aula do módulo
 */
export const createCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      CreateCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPostResponses,
      CreateCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/courses/{course_id}/modules/{module_id}/lessons",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Course Student Progress
 *
 * Obtém progresso dos alunos no curso
 */
export const getCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGetResponses,
      GetCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/courses/{course_id}/student-progress",
      ...options,
    });

/**
 * Get Students Progress
 *
 * Lista progresso dos alunos
 */
export const getStudentsProgressApiV1AdminCoursesCourseIdStudentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetStudentsProgressApiV1AdminCoursesCourseIdStudentsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetStudentsProgressApiV1AdminCoursesCourseIdStudentsGetResponses,
    GetStudentsProgressApiV1AdminCoursesCourseIdStudentsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/courses/{course_id}/students",
    ...options,
  });

/**
 * Mark Alert As Read
 *
 * Marca alerta como lido
 */
export const markAlertAsReadApiV1AdminBillingAlertsAlertIdReadPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkAlertAsReadApiV1AdminBillingAlertsAlertIdReadPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    MarkAlertAsReadApiV1AdminBillingAlertsAlertIdReadPutResponses,
    MarkAlertAsReadApiV1AdminBillingAlertsAlertIdReadPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/alerts/{alert_id}/read",
    ...options,
  });

/**
 * Get Quarterly Revenue By Plan
 *
 * Obtém faturamento do trimestre atual por plano
 */
export const getQuarterlyRevenueByPlanApiV1AdminBillingChartsQuarterlyByPlanGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetQuarterlyRevenueByPlanApiV1AdminBillingChartsQuarterlyByPlanGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetQuarterlyRevenueByPlanApiV1AdminBillingChartsQuarterlyByPlanGetResponses,
      GetQuarterlyRevenueByPlanApiV1AdminBillingChartsQuarterlyByPlanGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/billing/charts/quarterly-by-plan",
      ...options,
    });

/**
 * Get Revenue Evolution By Plan
 *
 * Obtém evolução do faturamento dos últimos 12 meses por plano
 */
export const getRevenueEvolutionByPlanApiV1AdminBillingChartsRevenueEvolutionGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetRevenueEvolutionByPlanApiV1AdminBillingChartsRevenueEvolutionGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetRevenueEvolutionByPlanApiV1AdminBillingChartsRevenueEvolutionGetResponses,
      GetRevenueEvolutionByPlanApiV1AdminBillingChartsRevenueEvolutionGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/billing/charts/revenue-evolution",
      ...options,
    });

/**
 * List Coupons
 *
 * Lista cupons de desconto
 */
export const listCouponsApiV1AdminBillingCouponsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListCouponsApiV1AdminBillingCouponsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListCouponsApiV1AdminBillingCouponsGetResponses,
    ListCouponsApiV1AdminBillingCouponsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/coupons",
    ...options,
  });

/**
 * Create Coupon
 *
 * Cria cupom de desconto
 */
export const createCouponApiV1AdminBillingCouponsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateCouponApiV1AdminBillingCouponsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateCouponApiV1AdminBillingCouponsPostResponses,
    CreateCouponApiV1AdminBillingCouponsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/coupons",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Coupon
 *
 * Atualiza cupom
 */
export const updateCouponApiV1AdminBillingCouponsCouponIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateCouponApiV1AdminBillingCouponsCouponIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateCouponApiV1AdminBillingCouponsCouponIdPutResponses,
    UpdateCouponApiV1AdminBillingCouponsCouponIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/coupons/{coupon_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Customer Billing History
 *
 * Obtém histórico de faturamento do cliente
 */
export const getCustomerBillingHistoryApiV1AdminBillingCustomersSubscriberIdHistoryGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetCustomerBillingHistoryApiV1AdminBillingCustomersSubscriberIdHistoryGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetCustomerBillingHistoryApiV1AdminBillingCustomersSubscriberIdHistoryGetResponses,
      GetCustomerBillingHistoryApiV1AdminBillingCustomersSubscriberIdHistoryGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/billing/customers/{subscriber_id}/history",
      ...options,
    });

/**
 * Export Transactions
 *
 * Exporta transações em formato CSV
 */
export const exportTransactionsApiV1AdminBillingExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportTransactionsApiV1AdminBillingExportGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ExportTransactionsApiV1AdminBillingExportGetResponses,
    ExportTransactionsApiV1AdminBillingExportGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/export",
    ...options,
  });

/**
 * List Invoices
 *
 * Lista faturas com filtros
 */
export const listInvoicesApiV1AdminBillingInvoicesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListInvoicesApiV1AdminBillingInvoicesGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListInvoicesApiV1AdminBillingInvoicesGetResponses,
    ListInvoicesApiV1AdminBillingInvoicesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/invoices",
    ...options,
  });

/**
 * Get Invoice Details
 *
 * Obtém detalhes da fatura
 */
export const getInvoiceDetailsApiV1AdminBillingInvoicesInvoiceIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInvoiceDetailsApiV1AdminBillingInvoicesInvoiceIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInvoiceDetailsApiV1AdminBillingInvoicesInvoiceIdGetResponses,
    GetInvoiceDetailsApiV1AdminBillingInvoicesInvoiceIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/invoices/{invoice_id}",
    ...options,
  });

/**
 * Update Invoice
 *
 * Atualiza fatura
 */
export const updateInvoiceApiV1AdminBillingInvoicesInvoiceIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateInvoiceApiV1AdminBillingInvoicesInvoiceIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateInvoiceApiV1AdminBillingInvoicesInvoiceIdPutResponses,
    UpdateInvoiceApiV1AdminBillingInvoicesInvoiceIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/invoices/{invoice_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Register Payment
 *
 * Registra pagamento manual
 */
export const registerPaymentApiV1AdminBillingPaymentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RegisterPaymentApiV1AdminBillingPaymentsPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    RegisterPaymentApiV1AdminBillingPaymentsPostResponses,
    RegisterPaymentApiV1AdminBillingPaymentsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/payments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Process Refund
 *
 * Processa reembolso
 */
export const processRefundApiV1AdminBillingPaymentsPaymentIdRefundPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProcessRefundApiV1AdminBillingPaymentsPaymentIdRefundPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ProcessRefundApiV1AdminBillingPaymentsPaymentIdRefundPostResponses,
    ProcessRefundApiV1AdminBillingPaymentsPaymentIdRefundPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/payments/{payment_id}/refund",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Billing Summary
 *
 * Obtém resumo de faturamento
 */
export const getBillingSummaryApiV1AdminBillingSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetBillingSummaryApiV1AdminBillingSummaryGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetBillingSummaryApiV1AdminBillingSummaryGetResponses,
    GetBillingSummaryApiV1AdminBillingSummaryGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/summary",
    ...options,
  });

/**
 * Get Billing Summary Fix
 *
 * Obtém resumo de faturamento com indicadores de crescimento
 */
export const getBillingSummaryFixApiV1AdminBillingSummaryFixGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetBillingSummaryFixApiV1AdminBillingSummaryFixGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetBillingSummaryFixApiV1AdminBillingSummaryFixGetResponses,
    GetBillingSummaryFixApiV1AdminBillingSummaryFixGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/summary-fix",
    ...options,
  });

/**
 * List Transactions
 *
 * Lista transações unificadas (pagamentos e faturas) com filtro por intervalo de datas.
 */
export const listTransactionsApiV1AdminBillingTransactionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListTransactionsApiV1AdminBillingTransactionsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ListTransactionsApiV1AdminBillingTransactionsGetResponses,
    ListTransactionsApiV1AdminBillingTransactionsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/billing/transactions",
    ...options,
  });

/**
 * Get Transaction Details
 *
 * Obtém detalhes completos de uma transação específica
 */
export const getTransactionDetailsApiV1AdminBillingTransactionsTransactionIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetTransactionDetailsApiV1AdminBillingTransactionsTransactionIdGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetTransactionDetailsApiV1AdminBillingTransactionsTransactionIdGetResponses,
      GetTransactionDetailsApiV1AdminBillingTransactionsTransactionIdGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/billing/transactions/{transaction_id}",
      ...options,
    });

/**
 * List AI Credit Packs
 */
export const apiV1AdminAiCreditPacksGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ApiV1AdminAiCreditPacksGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiV1AdminAiCreditPacksGetResponses,
    ApiV1AdminAiCreditPacksGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/ai-credit-packs",
    ...options,
  });

/**
 * Create AI Credit Pack
 */
export const apiV1AdminAiCreditPacksPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1AdminAiCreditPacksPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApiV1AdminAiCreditPacksPostResponses,
    ApiV1AdminAiCreditPacksPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/ai-credit-packs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete AI Credit Pack
 */
export const apiV1AdminAiCreditPacksPackIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1AdminAiCreditPacksPackIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ApiV1AdminAiCreditPacksPackIdDeleteResponses,
    ApiV1AdminAiCreditPacksPackIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/ai-credit-packs/{pack_id}",
    ...options,
  });

/**
 * Update AI Credit Pack
 */
export const apiV1AdminAiCreditPacksPackIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1AdminAiCreditPacksPackIdPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ApiV1AdminAiCreditPacksPackIdPutResponses,
    ApiV1AdminAiCreditPacksPackIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/ai-credit-packs/{pack_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Coupons
 */
export const listCouponsApiV1AdminCouponsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListCouponsApiV1AdminCouponsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListCouponsApiV1AdminCouponsGetResponses,
    ListCouponsApiV1AdminCouponsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/coupons",
    ...options,
  });

/**
 * List Coupons
 */
export const listCouponsApiV1AdminCouponsGet2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListCouponsApiV1AdminCouponsGet2Data, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListCouponsApiV1AdminCouponsGet2Responses,
    ListCouponsApiV1AdminCouponsGet2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/coupons/",
    ...options,
  });

/**
 * Create Coupon
 */
export const createCouponApiV1AdminCouponsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateCouponApiV1AdminCouponsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateCouponApiV1AdminCouponsPostResponses,
    CreateCouponApiV1AdminCouponsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/coupons/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Coupon Redemptions
 */
export const apiV1AdminCouponsRedemptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ApiV1AdminCouponsRedemptionsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiV1AdminCouponsRedemptionsGetResponses,
    ApiV1AdminCouponsRedemptionsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/coupons/redemptions",
    ...options,
  });

/**
 * Usage Timeseries
 */
export const usageTimeseriesApiV1AdminCouponsUsageTimeseriesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    UsageTimeseriesApiV1AdminCouponsUsageTimeseriesGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    UsageTimeseriesApiV1AdminCouponsUsageTimeseriesGetResponses,
    UsageTimeseriesApiV1AdminCouponsUsageTimeseriesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/coupons/usage/timeseries",
    ...options,
  });

/**
 * Delete Coupon
 */
export const deleteCouponApiV1AdminCouponsCouponIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteCouponApiV1AdminCouponsCouponIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteCouponApiV1AdminCouponsCouponIdDeleteResponses,
    DeleteCouponApiV1AdminCouponsCouponIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/coupons/{coupon_id}",
    ...options,
  });

/**
 * Update Coupon
 */
export const updateCouponApiV1AdminCouponsCouponIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCouponApiV1AdminCouponsCouponIdPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateCouponApiV1AdminCouponsCouponIdPutResponses,
    UpdateCouponApiV1AdminCouponsCouponIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/coupons/{coupon_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Inactivate Coupon
 */
export const inactivateCouponApiV1AdminCouponsCouponIdInactivatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    InactivateCouponApiV1AdminCouponsCouponIdInactivatePostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    InactivateCouponApiV1AdminCouponsCouponIdInactivatePostResponses,
    InactivateCouponApiV1AdminCouponsCouponIdInactivatePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/coupons/{coupon_id}/inactivate",
    ...options,
  });

/**
 * List Features
 *
 * Lista todas as funcionalidades
 */
export const listFeaturesApiV1AdminFeaturesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListFeaturesApiV1AdminFeaturesGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListFeaturesApiV1AdminFeaturesGetResponses,
    ListFeaturesApiV1AdminFeaturesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/features",
    ...options,
  });

/**
 * List Features
 *
 * Lista todas as funcionalidades
 */
export const listFeaturesApiV1AdminFeaturesGet2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListFeaturesApiV1AdminFeaturesGet2Data, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListFeaturesApiV1AdminFeaturesGet2Responses,
    ListFeaturesApiV1AdminFeaturesGet2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/features/",
    ...options,
  });

/**
 * Create Feature
 *
 * Cria nova funcionalidade
 */
export const createFeatureApiV1AdminFeaturesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateFeatureApiV1AdminFeaturesPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateFeatureApiV1AdminFeaturesPostResponses,
    CreateFeatureApiV1AdminFeaturesPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/features/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Categories
 *
 * Lista todas as categorias de funcionalidades
 */
export const listCategoriesApiV1AdminFeaturesCategoriesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListCategoriesApiV1AdminFeaturesCategoriesGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ListCategoriesApiV1AdminFeaturesCategoriesGetResponses,
    ListCategoriesApiV1AdminFeaturesCategoriesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/features/categories",
    ...options,
  });

/**
 * Get Plan Features
 *
 * Lista funcionalidades de um plano específico
 */
export const getPlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetPlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesGetResponses,
    GetPlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/features/plans/{plan_id}/features",
    ...options,
  });

/**
 * Update Plan Features
 *
 * Atualiza funcionalidades de um plano
 */
export const updatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPutResponses,
    UpdatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/features/plans/{plan_id}/features",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Feature
 *
 * Remove uma funcionalidade
 */
export const deleteFeatureApiV1AdminFeaturesFeatureIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteFeatureApiV1AdminFeaturesFeatureIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteFeatureApiV1AdminFeaturesFeatureIdDeleteResponses,
    DeleteFeatureApiV1AdminFeaturesFeatureIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/features/{feature_id}",
    ...options,
  });

/**
 * Get Feature Details
 *
 * Obtém detalhes de uma funcionalidade
 */
export const getFeatureDetailsApiV1AdminFeaturesFeatureIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetFeatureDetailsApiV1AdminFeaturesFeatureIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetFeatureDetailsApiV1AdminFeaturesFeatureIdGetResponses,
    GetFeatureDetailsApiV1AdminFeaturesFeatureIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/features/{feature_id}",
    ...options,
  });

/**
 * Update Feature
 *
 * Atualiza uma funcionalidade
 */
export const updateFeatureApiV1AdminFeaturesFeatureIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateFeatureApiV1AdminFeaturesFeatureIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateFeatureApiV1AdminFeaturesFeatureIdPutResponses,
    UpdateFeatureApiV1AdminFeaturesFeatureIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/features/{feature_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Plans
 *
 * Listar planos com paginação, filtros e estatísticas
 */
export const listPlansApiV1AdminPlansGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPlansApiV1AdminPlansGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListPlansApiV1AdminPlansGetResponses,
    ListPlansApiV1AdminPlansGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/plans",
    ...options,
  });

/**
 * List Plans
 *
 * Listar planos com paginação, filtros e estatísticas
 */
export const listPlansApiV1AdminPlansGet2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPlansApiV1AdminPlansGet2Data, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListPlansApiV1AdminPlansGet2Responses,
    ListPlansApiV1AdminPlansGet2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/plans/",
    ...options,
  });

/**
 * Create Plan
 *
 * Cria novo plano
 */
export const createPlanApiV1AdminPlansPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePlanApiV1AdminPlansPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreatePlanApiV1AdminPlansPostResponses,
    CreatePlanApiV1AdminPlansPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/plans/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Soft Delete Plan
 *
 * Soft delete de um plano (marca como deletado mas mantém no banco)
 */
export const softDeletePlanApiV1AdminPlansPlanIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SoftDeletePlanApiV1AdminPlansPlanIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    SoftDeletePlanApiV1AdminPlansPlanIdDeleteResponses,
    SoftDeletePlanApiV1AdminPlansPlanIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/plans/{plan_id}",
    ...options,
  });

/**
 * Get Plan Details
 *
 * Obtém detalhes completos do plano
 */
export const getPlanDetailsApiV1AdminPlansPlanIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPlanDetailsApiV1AdminPlansPlanIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPlanDetailsApiV1AdminPlansPlanIdGetResponses,
    GetPlanDetailsApiV1AdminPlansPlanIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/plans/{plan_id}",
    ...options,
  });

/**
 * Update Plan
 *
 * Atualiza dados do plano
 */
export const updatePlanApiV1AdminPlansPlanIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePlanApiV1AdminPlansPlanIdPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdatePlanApiV1AdminPlansPlanIdPutResponses,
    UpdatePlanApiV1AdminPlansPlanIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/plans/{plan_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Plan Features
 *
 * Atualiza features do plano
 */
export const updatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPutResponses,
    UpdatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/plans/{plan_id}/features",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reactivate Plan
 *
 * Reativa um plano que foi removido (soft delete)
 */
export const reactivatePlanApiV1AdminPlansPlanIdReactivatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReactivatePlanApiV1AdminPlansPlanIdReactivatePostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ReactivatePlanApiV1AdminPlansPlanIdReactivatePostResponses,
    ReactivatePlanApiV1AdminPlansPlanIdReactivatePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/plans/{plan_id}/reactivate",
    ...options,
  });

/**
 * Validate Coupon
 */
export const validateCouponApiV1PublicCouponsValidateGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ValidateCouponApiV1PublicCouponsValidateGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ValidateCouponApiV1PublicCouponsValidateGetResponses,
    ValidateCouponApiV1PublicCouponsValidateGetErrors,
    ThrowOnError
  >({ url: "/api/v1/public/coupons/validate", ...options });

/**
 * List Public Plans
 */
export const listPublicPlansApiV1PublicPlansGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPublicPlansApiV1PublicPlansGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListPublicPlansApiV1PublicPlansGetResponses,
    ListPublicPlansApiV1PublicPlansGetErrors,
    ThrowOnError
  >({ url: "/api/v1/public/plans", ...options });

/**
 * List Segments
 */
export const listSegmentsApiV1AdminBenchmarkSegmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListSegmentsApiV1AdminBenchmarkSegmentsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ListSegmentsApiV1AdminBenchmarkSegmentsGetResponses,
    ListSegmentsApiV1AdminBenchmarkSegmentsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/benchmark/segments",
    ...options,
  });

/**
 * Create Segment
 */
export const createSegmentApiV1AdminBenchmarkSegmentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateSegmentApiV1AdminBenchmarkSegmentsPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    CreateSegmentApiV1AdminBenchmarkSegmentsPostResponses,
    CreateSegmentApiV1AdminBenchmarkSegmentsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/benchmark/segments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Segment
 */
export const deleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDeleteResponses,
    DeleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/benchmark/segments/{segment_id}",
    ...options,
  });

/**
 * Update Segment
 */
export const updateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPutResponses,
    UpdateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/benchmark/segments/{segment_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Benchmark Stores
 */
export const adminBenchmarkStoresApiV1AdminBenchmarkStoresGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    AdminBenchmarkStoresApiV1AdminBenchmarkStoresGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    AdminBenchmarkStoresApiV1AdminBenchmarkStoresGetResponses,
    AdminBenchmarkStoresApiV1AdminBenchmarkStoresGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/benchmark/stores",
    ...options,
  });

/**
 * Get Recent Activities
 *
 * Obtém atividades recentes
 */
export const getRecentActivitiesApiV1AdminDashboardActivitiesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetRecentActivitiesApiV1AdminDashboardActivitiesGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetRecentActivitiesApiV1AdminDashboardActivitiesGetResponses,
    GetRecentActivitiesApiV1AdminDashboardActivitiesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/activities",
    ...options,
  });

/**
 * Get Recent Alerts
 *
 * Obtém alertas recentes de faturamento
 */
export const getRecentAlertsApiV1AdminDashboardAlertsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetRecentAlertsApiV1AdminDashboardAlertsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetRecentAlertsApiV1AdminDashboardAlertsGetResponses,
    GetRecentAlertsApiV1AdminDashboardAlertsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/alerts",
    ...options,
  });

/**
 * Get Churn Analysis
 *
 * Obtém análise de churn
 */
export const getChurnAnalysisApiV1AdminDashboardChurnAnalysisGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetChurnAnalysisApiV1AdminDashboardChurnAnalysisGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetChurnAnalysisApiV1AdminDashboardChurnAnalysisGetResponses,
    GetChurnAnalysisApiV1AdminDashboardChurnAnalysisGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/churn-analysis",
    ...options,
  });

/**
 * Get Daily Forecast Series
 *
 * Série diária do mês corrente com previsão, pagos e recebidos.
 */
export const getDailyForecastSeriesApiV1AdminDashboardForecastDailyGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetDailyForecastSeriesApiV1AdminDashboardForecastDailyGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetDailyForecastSeriesApiV1AdminDashboardForecastDailyGetResponses,
    GetDailyForecastSeriesApiV1AdminDashboardForecastDailyGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/forecast/daily",
    ...options,
  });

/**
 * Get Growth Metrics
 *
 * Obtém métricas de crescimento para gráficos
 */
export const getGrowthMetricsApiV1AdminDashboardGrowthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetGrowthMetricsApiV1AdminDashboardGrowthGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetGrowthMetricsApiV1AdminDashboardGrowthGetResponses,
    GetGrowthMetricsApiV1AdminDashboardGrowthGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/growth",
    ...options,
  });

/**
 * Get System Health
 *
 * Obtém status de saúde do sistema
 */
export const getSystemHealthApiV1AdminDashboardHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetSystemHealthApiV1AdminDashboardHealthGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetSystemHealthApiV1AdminDashboardHealthGetResponses,
    GetSystemHealthApiV1AdminDashboardHealthGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/health",
    ...options,
  });

/**
 * Update Daily Metrics
 *
 * Força atualização das métricas diárias
 */
export const updateDailyMetricsApiV1AdminDashboardMetricsUpdatePost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    UpdateDailyMetricsApiV1AdminDashboardMetricsUpdatePostData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).post<
    UpdateDailyMetricsApiV1AdminDashboardMetricsUpdatePostResponses,
    UpdateDailyMetricsApiV1AdminDashboardMetricsUpdatePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/metrics/update",
    ...options,
  });

/**
 * Get Revenue Metrics
 *
 * Obtém métricas de receita
 */
export const getRevenueMetricsApiV1AdminDashboardRevenueGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetRevenueMetricsApiV1AdminDashboardRevenueGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetRevenueMetricsApiV1AdminDashboardRevenueGetResponses,
    GetRevenueMetricsApiV1AdminDashboardRevenueGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/revenue",
    ...options,
  });

/**
 * Get Subscription Metrics
 *
 * Obtém métricas de assinaturas
 */
export const getSubscriptionMetricsApiV1AdminDashboardSubscriptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetSubscriptionMetricsApiV1AdminDashboardSubscriptionsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetSubscriptionMetricsApiV1AdminDashboardSubscriptionsGetResponses,
    GetSubscriptionMetricsApiV1AdminDashboardSubscriptionsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/subscriptions",
    ...options,
  });

/**
 * Get Subscription Distribution
 *
 * Obtém distribuição de assinaturas por plano
 */
export const getSubscriptionDistributionApiV1AdminDashboardSubscriptionsDistributionGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetSubscriptionDistributionApiV1AdminDashboardSubscriptionsDistributionGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetSubscriptionDistributionApiV1AdminDashboardSubscriptionsDistributionGetResponses,
      GetSubscriptionDistributionApiV1AdminDashboardSubscriptionsDistributionGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/dashboard/subscriptions/distribution",
      ...options,
    });

/**
 * Get Dashboard Summary
 *
 * Obtém resumo geral do dashboard
 */
export const getDashboardSummaryApiV1AdminDashboardSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetDashboardSummaryApiV1AdminDashboardSummaryGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetDashboardSummaryApiV1AdminDashboardSummaryGetResponses,
    GetDashboardSummaryApiV1AdminDashboardSummaryGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/summary",
    ...options,
  });

/**
 * Get Top Plans
 *
 * Obtém os planos mais populares
 */
export const getTopPlansApiV1AdminDashboardTopPlansGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetTopPlansApiV1AdminDashboardTopPlansGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetTopPlansApiV1AdminDashboardTopPlansGetResponses,
    GetTopPlansApiV1AdminDashboardTopPlansGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/top-plans",
    ...options,
  });

/**
 * Get User Metrics
 *
 * Obtém métricas de usuários
 */
export const getUserMetricsApiV1AdminDashboardUsersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetUserMetricsApiV1AdminDashboardUsersGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetUserMetricsApiV1AdminDashboardUsersGetResponses,
    GetUserMetricsApiV1AdminDashboardUsersGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/dashboard/users",
    ...options,
  });

/**
 * List Data Deletion Requests
 */
export const listDataDeletionRequestsApiV1AdminDataDeletionGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListDataDeletionRequestsApiV1AdminDataDeletionGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ListDataDeletionRequestsApiV1AdminDataDeletionGetResponses,
    ListDataDeletionRequestsApiV1AdminDataDeletionGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/data-deletion",
    ...options,
  });

/**
 * List Data Deletion Requests
 */
export const listDataDeletionRequestsApiV1AdminDataDeletionGet2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListDataDeletionRequestsApiV1AdminDataDeletionGet2Data,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ListDataDeletionRequestsApiV1AdminDataDeletionGet2Responses,
    ListDataDeletionRequestsApiV1AdminDataDeletionGet2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/data-deletion/",
    ...options,
  });

/**
 * List AI Prompts
 */
export const apiV1AdminAiPromptsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ApiV1AdminAiPromptsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiV1AdminAiPromptsGetResponses,
    ApiV1AdminAiPromptsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/ai-prompts",
    ...options,
  });

/**
 * Reset AI Prompt
 */
export const apiV1AdminAiPromptsKeyDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1AdminAiPromptsKeyDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ApiV1AdminAiPromptsKeyDeleteResponses,
    ApiV1AdminAiPromptsKeyDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/ai-prompts/{key}",
    ...options,
  });

/**
 * Update AI Prompt
 */
export const apiV1AdminAiPromptsKeyPut = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1AdminAiPromptsKeyPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ApiV1AdminAiPromptsKeyPutResponses,
    ApiV1AdminAiPromptsKeyPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/ai-prompts/{key}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Settings
 *
 * Get current system settings
 */
export const getSettingsApiV1AdminSettingsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSettingsApiV1AdminSettingsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSettingsApiV1AdminSettingsGetResponses,
    GetSettingsApiV1AdminSettingsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/settings",
    ...options,
  });

/**
 * Update Settings
 *
 * Update system settings
 */
export const updateSettingsApiV1AdminSettingsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateSettingsApiV1AdminSettingsPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateSettingsApiV1AdminSettingsPutResponses,
    UpdateSettingsApiV1AdminSettingsPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Settings
 *
 * Get current system settings
 */
export const getSettingsApiV1AdminSettingsGet2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSettingsApiV1AdminSettingsGet2Data, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSettingsApiV1AdminSettingsGet2Responses,
    GetSettingsApiV1AdminSettingsGet2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/settings/",
    ...options,
  });

/**
 * Update Settings
 *
 * Update system settings
 */
export const updateSettingsApiV1AdminSettingsPut2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateSettingsApiV1AdminSettingsPut2Data, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateSettingsApiV1AdminSettingsPut2Responses,
    UpdateSettingsApiV1AdminSettingsPut2Errors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/settings/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Maintenance Status
 *
 * Get current maintenance mode status
 */
export const getMaintenanceStatusApiV1AdminSettingsMaintenanceModeStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMaintenanceStatusApiV1AdminSettingsMaintenanceModeStatusGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetMaintenanceStatusApiV1AdminSettingsMaintenanceModeStatusGetResponses,
    GetMaintenanceStatusApiV1AdminSettingsMaintenanceModeStatusGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/settings/maintenance-mode/status",
    ...options,
  });

/**
 * Toggle Maintenance Mode
 *
 * Toggle maintenance mode on/off with admin password verification
 */
export const toggleMaintenanceModeApiV1AdminSettingsMaintenanceModeTogglePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ToggleMaintenanceModeApiV1AdminSettingsMaintenanceModeTogglePostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      ToggleMaintenanceModeApiV1AdminSettingsMaintenanceModeTogglePostResponses,
      ToggleMaintenanceModeApiV1AdminSettingsMaintenanceModeTogglePostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/admin/settings/maintenance-mode/toggle",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Admin Storage
 *
 * Get per-customer database storage usage in bytes, grouped by integration family.
 *
 * For Nexus-native sort fields (customer_uuid, total_max_bytes, updated_at) the
 * sort is delegated to Nexus — we fetch only the requested page, enrich, and return.
 *
 * For local-only sort fields (customer_name, customer_email, total_bytes) we fetch
 * all matching records from Nexus, enrich, sort locally, then paginate to maintain
 * correct ordering across the full result set.
 */
export const getAdminStorageApiV1AdminStorageGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAdminStorageApiV1AdminStorageGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetAdminStorageApiV1AdminStorageGetResponses,
    GetAdminStorageApiV1AdminStorageGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/storage",
    ...options,
  });

/**
 * Set Storage Limits
 *
 * Set per-customer storage limit. Sends customer_uuid and total_max_bytes to Nexus.
 * total_max_bytes must be >= 0: 0 freezes data (no new syncs), positive sets a cap.
 * Pass via the admin dashboard or API directly.
 */
export const setStorageLimitsApiV1AdminStorageLimitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetStorageLimitsApiV1AdminStorageLimitsPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SetStorageLimitsApiV1AdminStorageLimitsPostResponses,
    SetStorageLimitsApiV1AdminStorageLimitsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/storage/limits",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Receive Asaas Webhook
 */
export const receiveAsaasWebhookApiV1WebhooksAsaasPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ReceiveAsaasWebhookApiV1WebhooksAsaasPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReceiveAsaasWebhookApiV1WebhooksAsaasPostResponses,
    ReceiveAsaasWebhookApiV1WebhooksAsaasPostErrors,
    ThrowOnError
  >({
    url: "/api/v1/webhooks/asaas",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Sync Config
 *
 * Atualizar configurações do sistema de sincronização
 */
export const updateSyncConfigApiV1AdminSyncConfigPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateSyncConfigApiV1AdminSyncConfigPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateSyncConfigApiV1AdminSyncConfigPutResponses,
    UpdateSyncConfigApiV1AdminSyncConfigPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/sync/config",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Disable Sync
 *
 * Desabilitar sistema de sincronização
 */
export const disableSyncApiV1AdminSyncDisablePost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DisableSyncApiV1AdminSyncDisablePostData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    DisableSyncApiV1AdminSyncDisablePostResponses,
    DisableSyncApiV1AdminSyncDisablePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/sync/disable",
    ...options,
  });

/**
 * Enable Sync
 *
 * Habilitar sistema de sincronização
 */
export const enableSyncApiV1AdminSyncEnablePost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<EnableSyncApiV1AdminSyncEnablePostData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    EnableSyncApiV1AdminSyncEnablePostResponses,
    EnableSyncApiV1AdminSyncEnablePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/sync/enable",
    ...options,
  });

/**
 * Force Sync Integration
 *
 * Forçar sincronização manual de uma integração
 */
export const forceSyncIntegrationApiV1AdminSyncForceSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ForceSyncIntegrationApiV1AdminSyncForceSyncPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    ForceSyncIntegrationApiV1AdminSyncForceSyncPostResponses,
    ForceSyncIntegrationApiV1AdminSyncForceSyncPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/sync/force-sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Sync Health
 *
 * Health check do sistema de sincronização
 */
export const getSyncHealthApiV1AdminSyncHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSyncHealthApiV1AdminSyncHealthGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSyncHealthApiV1AdminSyncHealthGetResponses,
    GetSyncHealthApiV1AdminSyncHealthGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/sync/health",
    ...options,
  });

/**
 * Get Integration Types
 *
 * Listar tipos de integração disponíveis
 */
export const getIntegrationTypesApiV1AdminSyncIntegrationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetIntegrationTypesApiV1AdminSyncIntegrationsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetIntegrationTypesApiV1AdminSyncIntegrationsGetResponses,
    GetIntegrationTypesApiV1AdminSyncIntegrationsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/sync/integrations",
    ...options,
  });

/**
 * Get Sync Stats
 *
 * Obter estatísticas detalhadas de sincronização
 */
export const getSyncStatsApiV1AdminSyncStatsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSyncStatsApiV1AdminSyncStatsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSyncStatsApiV1AdminSyncStatsGetResponses,
    GetSyncStatsApiV1AdminSyncStatsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/sync/stats",
    ...options,
  });

/**
 * Get Sync Status
 *
 * Obter status atual do sistema de sincronização
 */
export const getSyncStatusApiV1AdminSyncStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSyncStatusApiV1AdminSyncStatusGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSyncStatusApiV1AdminSyncStatusGetResponses,
    GetSyncStatusApiV1AdminSyncStatusGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/sync/status",
    ...options,
  });

/**
 * Get Available Accounts
 *
 * Lista todas as contas disponíveis após OAuth
 *
 * Para Google: GA4 properties, Google Ads accounts, Search Console sites
 * Para Meta: Meta Ads accounts, Instagram pages
 */
export const getAvailableAccountsApiV1ExternalAccountsAvailableGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAvailableAccountsApiV1ExternalAccountsAvailableGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAvailableAccountsApiV1ExternalAccountsAvailableGetResponses,
    GetAvailableAccountsApiV1ExternalAccountsAvailableGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/external-accounts/available",
    ...options,
  });

/**
 * Select Accounts
 *
 * Salva as contas selecionadas pelo usuário e dispara sincronização
 * com storage enforcement por conta.
 *
 * - Salva contas em external_accounts com is_active=true
 * - Dispara sync ou backfill individual por conta (com account_uuid para storage check)
 */
export const selectAccountsApiV1ExternalAccountsSelectPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SelectAccountsApiV1ExternalAccountsSelectPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SelectAccountsApiV1ExternalAccountsSelectPostResponses,
    SelectAccountsApiV1ExternalAccountsSelectPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/external-accounts/select",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Selected Accounts
 *
 * Lista as contas já selecionadas e ativas do usuário
 */
export const getSelectedAccountsApiV1ExternalAccountsSelectedGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetSelectedAccountsApiV1ExternalAccountsSelectedGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetSelectedAccountsApiV1ExternalAccountsSelectedGetResponses,
    GetSelectedAccountsApiV1ExternalAccountsSelectedGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/external-accounts/selected",
    ...options,
  });

/**
 * Get Integration Auth Url
 *
 * Obter URL de autenticação OAuth do microsserviço Nexus
 *
 * Args:
 * source: Fonte da integração (google_analytics, meta_ads, etc.)
 * account_id: ID opcional da conta específica
 * current_user: Usuário autenticado
 * db: Sessão do banco de dados
 *
 * Returns:
 * Dict com URL de autenticação e estado
 */
export const getIntegrationAuthUrlApiV1IntegrationsNexusAuthUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIntegrationAuthUrlApiV1IntegrationsNexusAuthUrlGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetIntegrationAuthUrlApiV1IntegrationsNexusAuthUrlGetResponses,
    GetIntegrationAuthUrlApiV1IntegrationsNexusAuthUrlGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/nexus/auth-url",
    ...options,
  });

/**
 * Integration Oauth Callback
 *
 * Callback OAuth que processa a resposta através do microsserviço
 *
 * Args:
 * code: Código de autorização
 * state: Estado do OAuth
 * db: Sessão do banco de dados
 *
 * Returns:
 * Redirect para o frontend com resultado
 */
export const integrationOauthCallbackApiV1IntegrationsNexusCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    IntegrationOauthCallbackApiV1IntegrationsNexusCallbackGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    unknown,
    IntegrationOauthCallbackApiV1IntegrationsNexusCallbackGetErrors,
    ThrowOnError
  >({ url: "/api/v1/integrations/nexus/callback", ...options });

/**
 * Disconnect Integration
 *
 * Endpoint centralizado para desconectar qualquer integração.
 *
 * Remove credenciais e limpa todos os dados de métricas do customer_uuid
 * no microsserviço nexus-integrations.
 *
 * Args:
 * source: Fonte da integração (google, meta, google_analytics, meta_ads, search_console, instagram_insights)
 * customer_uuid: UUID do cliente (subconta).
 *
 * Returns:
 * Resultado da desconexão incluindo estatísticas de limpeza
 */
export const disconnectIntegrationApiV1IntegrationsNexusDisconnectDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DisconnectIntegrationApiV1IntegrationsNexusDisconnectDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DisconnectIntegrationApiV1IntegrationsNexusDisconnectDeleteResponses,
    DisconnectIntegrationApiV1IntegrationsNexusDisconnectDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/nexus/disconnect",
    ...options,
  });

/**
 * Get Google Ads Auth Url
 *
 * Endpoint específico para Google Ads (compatibilidade)
 */
export const getGoogleAdsAuthUrlApiV1IntegrationsNexusGoogleAdsAuthUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetGoogleAdsAuthUrlApiV1IntegrationsNexusGoogleAdsAuthUrlGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetGoogleAdsAuthUrlApiV1IntegrationsNexusGoogleAdsAuthUrlGetResponses,
    GetGoogleAdsAuthUrlApiV1IntegrationsNexusGoogleAdsAuthUrlGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/nexus/google-ads/auth-url",
    ...options,
  });

/**
 * Get Google Analytics Auth Url
 *
 * Endpoint específico para Google Analytics (compatibilidade)
 */
export const getGoogleAnalyticsAuthUrlApiV1IntegrationsNexusGoogleAnalyticsAuthUrlGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetGoogleAnalyticsAuthUrlApiV1IntegrationsNexusGoogleAnalyticsAuthUrlGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetGoogleAnalyticsAuthUrlApiV1IntegrationsNexusGoogleAnalyticsAuthUrlGetResponses,
      GetGoogleAnalyticsAuthUrlApiV1IntegrationsNexusGoogleAnalyticsAuthUrlGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/nexus/google-analytics/auth-url",
      ...options,
    });

/**
 * Get Instagram Insights Auth Url
 *
 * Endpoint específico para Instagram Insights (compatibilidade)
 */
export const getInstagramInsightsAuthUrlApiV1IntegrationsNexusInstagramInsightsAuthUrlGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetInstagramInsightsAuthUrlApiV1IntegrationsNexusInstagramInsightsAuthUrlGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetInstagramInsightsAuthUrlApiV1IntegrationsNexusInstagramInsightsAuthUrlGetResponses,
      GetInstagramInsightsAuthUrlApiV1IntegrationsNexusInstagramInsightsAuthUrlGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/nexus/instagram-insights/auth-url",
      ...options,
    });

/**
 * Get Meta Ads Auth Url
 *
 * Endpoint específico para Meta Ads (compatibilidade)
 */
export const getMetaAdsAuthUrlApiV1IntegrationsNexusMetaAdsAuthUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMetaAdsAuthUrlApiV1IntegrationsNexusMetaAdsAuthUrlGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetMetaAdsAuthUrlApiV1IntegrationsNexusMetaAdsAuthUrlGetResponses,
    GetMetaAdsAuthUrlApiV1IntegrationsNexusMetaAdsAuthUrlGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/nexus/meta-ads/auth-url",
    ...options,
  });

/**
 * Refresh Integration Token
 *
 * Renovar token de integração através do microsserviço
 *
 * Args:
 * source: Fonte da integração
 * account_id: ID opcional da conta específica
 * current_user: Usuário autenticado
 * db: Sessão do banco de dados
 *
 * Returns:
 * Dados do novo token
 */
export const refreshIntegrationTokenApiV1IntegrationsNexusRefreshTokenPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RefreshIntegrationTokenApiV1IntegrationsNexusRefreshTokenPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    RefreshIntegrationTokenApiV1IntegrationsNexusRefreshTokenPostResponses,
    RefreshIntegrationTokenApiV1IntegrationsNexusRefreshTokenPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/nexus/refresh-token",
    ...options,
  });

/**
 * Get Search Console Auth Url
 *
 * Endpoint específico para Search Console (compatibilidade)
 */
export const getSearchConsoleAuthUrlApiV1IntegrationsNexusSearchConsoleAuthUrlGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetSearchConsoleAuthUrlApiV1IntegrationsNexusSearchConsoleAuthUrlGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetSearchConsoleAuthUrlApiV1IntegrationsNexusSearchConsoleAuthUrlGetResponses,
      GetSearchConsoleAuthUrlApiV1IntegrationsNexusSearchConsoleAuthUrlGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/nexus/search-console/auth-url",
      ...options,
    });

/**
 * Get Oauth Auth Url
 *
 * Proxy para obter URL de autenticação OAuth do Nexus Integrations
 */
export const getOauthAuthUrlApiV1OauthAuthUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOauthAuthUrlApiV1OauthAuthUrlGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetOauthAuthUrlApiV1OauthAuthUrlGetResponses,
    GetOauthAuthUrlApiV1OauthAuthUrlGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/oauth/auth-url",
    ...options,
  });

/**
 * Oauth Callback Proxy
 *
 * Proxy do callback OAuth para o microsserviço Nexus Integrations
 */
export const oauthCallbackProxyApiV1OauthCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<OauthCallbackProxyApiV1OauthCallbackGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    unknown,
    OauthCallbackProxyApiV1OauthCallbackGetErrors,
    ThrowOnError
  >({ url: "/api/v1/oauth/callback", ...options });

/**
 * Refresh Oauth Token
 *
 * Proxy para renovar token OAuth através do Nexus Integrations
 */
export const refreshOauthTokenApiV1OauthRefreshPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RefreshOauthTokenApiV1OauthRefreshPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RefreshOauthTokenApiV1OauthRefreshPostResponses,
    RefreshOauthTokenApiV1OauthRefreshPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/oauth/refresh",
    ...options,
  });

/**
 * Trigger Sync
 */
export const triggerSyncApiV1SyncPost = <ThrowOnError extends boolean = false>(
  options: Options<TriggerSyncApiV1SyncPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TriggerSyncApiV1SyncPostResponses,
    TriggerSyncApiV1SyncPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Customer Sync Status
 *
 * Proxy para o endpoint do Nexus `/api/v1/sync/status`.
 *
 * - Aceita `customer_uuid` via query; se ausente, usa o `id` do usuário atual.
 * - Encaminha o header `X-API-Key` via serviço configurado.
 */
export const getCustomerSyncStatusApiV1SyncStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCustomerSyncStatusApiV1SyncStatusGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetCustomerSyncStatusApiV1SyncStatusGetResponses,
    GetCustomerSyncStatusApiV1SyncStatusGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sync/status",
    ...options,
  });

/**
 * Get Sync Job Status
 *
 * Proxy para o endpoint do Nexus `/api/v1/sync/{job_id}`.
 *
 * Retorna o status de um job de sincronização específico.
 */
export const getSyncJobStatusApiV1SyncJobIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSyncJobStatusApiV1SyncJobIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSyncJobStatusApiV1SyncJobIdGetResponses,
    GetSyncJobStatusApiV1SyncJobIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sync/{job_id}",
    ...options,
  });

/**
 * Get Ga4 Properties
 *
 * Lista properties GA4 disponíveis para o cliente
 */
export const getGa4PropertiesApiV1AnalyticsGa4PropertiesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetGa4PropertiesApiV1AnalyticsGa4PropertiesGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetGa4PropertiesApiV1AnalyticsGa4PropertiesGetResponses,
    GetGa4PropertiesApiV1AnalyticsGa4PropertiesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/analytics/ga4/properties",
    ...options,
  });

/**
 * Get Google Analytics Accounts
 *
 * Lista contas do Google Analytics acessíveis
 */
export const getGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsAccountsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsAccountsGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsAccountsGetResponses,
      GetGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsAccountsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/accounts",
      ...options,
    });

/**
 * Get Advanced Metrics
 *
 * Métricas avançadas do Google Analytics com dados demográficos e de conteúdo
 */
export const getAdvancedMetricsApiV1IntegrationsGoogleAnalyticsAdvancedMetricsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAdvancedMetricsApiV1IntegrationsGoogleAnalyticsAdvancedMetricsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAdvancedMetricsApiV1IntegrationsGoogleAnalyticsAdvancedMetricsGetResponses,
      GetAdvancedMetricsApiV1IntegrationsGoogleAnalyticsAdvancedMetricsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/advanced-metrics",
      ...options,
    });

/**
 * Get Google Analytics Auth Url
 *
 * Gera URL de autenticação OAuth para Google Analytics
 */
export const getGoogleAnalyticsAuthUrlApiV1IntegrationsGoogleAnalyticsAuthUrlGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetGoogleAnalyticsAuthUrlApiV1IntegrationsGoogleAnalyticsAuthUrlGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetGoogleAnalyticsAuthUrlApiV1IntegrationsGoogleAnalyticsAuthUrlGetResponses,
      GetGoogleAnalyticsAuthUrlApiV1IntegrationsGoogleAnalyticsAuthUrlGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/auth-url",
      ...options,
    });

/**
 * Google Analytics Oauth Callback
 *
 * Callback para processar resposta OAuth do Google Analytics
 */
export const googleAnalyticsOauthCallbackApiV1IntegrationsGoogleAnalyticsCallbackGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GoogleAnalyticsOauthCallbackApiV1IntegrationsGoogleAnalyticsCallbackGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      unknown,
      GoogleAnalyticsOauthCallbackApiV1IntegrationsGoogleAnalyticsCallbackGetErrors,
      ThrowOnError
    >({ url: "/api/v1/integrations/google-analytics/callback", ...options });

/**
 * Get Complete Data
 *
 * Recuperar dados completos Google Analytics (métricas + demographics + content + realtime + geography + technology)
 */
export const getCompleteDataApiV1IntegrationsGoogleAnalyticsCompleteDataGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCompleteDataApiV1IntegrationsGoogleAnalyticsCompleteDataGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCompleteDataApiV1IntegrationsGoogleAnalyticsCompleteDataGetResponses,
    GetCompleteDataApiV1IntegrationsGoogleAnalyticsCompleteDataGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-analytics/complete-data",
    ...options,
  });

/**
 * Disconnect Google Analytics
 *
 * Desconecta integração com Google Analytics
 *
 * Quando usuário desconecta:
 * 1. Remove credenciais de autenticação no backend
 * 2. Faz proxy para nexus-integrations desativar contas e limpar métricas
 *
 * IMPORTANTE: customer_uuid é obrigatório para garantir limpeza no tenant correto.
 */
export const disconnectGoogleAnalyticsApiV1IntegrationsGoogleAnalyticsDisconnectDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DisconnectGoogleAnalyticsApiV1IntegrationsGoogleAnalyticsDisconnectDeleteData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).delete<
      DisconnectGoogleAnalyticsApiV1IntegrationsGoogleAnalyticsDisconnectDeleteResponses,
      DisconnectGoogleAnalyticsApiV1IntegrationsGoogleAnalyticsDisconnectDeleteErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/disconnect",
      ...options,
    });

/**
 * Get Google Analytics Geography
 *
 * Dados geográficos do Google Analytics
 */
export const getGoogleAnalyticsGeographyApiV1IntegrationsGoogleAnalyticsGeographyGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAnalyticsGeographyApiV1IntegrationsGoogleAnalyticsGeographyGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAnalyticsGeographyApiV1IntegrationsGoogleAnalyticsGeographyGetResponses,
      GetGoogleAnalyticsGeographyApiV1IntegrationsGoogleAnalyticsGeographyGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/geography",
      ...options,
    });

/**
 * Get Google Analytics Metrics
 *
 * Recupera métricas do Google Analytics
 */
export const getGoogleAnalyticsMetricsApiV1IntegrationsGoogleAnalyticsMetricsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAnalyticsMetricsApiV1IntegrationsGoogleAnalyticsMetricsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAnalyticsMetricsApiV1IntegrationsGoogleAnalyticsMetricsGetResponses,
      GetGoogleAnalyticsMetricsApiV1IntegrationsGoogleAnalyticsMetricsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/metrics",
      ...options,
    });

/**
 * Get Google Analytics Overview
 *
 * Dados consolidados para overview/dashboard de uma propriedade específica
 */
export const getGoogleAnalyticsOverviewApiV1IntegrationsGoogleAnalyticsOverviewGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAnalyticsOverviewApiV1IntegrationsGoogleAnalyticsOverviewGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAnalyticsOverviewApiV1IntegrationsGoogleAnalyticsOverviewGetResponses,
      GetGoogleAnalyticsOverviewApiV1IntegrationsGoogleAnalyticsOverviewGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/overview",
      ...options,
    });

/**
 * Get Consolidated Overview
 *
 * Dados consolidados de TODAS as propriedades GA4 ou propriedades específicas
 */
export const getConsolidatedOverviewApiV1IntegrationsGoogleAnalyticsOverviewConsolidatedGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetConsolidatedOverviewApiV1IntegrationsGoogleAnalyticsOverviewConsolidatedGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetConsolidatedOverviewApiV1IntegrationsGoogleAnalyticsOverviewConsolidatedGetResponses,
      GetConsolidatedOverviewApiV1IntegrationsGoogleAnalyticsOverviewConsolidatedGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/overview-consolidated",
      ...options,
    });

/**
 * Get Google Analytics Page Metrics
 *
 * Métricas de páginas do Google Analytics
 */
export const getGoogleAnalyticsPageMetricsApiV1IntegrationsGoogleAnalyticsPagesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAnalyticsPageMetricsApiV1IntegrationsGoogleAnalyticsPagesGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAnalyticsPageMetricsApiV1IntegrationsGoogleAnalyticsPagesGetResponses,
      GetGoogleAnalyticsPageMetricsApiV1IntegrationsGoogleAnalyticsPagesGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/pages",
      ...options,
    });

/**
 * Get Performance Insights
 *
 * Insights de performance avançados com KPIs calculados
 */
export const getPerformanceInsightsApiV1IntegrationsGoogleAnalyticsPerformanceInsightsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPerformanceInsightsApiV1IntegrationsGoogleAnalyticsPerformanceInsightsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetPerformanceInsightsApiV1IntegrationsGoogleAnalyticsPerformanceInsightsGetResponses,
      GetPerformanceInsightsApiV1IntegrationsGoogleAnalyticsPerformanceInsightsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/performance-insights",
      ...options,
    });

/**
 * Get Google Analytics Realtime
 *
 * Dados em tempo real do Google Analytics
 */
export const getGoogleAnalyticsRealtimeApiV1IntegrationsGoogleAnalyticsRealtimeGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAnalyticsRealtimeApiV1IntegrationsGoogleAnalyticsRealtimeGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAnalyticsRealtimeApiV1IntegrationsGoogleAnalyticsRealtimeGetResponses,
      GetGoogleAnalyticsRealtimeApiV1IntegrationsGoogleAnalyticsRealtimeGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/realtime",
      ...options,
    });

/**
 * Get Google Analytics Status
 *
 * Verifica status da conexão com Google Analytics
 */
export const getGoogleAnalyticsStatusApiV1IntegrationsGoogleAnalyticsStatusGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetGoogleAnalyticsStatusApiV1IntegrationsGoogleAnalyticsStatusGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetGoogleAnalyticsStatusApiV1IntegrationsGoogleAnalyticsStatusGetResponses,
      GetGoogleAnalyticsStatusApiV1IntegrationsGoogleAnalyticsStatusGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/status",
      ...options,
    });

/**
 * Sync Google Analytics Data
 */
export const syncGoogleAnalyticsDataApiV1IntegrationsGoogleAnalyticsSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncGoogleAnalyticsDataApiV1IntegrationsGoogleAnalyticsSyncPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SyncGoogleAnalyticsDataApiV1IntegrationsGoogleAnalyticsSyncPostResponses,
    SyncGoogleAnalyticsDataApiV1IntegrationsGoogleAnalyticsSyncPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-analytics/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sync Google Analytics Accounts
 *
 * Sincroniza contas/propriedades do Google Analytics
 */
export const syncGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsSyncAccountsPost =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      SyncGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsSyncAccountsPostData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).post<
      SyncGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsSyncAccountsPostResponses,
      SyncGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsSyncAccountsPostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/sync-accounts",
      ...options,
    });

/**
 * Sync Advanced Data
 *
 * Sincronizar dados avançados do Google Analytics
 */
export const syncAdvancedDataApiV1IntegrationsGoogleAnalyticsSyncAdvancedPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SyncAdvancedDataApiV1IntegrationsGoogleAnalyticsSyncAdvancedPostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      SyncAdvancedDataApiV1IntegrationsGoogleAnalyticsSyncAdvancedPostResponses,
      SyncAdvancedDataApiV1IntegrationsGoogleAnalyticsSyncAdvancedPostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/sync-advanced",
      ...options,
    });

/**
 * Sync All Properties
 *
 * Sincroniza dados de TODAS as propriedades Google Analytics do usuário
 */
export const syncAllPropertiesApiV1IntegrationsGoogleAnalyticsSyncAllPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SyncAllPropertiesApiV1IntegrationsGoogleAnalyticsSyncAllPostData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).post<
    SyncAllPropertiesApiV1IntegrationsGoogleAnalyticsSyncAllPostResponses,
    SyncAllPropertiesApiV1IntegrationsGoogleAnalyticsSyncAllPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-analytics/sync-all",
    ...options,
  });

/**
 * Sync Complete Data
 *
 * Sincronização completa Google Analytics (todas as tabelas)
 */
export const syncCompleteDataApiV1IntegrationsGoogleAnalyticsSyncCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SyncCompleteDataApiV1IntegrationsGoogleAnalyticsSyncCompletePostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      SyncCompleteDataApiV1IntegrationsGoogleAnalyticsSyncCompletePostResponses,
      SyncCompleteDataApiV1IntegrationsGoogleAnalyticsSyncCompletePostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/sync-complete",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Google Analytics Technology
 *
 * Dados de tecnologia do Google Analytics
 */
export const getGoogleAnalyticsTechnologyApiV1IntegrationsGoogleAnalyticsTechnologyGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAnalyticsTechnologyApiV1IntegrationsGoogleAnalyticsTechnologyGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAnalyticsTechnologyApiV1IntegrationsGoogleAnalyticsTechnologyGetResponses,
      GetGoogleAnalyticsTechnologyApiV1IntegrationsGoogleAnalyticsTechnologyGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-analytics/technology",
      ...options,
    });

/**
 * Get Google Ads Manager Total
 *
 * # ENDPOINT EM USO NA PÁGINA Visão Geral - Card GOOGLE ADS GERENCIADOR (TOTAL)
 */
export const getGoogleAdsManagerTotalApiV1GoogleAdsManagerTotalGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoogleAdsManagerTotalApiV1GoogleAdsManagerTotalGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetGoogleAdsManagerTotalApiV1GoogleAdsManagerTotalGetResponses,
    GetGoogleAdsManagerTotalApiV1GoogleAdsManagerTotalGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/google-ads-manager-total",
    ...options,
  });

/**
 * Get Google Ads Accounts
 *
 * Lista contas do Google Ads acessíveis
 */
export const getGoogleAdsAccountsApiV1IntegrationsGoogleAdsAccountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetGoogleAdsAccountsApiV1IntegrationsGoogleAdsAccountsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetGoogleAdsAccountsApiV1IntegrationsGoogleAdsAccountsGetResponses,
    GetGoogleAdsAccountsApiV1IntegrationsGoogleAdsAccountsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-ads/accounts",
    ...options,
  });

/**
 * Get Google Ads Ad Performance
 *
 * Performance detalhada de anúncios individuais
 */
export const getGoogleAdsAdPerformanceApiV1IntegrationsGoogleAdsAdPerformanceGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAdsAdPerformanceApiV1IntegrationsGoogleAdsAdPerformanceGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAdsAdPerformanceApiV1IntegrationsGoogleAdsAdPerformanceGetResponses,
      GetGoogleAdsAdPerformanceApiV1IntegrationsGoogleAdsAdPerformanceGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-ads/ad-performance",
      ...options,
    });

/**
 * Get Google Ads Auth Url
 *
 * Gera URL de autenticação OAuth para Google Ads
 */
export const getGoogleAdsAuthUrlApiV1IntegrationsGoogleAdsAuthUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetGoogleAdsAuthUrlApiV1IntegrationsGoogleAdsAuthUrlGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetGoogleAdsAuthUrlApiV1IntegrationsGoogleAdsAuthUrlGetResponses,
    GetGoogleAdsAuthUrlApiV1IntegrationsGoogleAdsAuthUrlGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-ads/auth-url",
    ...options,
  });

/**
 * Google Ads Oauth Callback
 *
 * Callback para processar resposta OAuth do Google Ads
 */
export const googleAdsOauthCallbackApiV1IntegrationsGoogleAdsCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GoogleAdsOauthCallbackApiV1IntegrationsGoogleAdsCallbackGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    unknown,
    GoogleAdsOauthCallbackApiV1IntegrationsGoogleAdsCallbackGetErrors,
    ThrowOnError
  >({ url: "/api/v1/integrations/google-ads/callback", ...options });

/**
 * Get Google Ads Campaigns
 *
 * Lista campanhas de uma conta específica
 */
export const getGoogleAdsCampaignsApiV1IntegrationsGoogleAdsCampaignsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoogleAdsCampaignsApiV1IntegrationsGoogleAdsCampaignsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetGoogleAdsCampaignsApiV1IntegrationsGoogleAdsCampaignsGetResponses,
    GetGoogleAdsCampaignsApiV1IntegrationsGoogleAdsCampaignsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-ads/campaigns",
    ...options,
  });

/**
 * Get Google Ads City Metrics
 *
 * Proxy para obter métricas por cidade do Google Ads via nexus-integrations
 */
export const getGoogleAdsCityMetricsApiV1IntegrationsGoogleAdsCityMetricsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoogleAdsCityMetricsApiV1IntegrationsGoogleAdsCityMetricsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetGoogleAdsCityMetricsApiV1IntegrationsGoogleAdsCityMetricsGetResponses,
    GetGoogleAdsCityMetricsApiV1IntegrationsGoogleAdsCityMetricsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-ads/city-metrics",
    ...options,
  });

/**
 * Get Complete Google Ads Data
 *
 * Dados completos do Google Ads com todas as métricas avançadas
 */
export const getCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsCompleteDataGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsCompleteDataGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsCompleteDataGetResponses,
      GetCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsCompleteDataGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-ads/complete-data",
      ...options,
    });

/**
 * Get Google Ads Demographics
 *
 * Dados demográficos detalhados do Google Ads
 */
export const getGoogleAdsDemographicsApiV1IntegrationsGoogleAdsDemographicsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAdsDemographicsApiV1IntegrationsGoogleAdsDemographicsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAdsDemographicsApiV1IntegrationsGoogleAdsDemographicsGetResponses,
      GetGoogleAdsDemographicsApiV1IntegrationsGoogleAdsDemographicsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-ads/demographics",
      ...options,
    });

/**
 * Get Google Ads Device Metrics
 *
 * Proxy para obter métricas por dispositivo do Google Ads via nexus-integrations
 */
export const getGoogleAdsDeviceMetricsApiV1IntegrationsGoogleAdsDeviceMetricsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAdsDeviceMetricsApiV1IntegrationsGoogleAdsDeviceMetricsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAdsDeviceMetricsApiV1IntegrationsGoogleAdsDeviceMetricsGetResponses,
      GetGoogleAdsDeviceMetricsApiV1IntegrationsGoogleAdsDeviceMetricsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-ads/device-metrics",
      ...options,
    });

/**
 * Disconnect Google Ads
 *
 * Desconecta integração com Google Ads
 *
 * Quando usuário desconecta:
 * 1. Remove credenciais de autenticação no backend
 * 2. Faz proxy para nexus-integrations desativar contas e limpar métricas
 *
 * IMPORTANTE: customer_uuid é obrigatório para garantir limpeza no tenant correto.
 */
export const disconnectGoogleAdsApiV1IntegrationsGoogleAdsDisconnectDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DisconnectGoogleAdsApiV1IntegrationsGoogleAdsDisconnectDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DisconnectGoogleAdsApiV1IntegrationsGoogleAdsDisconnectDeleteResponses,
    DisconnectGoogleAdsApiV1IntegrationsGoogleAdsDisconnectDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-ads/disconnect",
    ...options,
  });

/**
 * Get Google Ads Extensions Performance
 *
 * Performance das extensões de anúncios
 */
export const getGoogleAdsExtensionsPerformanceApiV1IntegrationsGoogleAdsExtensionsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAdsExtensionsPerformanceApiV1IntegrationsGoogleAdsExtensionsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAdsExtensionsPerformanceApiV1IntegrationsGoogleAdsExtensionsGetResponses,
      GetGoogleAdsExtensionsPerformanceApiV1IntegrationsGoogleAdsExtensionsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-ads/extensions",
      ...options,
    });

/**
 * Get Google Ads Geographic Performance
 *
 * Performance geográfica detalhada do Google Ads
 */
export const getGoogleAdsGeographicPerformanceApiV1IntegrationsGoogleAdsGeographicGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAdsGeographicPerformanceApiV1IntegrationsGoogleAdsGeographicGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAdsGeographicPerformanceApiV1IntegrationsGoogleAdsGeographicGetResponses,
      GetGoogleAdsGeographicPerformanceApiV1IntegrationsGoogleAdsGeographicGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-ads/geographic",
      ...options,
    });

/**
 * Get Google Ads Hourly Metrics
 *
 * Proxy para obter métricas por hora do Google Ads via nexus-integrations
 */
export const getGoogleAdsHourlyMetricsApiV1IntegrationsGoogleAdsHourlyMetricsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAdsHourlyMetricsApiV1IntegrationsGoogleAdsHourlyMetricsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAdsHourlyMetricsApiV1IntegrationsGoogleAdsHourlyMetricsGetResponses,
      GetGoogleAdsHourlyMetricsApiV1IntegrationsGoogleAdsHourlyMetricsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-ads/hourly-metrics",
      ...options,
    });

/**
 * Get Google Ads Keywords
 *
 * Lista palavras-chave por conta ou campanha específica
 */
export const getGoogleAdsKeywordsApiV1IntegrationsGoogleAdsKeywordsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoogleAdsKeywordsApiV1IntegrationsGoogleAdsKeywordsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetGoogleAdsKeywordsApiV1IntegrationsGoogleAdsKeywordsGetResponses,
    GetGoogleAdsKeywordsApiV1IntegrationsGoogleAdsKeywordsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-ads/keywords",
    ...options,
  });

/**
 * Get Google Ads Metrics
 *
 * Busca métricas de performance para período específico
 */
export const getGoogleAdsMetricsApiV1IntegrationsGoogleAdsMetricsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoogleAdsMetricsApiV1IntegrationsGoogleAdsMetricsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetGoogleAdsMetricsApiV1IntegrationsGoogleAdsMetricsGetResponses,
    GetGoogleAdsMetricsApiV1IntegrationsGoogleAdsMetricsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-ads/metrics",
    ...options,
  });

/**
 * Get Google Ads Performance Insights
 *
 * Insights de performance avançados com KPIs calculados
 */
export const getGoogleAdsPerformanceInsightsApiV1IntegrationsGoogleAdsPerformanceInsightsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAdsPerformanceInsightsApiV1IntegrationsGoogleAdsPerformanceInsightsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAdsPerformanceInsightsApiV1IntegrationsGoogleAdsPerformanceInsightsGetResponses,
      GetGoogleAdsPerformanceInsightsApiV1IntegrationsGoogleAdsPerformanceInsightsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-ads/performance-insights",
      ...options,
    });

/**
 * Get Google Ads Status
 *
 * Verifica status da conexão com Google Ads
 */
export const getGoogleAdsStatusApiV1IntegrationsGoogleAdsStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetGoogleAdsStatusApiV1IntegrationsGoogleAdsStatusGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetGoogleAdsStatusApiV1IntegrationsGoogleAdsStatusGetResponses,
    GetGoogleAdsStatusApiV1IntegrationsGoogleAdsStatusGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-ads/status",
    ...options,
  });

/**
 * Sync Google Ads Data
 *
 * Força sincronização dos dados do Google Ads
 */
export const syncGoogleAdsDataApiV1IntegrationsGoogleAdsSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncGoogleAdsDataApiV1IntegrationsGoogleAdsSyncPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SyncGoogleAdsDataApiV1IntegrationsGoogleAdsSyncPostResponses,
    SyncGoogleAdsDataApiV1IntegrationsGoogleAdsSyncPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/google-ads/sync",
    ...options,
  });

/**
 * Sync Complete Google Ads Data
 *
 * Sincronizar dados completos do Google Ads
 */
export const syncCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsSyncCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SyncCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsSyncCompletePostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      SyncCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsSyncCompletePostResponses,
      SyncCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsSyncCompletePostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/google-ads/sync-complete",
      ...options,
    });

/**
 * Get Accounts
 *
 * Listar contas Meta Ads
 */
export const getAccountsApiV1IntegrationsMetaAdsAccountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAccountsApiV1IntegrationsMetaAdsAccountsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetAccountsApiV1IntegrationsMetaAdsAccountsGetResponses,
    GetAccountsApiV1IntegrationsMetaAdsAccountsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/accounts",
    ...options,
  });

/**
 * Get Meta Ads Ad Performance
 *
 * Proxy para ad-performance do Meta Ads via nexus-integrations.
 */
export const getMetaAdsAdPerformanceApiV1IntegrationsMetaAdsAdPerformanceGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMetaAdsAdPerformanceApiV1IntegrationsMetaAdsAdPerformanceGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetMetaAdsAdPerformanceApiV1IntegrationsMetaAdsAdPerformanceGetResponses,
    GetMetaAdsAdPerformanceApiV1IntegrationsMetaAdsAdPerformanceGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/ad-performance",
    ...options,
  });

/**
 * Get Auth Url
 *
 * Obter URL de autenticação OAuth Meta Ads
 */
export const getAuthUrlApiV1IntegrationsMetaAdsAuthUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAuthUrlApiV1IntegrationsMetaAdsAuthUrlGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetAuthUrlApiV1IntegrationsMetaAdsAuthUrlGetResponses,
    GetAuthUrlApiV1IntegrationsMetaAdsAuthUrlGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/auth-url",
    ...options,
  });

/**
 * Oauth Callback
 *
 * Callback OAuth Meta Ads
 */
export const oauthCallbackApiV1IntegrationsMetaAdsCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OauthCallbackApiV1IntegrationsMetaAdsCallbackGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    OauthCallbackApiV1IntegrationsMetaAdsCallbackGetResponses,
    OauthCallbackApiV1IntegrationsMetaAdsCallbackGetErrors,
    ThrowOnError
  >({ url: "/api/v1/integrations/meta-ads/callback", ...options });

/**
 * Get Campaigns
 *
 * Listar campanhas da conta
 */
export const getCampaignsApiV1IntegrationsMetaAdsCampaignsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCampaignsApiV1IntegrationsMetaAdsCampaignsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCampaignsApiV1IntegrationsMetaAdsCampaignsGetResponses,
    GetCampaignsApiV1IntegrationsMetaAdsCampaignsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/campaigns",
    ...options,
  });

/**
 * Clear Account Data
 *
 * Limpar todos os dados de uma conta (CUIDADO!)
 */
export const clearAccountDataApiV1IntegrationsMetaAdsClearDataDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ClearAccountDataApiV1IntegrationsMetaAdsClearDataDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    ClearAccountDataApiV1IntegrationsMetaAdsClearDataDeleteResponses,
    ClearAccountDataApiV1IntegrationsMetaAdsClearDataDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/clear-data",
    ...options,
  });

/**
 * Get Complete Data
 *
 * Recuperar dados completos Meta Ads (métricas + demographics + interests + placement + creative)
 */
export const getCompleteDataApiV1IntegrationsMetaAdsCompleteDataGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCompleteDataApiV1IntegrationsMetaAdsCompleteDataGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCompleteDataApiV1IntegrationsMetaAdsCompleteDataGetResponses,
    GetCompleteDataApiV1IntegrationsMetaAdsCompleteDataGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/complete-data",
    ...options,
  });

/**
 * Get Connection Status
 *
 * Verificar status da conexão Meta Ads
 */
export const getConnectionStatusApiV1IntegrationsMetaAdsConnectionStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetConnectionStatusApiV1IntegrationsMetaAdsConnectionStatusGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetConnectionStatusApiV1IntegrationsMetaAdsConnectionStatusGetResponses,
    GetConnectionStatusApiV1IntegrationsMetaAdsConnectionStatusGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/connection-status",
    ...options,
  });

/**
 * Get Creative
 *
 * Recuperar performance por creative
 */
export const getCreativeApiV1IntegrationsMetaAdsCreativeGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCreativeApiV1IntegrationsMetaAdsCreativeGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCreativeApiV1IntegrationsMetaAdsCreativeGetResponses,
    GetCreativeApiV1IntegrationsMetaAdsCreativeGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/creative",
    ...options,
  });

/**
 * Get Demographics
 *
 * Recuperar breakdown demográfico detalhado
 */
export const getDemographicsApiV1IntegrationsMetaAdsDemographicsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetDemographicsApiV1IntegrationsMetaAdsDemographicsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetDemographicsApiV1IntegrationsMetaAdsDemographicsGetResponses,
    GetDemographicsApiV1IntegrationsMetaAdsDemographicsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/demographics",
    ...options,
  });

/**
 * Get Meta Ads Featured Adsets
 *
 * Proxy para featured-adsets do Meta Ads via nexus-integrations.
 */
export const getMetaAdsFeaturedAdsetsApiV1IntegrationsMetaAdsFeaturedAdsetsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMetaAdsFeaturedAdsetsApiV1IntegrationsMetaAdsFeaturedAdsetsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMetaAdsFeaturedAdsetsApiV1IntegrationsMetaAdsFeaturedAdsetsGetResponses,
      GetMetaAdsFeaturedAdsetsApiV1IntegrationsMetaAdsFeaturedAdsetsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/meta-ads/featured-adsets",
      ...options,
    });

/**
 * Get Meta Ads Hourly Metrics
 *
 * Proxy para obter métricas por hora do Meta Ads via nexus-integrations
 */
export const getMetaAdsHourlyMetricsApiV1IntegrationsMetaAdsHourlyMetricsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMetaAdsHourlyMetricsApiV1IntegrationsMetaAdsHourlyMetricsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetMetaAdsHourlyMetricsApiV1IntegrationsMetaAdsHourlyMetricsGetResponses,
    GetMetaAdsHourlyMetricsApiV1IntegrationsMetaAdsHourlyMetricsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/hourly-metrics",
    ...options,
  });

/**
 * Get Interests
 *
 * Recuperar performance por interesses e comportamentos
 */
export const getInterestsApiV1IntegrationsMetaAdsInterestsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInterestsApiV1IntegrationsMetaAdsInterestsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInterestsApiV1IntegrationsMetaAdsInterestsGetResponses,
    GetInterestsApiV1IntegrationsMetaAdsInterestsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/interests",
    ...options,
  });

/**
 * Get Metrics
 *
 * Recuperar métricas básicas Meta Ads
 */
export const getMetricsApiV1IntegrationsMetaAdsMetricsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMetricsApiV1IntegrationsMetaAdsMetricsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetMetricsApiV1IntegrationsMetaAdsMetricsGetResponses,
    GetMetricsApiV1IntegrationsMetaAdsMetricsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/metrics",
    ...options,
  });

/**
 * Get Performance Insights
 *
 * Recuperar insights de performance calculados
 */
export const getPerformanceInsightsApiV1IntegrationsMetaAdsPerformanceInsightsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPerformanceInsightsApiV1IntegrationsMetaAdsPerformanceInsightsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetPerformanceInsightsApiV1IntegrationsMetaAdsPerformanceInsightsGetResponses,
      GetPerformanceInsightsApiV1IntegrationsMetaAdsPerformanceInsightsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/meta-ads/performance-insights",
      ...options,
    });

/**
 * Get Placement
 *
 * Recuperar performance por placement e dispositivos
 */
export const getPlacementApiV1IntegrationsMetaAdsPlacementGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPlacementApiV1IntegrationsMetaAdsPlacementGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetPlacementApiV1IntegrationsMetaAdsPlacementGetResponses,
    GetPlacementApiV1IntegrationsMetaAdsPlacementGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/placement",
    ...options,
  });

/**
 * Get Meta Ads Platform Metrics
 *
 * Proxy para obter métricas por plataforma do Meta Ads via nexus-integrations
 */
export const getMetaAdsPlatformMetricsApiV1IntegrationsMetaAdsPlatformMetricsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMetaAdsPlatformMetricsApiV1IntegrationsMetaAdsPlatformMetricsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMetaAdsPlatformMetricsApiV1IntegrationsMetaAdsPlatformMetricsGetResponses,
      GetMetaAdsPlatformMetricsApiV1IntegrationsMetaAdsPlatformMetricsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/meta-ads/platform-metrics",
      ...options,
    });

/**
 * Get Account Summary
 *
 * Recuperar resumo da conta Meta Ads
 */
export const getAccountSummaryApiV1IntegrationsMetaAdsSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAccountSummaryApiV1IntegrationsMetaAdsSummaryGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAccountSummaryApiV1IntegrationsMetaAdsSummaryGetResponses,
    GetAccountSummaryApiV1IntegrationsMetaAdsSummaryGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/summary",
    ...options,
  });

/**
 * Sync Metrics
 *
 * Sincronizar métricas básicas Meta Ads
 */
export const syncMetricsApiV1IntegrationsMetaAdsSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncMetricsApiV1IntegrationsMetaAdsSyncPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SyncMetricsApiV1IntegrationsMetaAdsSyncPostResponses,
    SyncMetricsApiV1IntegrationsMetaAdsSyncPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sync Complete Data
 *
 * Sincronização completa Meta Ads (todas as tabelas)
 */
export const syncCompleteDataApiV1IntegrationsMetaAdsSyncCompletePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncCompleteDataApiV1IntegrationsMetaAdsSyncCompletePostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SyncCompleteDataApiV1IntegrationsMetaAdsSyncCompletePostResponses,
    SyncCompleteDataApiV1IntegrationsMetaAdsSyncCompletePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/sync-complete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Test Data
 *
 * Endpoint de teste para Meta Ads sem autenticação
 */
export const getTestDataApiV1IntegrationsMetaAdsTestDataGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetTestDataApiV1IntegrationsMetaAdsTestDataGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetTestDataApiV1IntegrationsMetaAdsTestDataGetResponses,
    GetTestDataApiV1IntegrationsMetaAdsTestDataGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/meta-ads/test-data",
    ...options,
  });

/**
 * Get Meta Ads Instagram Kpi
 *
 * ENDPOINT EM USO NA PÁGINA Instagram - Cards KPI
 */
export const getMetaAdsInstagramKpiApiV1MetaAdsInstagramKpiGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMetaAdsInstagramKpiApiV1MetaAdsInstagramKpiGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetMetaAdsInstagramKpiApiV1MetaAdsInstagramKpiGetResponses,
    GetMetaAdsInstagramKpiApiV1MetaAdsInstagramKpiGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/meta-ads-instagram-kpi",
    ...options,
  });

/**
 * Get Meta Ads Instagram Timeseries
 *
 * ENDPOINT EM USO NA PÁGINA Instagram - Gráficos TimeSeries
 */
export const getMetaAdsInstagramTimeseriesApiV1MetaAdsInstagramTimeseriesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMetaAdsInstagramTimeseriesApiV1MetaAdsInstagramTimeseriesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetMetaAdsInstagramTimeseriesApiV1MetaAdsInstagramTimeseriesGetResponses,
    GetMetaAdsInstagramTimeseriesApiV1MetaAdsInstagramTimeseriesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/meta-ads-instagram-timeseries",
    ...options,
  });

/**
 * Get Meta Ads Manager Total
 *
 * # ENDPOINT EM USO NA PÁGINA Visão Geral - Card META ADS GERENCIADOR (TOTAL)
 */
export const getMetaAdsManagerTotalApiV1MetaAdsManagerTotalGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMetaAdsManagerTotalApiV1MetaAdsManagerTotalGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetMetaAdsManagerTotalApiV1MetaAdsManagerTotalGetResponses,
    GetMetaAdsManagerTotalApiV1MetaAdsManagerTotalGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/meta-ads-manager-total",
    ...options,
  });

/**
 * Get Instagram Demographics
 *
 * Proxy para o endpoint de demografia do Instagram Insights.
 */
export const getInstagramDemographicsApiV1InstagramDemographicsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInstagramDemographicsApiV1InstagramDemographicsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInstagramDemographicsApiV1InstagramDemographicsGetResponses,
    GetInstagramDemographicsApiV1InstagramDemographicsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/instagram-demographics",
    ...options,
  });

/**
 * Get Instagram Engagement
 *
 * ENDPOINT EM USO NA PÁGINA Instagram - Engagement Metrics
 */
export const getInstagramEngagementApiV1InstagramEngagementGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInstagramEngagementApiV1InstagramEngagementGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInstagramEngagementApiV1InstagramEngagementGetResponses,
    GetInstagramEngagementApiV1InstagramEngagementGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/instagram-engagement",
    ...options,
  });

/**
 * Get Instagram Kpis Complete
 *
 * Proxy para o endpoint completo de KPIs do Instagram Insights.
 */
export const getInstagramKpisCompleteApiV1InstagramKpisCompleteGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInstagramKpisCompleteApiV1InstagramKpisCompleteGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInstagramKpisCompleteApiV1InstagramKpisCompleteGetResponses,
    GetInstagramKpisCompleteApiV1InstagramKpisCompleteGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/instagram-kpis-complete",
    ...options,
  });

/**
 * Get Instagram Posts
 *
 * Proxy para o Nexus Integrations `/instagram/posts`.
 */
export const getInstagramPostsApiV1InstagramPostsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetInstagramPostsApiV1InstagramPostsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetInstagramPostsApiV1InstagramPostsGetResponses,
    GetInstagramPostsApiV1InstagramPostsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/instagram-posts",
    ...options,
  });

/**
 * Get Instagram Profile Metrics
 *
 * ENDPOINT EM USO NA PÁGINA Instagram - Profile Metrics
 */
export const getInstagramProfileMetricsApiV1InstagramProfileMetricsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInstagramProfileMetricsApiV1InstagramProfileMetricsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInstagramProfileMetricsApiV1InstagramProfileMetricsGetResponses,
    GetInstagramProfileMetricsApiV1InstagramProfileMetricsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/instagram-profile-metrics",
    ...options,
  });

/**
 * Get Instagram Stories
 *
 * ENDPOINT EM USO NA PÁGINA Instagram - Stories
 */
export const getInstagramStoriesApiV1InstagramStoriesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInstagramStoriesApiV1InstagramStoriesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInstagramStoriesApiV1InstagramStoriesGetResponses,
    GetInstagramStoriesApiV1InstagramStoriesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/instagram-stories",
    ...options,
  });

/**
 * Get Instagram Timeseries Complete
 *
 * Proxy para o endpoint de séries temporais do Instagram Insights.
 */
export const getInstagramTimeseriesCompleteApiV1InstagramTimeseriesCompleteGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInstagramTimeseriesCompleteApiV1InstagramTimeseriesCompleteGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetInstagramTimeseriesCompleteApiV1InstagramTimeseriesCompleteGetResponses,
      GetInstagramTimeseriesCompleteApiV1InstagramTimeseriesCompleteGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/instagram-timeseries-complete",
      ...options,
    });

/**
 * Get Instagram Card Metric
 *
 * Proxy individual para cada card da página de Instagram.
 */
export const getInstagramCardMetricApiV1InstagramCardsMetricSlugGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInstagramCardMetricApiV1InstagramCardsMetricSlugGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInstagramCardMetricApiV1InstagramCardsMetricSlugGetResponses,
    GetInstagramCardMetricApiV1InstagramCardsMetricSlugGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/instagram/cards/{metric_slug}",
    ...options,
  });

/**
 * Get Instagram Demographics Dimension
 *
 * Proxy individual para dimensões demográficas específicas (gênero, idade, cidades).
 */
export const getInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGetResponses,
      GetInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/instagram/demographics/{dimension_slug}",
      ...options,
    });

/**
 * Get Instagram Timeseries Metric
 *
 * Proxy individual para séries temporais do Instagram (alcance, visualizações, etc.).
 */
export const getInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGetResponses,
      GetInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/instagram/timeseries/{metric_slug}",
      ...options,
    });

/**
 * Get Accounts
 *
 * Listar contas Instagram
 */
export const getAccountsApiV1IntegrationsInstagramInsightsAccountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAccountsApiV1IntegrationsInstagramInsightsAccountsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetAccountsApiV1IntegrationsInstagramInsightsAccountsGetResponses,
    GetAccountsApiV1IntegrationsInstagramInsightsAccountsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/instagram-insights/accounts",
    ...options,
  });

/**
 * Get Audience Insights
 *
 * Recuperar insights de audiência
 */
export const getAudienceInsightsApiV1IntegrationsInstagramInsightsAudienceInsightsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAudienceInsightsApiV1IntegrationsInstagramInsightsAudienceInsightsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAudienceInsightsApiV1IntegrationsInstagramInsightsAudienceInsightsGetResponses,
      GetAudienceInsightsApiV1IntegrationsInstagramInsightsAudienceInsightsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/instagram-insights/audience-insights",
      ...options,
    });

/**
 * Get Auth Url
 *
 * Obter URL de autenticação OAuth Instagram
 */
export const getAuthUrlApiV1IntegrationsInstagramInsightsAuthUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAuthUrlApiV1IntegrationsInstagramInsightsAuthUrlGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetAuthUrlApiV1IntegrationsInstagramInsightsAuthUrlGetResponses,
    GetAuthUrlApiV1IntegrationsInstagramInsightsAuthUrlGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/instagram-insights/auth-url",
    ...options,
  });

/**
 * Oauth Callback
 *
 * Callback OAuth Instagram
 */
export const oauthCallbackApiV1IntegrationsInstagramInsightsCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OauthCallbackApiV1IntegrationsInstagramInsightsCallbackGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    OauthCallbackApiV1IntegrationsInstagramInsightsCallbackGetResponses,
    OauthCallbackApiV1IntegrationsInstagramInsightsCallbackGetErrors,
    ThrowOnError
  >({ url: "/api/v1/integrations/instagram-insights/callback", ...options });

/**
 * Clear Account Data
 */
export const clearAccountDataApiV1IntegrationsInstagramInsightsClearDataDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ClearAccountDataApiV1IntegrationsInstagramInsightsClearDataDeleteData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).delete<
      ClearAccountDataApiV1IntegrationsInstagramInsightsClearDataDeleteResponses,
      ClearAccountDataApiV1IntegrationsInstagramInsightsClearDataDeleteErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/instagram-insights/clear-data",
      ...options,
    });

/**
 * Get Complete Data
 *
 * Recuperar dados completos Instagram (métricas + posts + stories + reels + audience + hashtags)
 */
export const getCompleteDataApiV1IntegrationsInstagramInsightsCompleteDataGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetCompleteDataApiV1IntegrationsInstagramInsightsCompleteDataGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetCompleteDataApiV1IntegrationsInstagramInsightsCompleteDataGetResponses,
      GetCompleteDataApiV1IntegrationsInstagramInsightsCompleteDataGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/instagram-insights/complete-data",
      ...options,
    });

/**
 * Get Connection Status
 *
 * Verificar status da conexão Instagram
 */
export const getConnectionStatusApiV1IntegrationsInstagramInsightsConnectionStatusGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetConnectionStatusApiV1IntegrationsInstagramInsightsConnectionStatusGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetConnectionStatusApiV1IntegrationsInstagramInsightsConnectionStatusGetResponses,
      GetConnectionStatusApiV1IntegrationsInstagramInsightsConnectionStatusGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/instagram-insights/connection-status",
      ...options,
    });

/**
 * Get Daily Metrics
 */
export const getDailyMetricsApiV1IntegrationsInstagramInsightsDailyMetricsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetDailyMetricsApiV1IntegrationsInstagramInsightsDailyMetricsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetDailyMetricsApiV1IntegrationsInstagramInsightsDailyMetricsGetResponses,
      GetDailyMetricsApiV1IntegrationsInstagramInsightsDailyMetricsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/instagram-insights/daily-metrics",
      ...options,
    });

/**
 * Get Engagement Trends
 *
 * Analisar tendências de engagement
 */
export const getEngagementTrendsApiV1IntegrationsInstagramInsightsEngagementTrendsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetEngagementTrendsApiV1IntegrationsInstagramInsightsEngagementTrendsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetEngagementTrendsApiV1IntegrationsInstagramInsightsEngagementTrendsGetResponses,
      GetEngagementTrendsApiV1IntegrationsInstagramInsightsEngagementTrendsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/instagram-insights/engagement-trends",
      ...options,
    });

/**
 * Get Hashtag Metrics
 *
 * Recuperar métricas de hashtags
 */
export const getHashtagMetricsApiV1IntegrationsInstagramInsightsHashtagMetricsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetHashtagMetricsApiV1IntegrationsInstagramInsightsHashtagMetricsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetHashtagMetricsApiV1IntegrationsInstagramInsightsHashtagMetricsGetResponses,
      GetHashtagMetricsApiV1IntegrationsInstagramInsightsHashtagMetricsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/instagram-insights/hashtag-metrics",
      ...options,
    });

/**
 * Get Performance Insights
 *
 * Recuperar insights de performance Instagram calculados
 */
export const getPerformanceInsightsApiV1IntegrationsInstagramInsightsPerformanceInsightsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPerformanceInsightsApiV1IntegrationsInstagramInsightsPerformanceInsightsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetPerformanceInsightsApiV1IntegrationsInstagramInsightsPerformanceInsightsGetResponses,
      GetPerformanceInsightsApiV1IntegrationsInstagramInsightsPerformanceInsightsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/instagram-insights/performance-insights",
      ...options,
    });

/**
 * Get Posts Metrics
 *
 * Recuperar métricas de posts
 */
export const getPostsMetricsApiV1IntegrationsInstagramInsightsPostsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPostsMetricsApiV1IntegrationsInstagramInsightsPostsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetPostsMetricsApiV1IntegrationsInstagramInsightsPostsGetResponses,
    GetPostsMetricsApiV1IntegrationsInstagramInsightsPostsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/instagram-insights/posts",
    ...options,
  });

/**
 * Get Reels Metrics
 *
 * Recuperar métricas de reels
 */
export const getReelsMetricsApiV1IntegrationsInstagramInsightsReelsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReelsMetricsApiV1IntegrationsInstagramInsightsReelsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetReelsMetricsApiV1IntegrationsInstagramInsightsReelsGetResponses,
    GetReelsMetricsApiV1IntegrationsInstagramInsightsReelsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/instagram-insights/reels",
    ...options,
  });

/**
 * Get Status
 *
 * Obter status da conexão Instagram Insights
 */
export const getStatusApiV1IntegrationsInstagramInsightsStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetStatusApiV1IntegrationsInstagramInsightsStatusGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetStatusApiV1IntegrationsInstagramInsightsStatusGetResponses,
    GetStatusApiV1IntegrationsInstagramInsightsStatusGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/instagram-insights/status",
    ...options,
  });

/**
 * Get Stories Metrics
 *
 * Recuperar métricas de stories
 */
export const getStoriesMetricsApiV1IntegrationsInstagramInsightsStoriesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetStoriesMetricsApiV1IntegrationsInstagramInsightsStoriesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetStoriesMetricsApiV1IntegrationsInstagramInsightsStoriesGetResponses,
    GetStoriesMetricsApiV1IntegrationsInstagramInsightsStoriesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/instagram-insights/stories",
    ...options,
  });

/**
 * Get Account Summary
 */
export const getAccountSummaryApiV1IntegrationsInstagramInsightsSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAccountSummaryApiV1IntegrationsInstagramInsightsSummaryGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAccountSummaryApiV1IntegrationsInstagramInsightsSummaryGetResponses,
    GetAccountSummaryApiV1IntegrationsInstagramInsightsSummaryGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/instagram-insights/summary",
    ...options,
  });

/**
 * Sync Basic Metrics
 *
 * Sincronização básica Instagram
 */
export const syncBasicMetricsApiV1IntegrationsInstagramInsightsSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncBasicMetricsApiV1IntegrationsInstagramInsightsSyncPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SyncBasicMetricsApiV1IntegrationsInstagramInsightsSyncPostResponses,
    SyncBasicMetricsApiV1IntegrationsInstagramInsightsSyncPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/instagram-insights/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sync Complete Data
 *
 * Sincronização completa Instagram (todas as tabelas)
 */
export const syncCompleteDataApiV1IntegrationsInstagramInsightsSyncCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SyncCompleteDataApiV1IntegrationsInstagramInsightsSyncCompletePostData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      SyncCompleteDataApiV1IntegrationsInstagramInsightsSyncCompletePostResponses,
      SyncCompleteDataApiV1IntegrationsInstagramInsightsSyncCompletePostErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/instagram-insights/sync-complete",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Get Top Posts
 *
 * Listar top posts da conta
 */
export const getTopPostsApiV1IntegrationsInstagramInsightsTopPostsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTopPostsApiV1IntegrationsInstagramInsightsTopPostsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetTopPostsApiV1IntegrationsInstagramInsightsTopPostsGetResponses,
    GetTopPostsApiV1IntegrationsInstagramInsightsTopPostsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/instagram-insights/top-posts",
    ...options,
  });

/**
 * Get Accounts
 *
 * Listar contas Search Console
 */
export const getAccountsApiV1IntegrationsSearchConsoleAccountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAccountsApiV1IntegrationsSearchConsoleAccountsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetAccountsApiV1IntegrationsSearchConsoleAccountsGetResponses,
    GetAccountsApiV1IntegrationsSearchConsoleAccountsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/accounts",
    ...options,
  });

/**
 * Get Auth Url
 *
 * Obter URL de autenticação OAuth Search Console
 */
export const getAuthUrlApiV1IntegrationsSearchConsoleAuthUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAuthUrlApiV1IntegrationsSearchConsoleAuthUrlGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetAuthUrlApiV1IntegrationsSearchConsoleAuthUrlGetResponses,
    GetAuthUrlApiV1IntegrationsSearchConsoleAuthUrlGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/auth-url",
    ...options,
  });

/**
 * Oauth Callback
 */
export const oauthCallbackApiV1IntegrationsSearchConsoleCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OauthCallbackApiV1IntegrationsSearchConsoleCallbackGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    OauthCallbackApiV1IntegrationsSearchConsoleCallbackGetResponses,
    OauthCallbackApiV1IntegrationsSearchConsoleCallbackGetErrors,
    ThrowOnError
  >({ url: "/api/v1/integrations/search-console/callback", ...options });

/**
 * Clear Account Data
 *
 * Limpar todos os dados de uma conta (CUIDADO!)
 */
export const clearAccountDataApiV1IntegrationsSearchConsoleClearDataDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ClearAccountDataApiV1IntegrationsSearchConsoleClearDataDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    ClearAccountDataApiV1IntegrationsSearchConsoleClearDataDeleteResponses,
    ClearAccountDataApiV1IntegrationsSearchConsoleClearDataDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/clear-data",
    ...options,
  });

/**
 * Get Complete Data
 *
 * Recuperar dados completos Search Console (métricas + Core Web Vitals + Index Coverage + Mobile Usability + Rich Results + Links)
 */
export const getCompleteDataApiV1IntegrationsSearchConsoleCompleteDataGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCompleteDataApiV1IntegrationsSearchConsoleCompleteDataGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCompleteDataApiV1IntegrationsSearchConsoleCompleteDataGetResponses,
    GetCompleteDataApiV1IntegrationsSearchConsoleCompleteDataGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/complete-data",
    ...options,
  });

/**
 * Get Connection Status
 *
 * Verificar status da conexão Search Console
 */
export const getConnectionStatusApiV1IntegrationsSearchConsoleConnectionStatusGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetConnectionStatusApiV1IntegrationsSearchConsoleConnectionStatusGetData,
      ThrowOnError
    >,
  ) =>
    (options?.client ?? client).get<
      GetConnectionStatusApiV1IntegrationsSearchConsoleConnectionStatusGetResponses,
      GetConnectionStatusApiV1IntegrationsSearchConsoleConnectionStatusGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/search-console/connection-status",
      ...options,
    });

/**
 * Get Core Web Vitals
 *
 * Recuperar dados de Core Web Vitals
 */
export const getCoreWebVitalsApiV1IntegrationsSearchConsoleCoreWebVitalsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCoreWebVitalsApiV1IntegrationsSearchConsoleCoreWebVitalsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCoreWebVitalsApiV1IntegrationsSearchConsoleCoreWebVitalsGetResponses,
    GetCoreWebVitalsApiV1IntegrationsSearchConsoleCoreWebVitalsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/core-web-vitals",
    ...options,
  });

/**
 * Get Index Coverage
 *
 * Recuperar dados de cobertura de indexação
 */
export const getIndexCoverageApiV1IntegrationsSearchConsoleIndexCoverageGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIndexCoverageApiV1IntegrationsSearchConsoleIndexCoverageGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetIndexCoverageApiV1IntegrationsSearchConsoleIndexCoverageGetResponses,
    GetIndexCoverageApiV1IntegrationsSearchConsoleIndexCoverageGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/index-coverage",
    ...options,
  });

/**
 * Get Metrics
 *
 * Recuperar métricas básicas Search Console
 */
export const getMetricsApiV1IntegrationsSearchConsoleMetricsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMetricsApiV1IntegrationsSearchConsoleMetricsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetMetricsApiV1IntegrationsSearchConsoleMetricsGetResponses,
    GetMetricsApiV1IntegrationsSearchConsoleMetricsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/metrics",
    ...options,
  });

/**
 * Get Performance Insights
 *
 * Recuperar insights de performance SEO calculados
 */
export const getPerformanceInsightsApiV1IntegrationsSearchConsolePerformanceInsightsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPerformanceInsightsApiV1IntegrationsSearchConsolePerformanceInsightsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetPerformanceInsightsApiV1IntegrationsSearchConsolePerformanceInsightsGetResponses,
      GetPerformanceInsightsApiV1IntegrationsSearchConsolePerformanceInsightsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/integrations/search-console/performance-insights",
      ...options,
    });

/**
 * Get Rich Results
 *
 * Recuperar dados de Rich Results
 */
export const getRichResultsApiV1IntegrationsSearchConsoleRichResultsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRichResultsApiV1IntegrationsSearchConsoleRichResultsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetRichResultsApiV1IntegrationsSearchConsoleRichResultsGetResponses,
    GetRichResultsApiV1IntegrationsSearchConsoleRichResultsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/rich-results",
    ...options,
  });

/**
 * Get Status
 *
 * Obter status da conexão Search Console
 */
export const getStatusApiV1IntegrationsSearchConsoleStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetStatusApiV1IntegrationsSearchConsoleStatusGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetStatusApiV1IntegrationsSearchConsoleStatusGetResponses,
    GetStatusApiV1IntegrationsSearchConsoleStatusGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/status",
    ...options,
  });

/**
 * Get Account Summary
 *
 * Recuperar resumo da conta Search Console
 */
export const getAccountSummaryApiV1IntegrationsSearchConsoleSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAccountSummaryApiV1IntegrationsSearchConsoleSummaryGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAccountSummaryApiV1IntegrationsSearchConsoleSummaryGetResponses,
    GetAccountSummaryApiV1IntegrationsSearchConsoleSummaryGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/summary",
    ...options,
  });

/**
 * Sync Metrics
 *
 * Sincronizar métricas básicas Search Console
 */
export const syncMetricsApiV1IntegrationsSearchConsoleSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncMetricsApiV1IntegrationsSearchConsoleSyncPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SyncMetricsApiV1IntegrationsSearchConsoleSyncPostResponses,
    SyncMetricsApiV1IntegrationsSearchConsoleSyncPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sync Complete Data
 *
 * Sincronização completa Search Console (todas as tabelas)
 */
export const syncCompleteDataApiV1IntegrationsSearchConsoleSyncCompletePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncCompleteDataApiV1IntegrationsSearchConsoleSyncCompletePostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    SyncCompleteDataApiV1IntegrationsSearchConsoleSyncCompletePostResponses,
    SyncCompleteDataApiV1IntegrationsSearchConsoleSyncCompletePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/sync-complete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Top Pages
 *
 * Listar top páginas da conta
 */
export const getTopPagesApiV1IntegrationsSearchConsoleTopPagesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTopPagesApiV1IntegrationsSearchConsoleTopPagesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetTopPagesApiV1IntegrationsSearchConsoleTopPagesGetResponses,
    GetTopPagesApiV1IntegrationsSearchConsoleTopPagesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/top-pages",
    ...options,
  });

/**
 * Get Top Queries
 *
 * Listar top queries da conta
 */
export const getTopQueriesApiV1IntegrationsSearchConsoleTopQueriesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTopQueriesApiV1IntegrationsSearchConsoleTopQueriesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetTopQueriesApiV1IntegrationsSearchConsoleTopQueriesGetResponses,
    GetTopQueriesApiV1IntegrationsSearchConsoleTopQueriesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/integrations/search-console/top-queries",
    ...options,
  });

/**
 * Get Seo Cards Data
 *
 * Proxy para os cards da página SEO no microsserviço Nexus.
 */
export const getSeoCardsDataApiV1SeoCardsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSeoCardsDataApiV1SeoCardsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSeoCardsDataApiV1SeoCardsGetResponses,
    GetSeoCardsDataApiV1SeoCardsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/seo/cards",
    ...options,
  });

/**
 * Get Seo Devices
 *
 * Obter dados reais por dispositivo do Search Console via Nexus.
 */
export const getSeoDevicesApiV1SeoDevicesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSeoDevicesApiV1SeoDevicesGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSeoDevicesApiV1SeoDevicesGetResponses,
    GetSeoDevicesApiV1SeoDevicesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/seo/devices",
    ...options,
  });

/**
 * Get Seo Brand Terms
 */
export const apiV1SeoBrandTermsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ApiV1SeoBrandTermsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiV1SeoBrandTermsGetResponses,
    ApiV1SeoBrandTermsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/seo/brand-terms",
    ...options,
  });

/**
 * Put Seo Brand Terms
 */
export const apiV1SeoBrandTermsPut = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1SeoBrandTermsPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ApiV1SeoBrandTermsPutResponses,
    ApiV1SeoBrandTermsPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/seo/brand-terms",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Analytics Overview
 *
 * # ENDPOINT EM USO NA PÁGINA Visão Geral - Card LOJA VIRTUAL (ANALYTICS)
 */
export const getAnalyticsOverviewApiV1AnalyticsOverviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAnalyticsOverviewApiV1AnalyticsOverviewGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAnalyticsOverviewApiV1AnalyticsOverviewGetResponses,
    GetAnalyticsOverviewApiV1AnalyticsOverviewGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/analytics-overview",
    ...options,
  });

/**
 * Get Channel Daily Analysis
 *
 * Proxy para o endpoint de análise diária por canal no Nexus.
 */
export const getChannelDailyAnalysisApiV1ChannelDailyAnalysisGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetChannelDailyAnalysisApiV1ChannelDailyAnalysisGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetChannelDailyAnalysisApiV1ChannelDailyAnalysisGetResponses,
    GetChannelDailyAnalysisApiV1ChannelDailyAnalysisGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/channel-daily-analysis",
    ...options,
  });

/**
 * Get Channel Grouping Card Data
 *
 * # ENDPOINT EM USO NA PÁGINA Dashboard - Card AGRUPAMENTO DE CANAL PADRÃO
 *
 * Obter dados consolidados do Google Analytics 4 para o card AGRUPAMENTO DE CANAL PADRÃO
 */
export const getChannelGroupingCardDataApiV1ChannelGroupingCardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetChannelGroupingCardDataApiV1ChannelGroupingCardGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetChannelGroupingCardDataApiV1ChannelGroupingCardGetResponses,
    GetChannelGroupingCardDataApiV1ChannelGroupingCardGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/channel-grouping/card",
    ...options,
  });

/**
 * Get Channel Monthly Analysis
 *
 * Proxy para o endpoint de análise mensal por canal no Nexus.
 */
export const getChannelMonthlyAnalysisApiV1ChannelMonthlyAnalysisGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetChannelMonthlyAnalysisApiV1ChannelMonthlyAnalysisGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetChannelMonthlyAnalysisApiV1ChannelMonthlyAnalysisGetResponses,
    GetChannelMonthlyAnalysisApiV1ChannelMonthlyAnalysisGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/channel-monthly-analysis",
    ...options,
  });

/**
 * Get Source Analysis Card
 *
 * # ENDPOINT EM USO NA PÁGINA Visão Geral - Card ANÁLISE POR ORIGEM
 */
export const getSourceAnalysisCardApiV1SourceAnalysisCardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetSourceAnalysisCardApiV1SourceAnalysisCardGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetSourceAnalysisCardApiV1SourceAnalysisCardGetResponses,
    GetSourceAnalysisCardApiV1SourceAnalysisCardGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/source-analysis/card",
    ...options,
  });

/**
 * Get Acquisition Audience Quality
 */
export const apiV1AcquisitionAudienceQualityGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1AcquisitionAudienceQualityGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ApiV1AcquisitionAudienceQualityGetResponses,
    ApiV1AcquisitionAudienceQualityGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/audience-quality",
    ...options,
  });

/**
 * Get Acquisition Campaigns
 */
export const getAcquisitionCampaignsApiV1AcquisitionCampaignsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAcquisitionCampaignsApiV1AcquisitionCampaignsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAcquisitionCampaignsApiV1AcquisitionCampaignsGetResponses,
    GetAcquisitionCampaignsApiV1AcquisitionCampaignsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/campaigns",
    ...options,
  });

/**
 * Get Acquisition Channel Grouping
 *
 * Proxy para o endpoint de agrupamento de canal padrão da página de Aquisição.
 *
 * Retorna:
 * - CANAL PADRÃO
 * - SESSÕES + % DELTA
 * - CARRINHOS + % DELTA
 * - PEDIDOS + % DELTA
 * - TICKET MÉDIO + % DELTA
 * - TAXA DE CONVERSÃO + % DELTA
 * - RECEITA TOTAL + % DELTA
 */
export const getAcquisitionChannelGroupingApiV1AcquisitionChannelGroupingGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAcquisitionChannelGroupingApiV1AcquisitionChannelGroupingGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAcquisitionChannelGroupingApiV1AcquisitionChannelGroupingGetResponses,
    GetAcquisitionChannelGroupingApiV1AcquisitionChannelGroupingGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/channel-grouping",
    ...options,
  });

/**
 * Get Acquisition Dashboard
 */
export const getAcquisitionDashboardApiV1AcquisitionGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAcquisitionDashboardApiV1AcquisitionGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAcquisitionDashboardApiV1AcquisitionGetResponses,
    GetAcquisitionDashboardApiV1AcquisitionGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition",
    ...options,
  });

/**
 * Get Acquisition Drilldown
 *
 * Endpoint de drill-down para métricas de aquisição.
 * Permite navegar entre dimensões (channel_group -> source_medium -> campaign).
 */
export const getAcquisitionDrilldownApiV1AcquisitionDrilldownGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAcquisitionDrilldownApiV1AcquisitionDrilldownGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAcquisitionDrilldownApiV1AcquisitionDrilldownGetResponses,
    GetAcquisitionDrilldownApiV1AcquisitionDrilldownGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/drilldown",
    ...options,
  });

/**
 * Get Acquisition Full
 */
export const getAcquisitionFullApiV1AcquisitionFullGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAcquisitionFullApiV1AcquisitionFullGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAcquisitionFullApiV1AcquisitionFullGetResponses,
    GetAcquisitionFullApiV1AcquisitionFullGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/full",
    ...options,
  });

/**
 * Get Acquisition Geo Tables
 */
export const apiV1AcquisitionGeoTablesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1AcquisitionGeoTablesGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ApiV1AcquisitionGeoTablesGetResponses,
    ApiV1AcquisitionGeoTablesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/geo-tables",
    ...options,
  });

/**
 * Get Acquisition Geo Users
 */
export const getAcquisitionGeoUsersApiV1AcquisitionGeoUsersGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAcquisitionGeoUsersApiV1AcquisitionGeoUsersGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAcquisitionGeoUsersApiV1AcquisitionGeoUsersGetResponses,
    GetAcquisitionGeoUsersApiV1AcquisitionGeoUsersGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/geo-users",
    ...options,
  });

/**
 * Get Acquisition Geo Users New By Region
 */
export const getAcquisitionGeoUsersNewByRegionApiV1AcquisitionGeoUsersNewByRegionGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAcquisitionGeoUsersNewByRegionApiV1AcquisitionGeoUsersNewByRegionGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAcquisitionGeoUsersNewByRegionApiV1AcquisitionGeoUsersNewByRegionGetResponses,
      GetAcquisitionGeoUsersNewByRegionApiV1AcquisitionGeoUsersNewByRegionGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/acquisition/geo-users/new-by-region",
      ...options,
    });

/**
 * Get Acquisition Geo Users New By Region Source
 */
export const getAcquisitionGeoUsersNewByRegionSourceApiV1AcquisitionGeoUsersNewByRegionSourceGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAcquisitionGeoUsersNewByRegionSourceApiV1AcquisitionGeoUsersNewByRegionSourceGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAcquisitionGeoUsersNewByRegionSourceApiV1AcquisitionGeoUsersNewByRegionSourceGetResponses,
      GetAcquisitionGeoUsersNewByRegionSourceApiV1AcquisitionGeoUsersNewByRegionSourceGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/acquisition/geo-users/new-by-region-source",
      ...options,
    });

/**
 * Get Acquisition Geo Users Returning By Region
 */
export const getAcquisitionGeoUsersReturningByRegionApiV1AcquisitionGeoUsersReturningByRegionGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAcquisitionGeoUsersReturningByRegionApiV1AcquisitionGeoUsersReturningByRegionGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAcquisitionGeoUsersReturningByRegionApiV1AcquisitionGeoUsersReturningByRegionGetResponses,
      GetAcquisitionGeoUsersReturningByRegionApiV1AcquisitionGeoUsersReturningByRegionGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/acquisition/geo-users/returning-by-region",
      ...options,
    });

/**
 * Get Acquisition Geo Users Returning By Region Source
 */
export const getAcquisitionGeoUsersReturningByRegionSourceApiV1AcquisitionGeoUsersReturningByRegionSourceGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAcquisitionGeoUsersReturningByRegionSourceApiV1AcquisitionGeoUsersReturningByRegionSourceGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAcquisitionGeoUsersReturningByRegionSourceApiV1AcquisitionGeoUsersReturningByRegionSourceGetResponses,
      GetAcquisitionGeoUsersReturningByRegionSourceApiV1AcquisitionGeoUsersReturningByRegionSourceGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/acquisition/geo-users/returning-by-region-source",
      ...options,
    });

/**
 * Get Acquisition Kpis
 */
export const getAcquisitionKpisApiV1AcquisitionKpisGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAcquisitionKpisApiV1AcquisitionKpisGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAcquisitionKpisApiV1AcquisitionKpisGetResponses,
    GetAcquisitionKpisApiV1AcquisitionKpisGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/kpis",
    ...options,
  });

/**
 * Get Acquisition New Vs Returning
 */
export const getAcquisitionNewVsReturningApiV1AcquisitionNewVsReturningGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAcquisitionNewVsReturningApiV1AcquisitionNewVsReturningGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAcquisitionNewVsReturningApiV1AcquisitionNewVsReturningGetResponses,
    GetAcquisitionNewVsReturningApiV1AcquisitionNewVsReturningGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/new-vs-returning",
    ...options,
  });

/**
 * Get Acquisition Orders
 */
export const apiV1AcquisitionOrdersGet = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1AcquisitionOrdersGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ApiV1AcquisitionOrdersGetResponses,
    ApiV1AcquisitionOrdersGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/orders",
    ...options,
  });

/**
 * Get Acquisition Source Medium
 */
export const getAcquisitionSourceMediumApiV1AcquisitionSourceMediumGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAcquisitionSourceMediumApiV1AcquisitionSourceMediumGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAcquisitionSourceMediumApiV1AcquisitionSourceMediumGetResponses,
    GetAcquisitionSourceMediumApiV1AcquisitionSourceMediumGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/source-medium",
    ...options,
  });

/**
 * Get Acquisition Timeline
 */
export const getAcquisitionTimelineApiV1AcquisitionTimelineGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAcquisitionTimelineApiV1AcquisitionTimelineGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAcquisitionTimelineApiV1AcquisitionTimelineGetResponses,
    GetAcquisitionTimelineApiV1AcquisitionTimelineGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/acquisition/timeline",
    ...options,
  });

/**
 * Get Campaign Filter Fields
 */
export const getCampaignFilterFieldsApiV1CampaignFilterFieldsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCampaignFilterFieldsApiV1CampaignFilterFieldsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCampaignFilterFieldsApiV1CampaignFilterFieldsGetResponses,
    GetCampaignFilterFieldsApiV1CampaignFilterFieldsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/campaign-filter-fields",
    ...options,
  });

/**
 * Get Campaign Filter Suggestions
 */
export const getCampaignFilterSuggestionsApiV1CampaignFilterSuggestionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCampaignFilterSuggestionsApiV1CampaignFilterSuggestionsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCampaignFilterSuggestionsApiV1CampaignFilterSuggestionsGetResponses,
    GetCampaignFilterSuggestionsApiV1CampaignFilterSuggestionsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/campaign-filter-suggestions",
    ...options,
  });

/**
 * Get Campaign Filters
 */
export const getCampaignFiltersApiV1CampaignFiltersGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCampaignFiltersApiV1CampaignFiltersGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCampaignFiltersApiV1CampaignFiltersGetResponses,
    GetCampaignFiltersApiV1CampaignFiltersGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/campaign-filters",
    ...options,
  });

/**
 * Update Campaign Filters
 */
export const updateCampaignFiltersApiV1CampaignFiltersPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateCampaignFiltersApiV1CampaignFiltersPutData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    UpdateCampaignFiltersApiV1CampaignFiltersPutResponses,
    UpdateCampaignFiltersApiV1CampaignFiltersPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/campaign-filters",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Campaigns Card Pages
 *
 * # ENDPOINT EM USO NA PÁGINA Páginas - Card Campanhas
 */
export const getCampaignsCardPagesApiV1AnalyticsCampaignsPagesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCampaignsCardPagesApiV1AnalyticsCampaignsPagesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetCampaignsCardPagesApiV1AnalyticsCampaignsPagesGetResponses,
    GetCampaignsCardPagesApiV1AnalyticsCampaignsPagesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/analytics/campaigns/pages",
    ...options,
  });

/**
 * Get Utm Ad Content
 *
 * ENDPOINT EM USO NA PÁGINA UTM - Card Conteúdo do Anúncio
 *
 * Retorna dados paginados para o card "Conteúdo do Anúncio":
 * - Conteúdo do anúncio
 * - Usuários ativos
 * - Sessões (com trend)
 * - Taxa de Conversão (com trend)
 * - Pedidos (com trend)
 * - Ticket Médio (com trend)
 * - Receita Total (com trend)
 *
 * Retorna também:
 * - Linha de total geral
 * - Metadados de paginação (current_page, page_size, total_items, total_pages)
 */
export const getUtmAdContentApiV1UtmAdContentGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUtmAdContentApiV1UtmAdContentGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetUtmAdContentApiV1UtmAdContentGetResponses,
    GetUtmAdContentApiV1UtmAdContentGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/utm/ad-content",
    ...options,
  });

/**
 * Get Utm Campaigns
 *
 * ENDPOINT EM USO NA PÁGINA UTM - Card Campanhas
 *
 * Retorna dados paginados para o card "Campanhas":
 * - Campanha da sessão
 * - Usuários ativos
 * - Sessões (com trend)
 * - Taxa de Conversão (com trend)
 * - Pedidos (com trend)
 * - Ticket Médio (com trend)
 * - Receita Total (com trend)
 *
 * Retorna também:
 * - Linha de total geral
 * - Metadados de paginação (current_page, page_size, total_items, total_pages)
 */
export const getUtmCampaignsApiV1UtmCampaignsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUtmCampaignsApiV1UtmCampaignsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetUtmCampaignsApiV1UtmCampaignsGetResponses,
    GetUtmCampaignsApiV1UtmCampaignsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/utm/campaigns",
    ...options,
  });

/**
 * Get Utm Cards
 *
 * ENDPOINT EM USO NA PÁGINA UTM - Cards KPI
 *
 * Retorna os dados dos 8 cards KPI da página UTM:
 * - RECEITA TOTAL
 * - CPS GERAL (Custo por Sessão)
 * - SESSÕES
 * - TAXA DE CONVERSÃO
 * - PEDIDOS
 * - TICKET MÉDIO
 * - MÉDIA DE ITENS POR PEDIDO
 * - VALOR MÉDIO UNITÁRIO
 */
export const getUtmCardsApiV1UtmCardsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUtmCardsApiV1UtmCardsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetUtmCardsApiV1UtmCardsGetResponses,
    GetUtmCardsApiV1UtmCardsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/utm/cards",
    ...options,
  });

/**
 * Get Utm Medium
 *
 * ENDPOINT EM USO NA PÁGINA UTM - Card Meio da Sessão
 *
 * Retorna dados paginados para o card "Meio da Sessão":
 * - Meio da sessão
 * - Usuários ativos
 * - Sessões (com trend)
 * - Taxa de Conversão (com trend)
 * - Pedidos (com trend)
 * - Ticket Médio (com trend)
 * - Receita Total (com trend)
 *
 * Retorna também:
 * - Linha de total geral
 * - Metadados de paginação (current_page, page_size, total_items, total_pages)
 */
export const getUtmMediumApiV1UtmMediumGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUtmMediumApiV1UtmMediumGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetUtmMediumApiV1UtmMediumGetResponses,
    GetUtmMediumApiV1UtmMediumGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/utm/medium",
    ...options,
  });

/**
 * Get Utm Session Source
 *
 * ENDPOINT EM USO NA PÁGINA UTM - Tabela Origem da Sessão
 *
 * Retorna dados paginados para a tabela "Origem da Sessão":
 * - Origem da sessão
 * - Usuários ativos
 * - Sessões (com trend)
 * - Taxa de Conversão (com trend)
 * - Pedidos (com trend)
 * - Ticket Médio (com trend)
 * - Receita Total (com trend)
 *
 * Retorna também:
 * - Linha de total geral
 * - Metadados de paginação (current_page, page_size, total_items, total_pages)
 */
export const getUtmSessionSourceApiV1UtmSessionSourceGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUtmSessionSourceApiV1UtmSessionSourceGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetUtmSessionSourceApiV1UtmSessionSourceGetResponses,
    GetUtmSessionSourceApiV1UtmSessionSourceGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/utm/session-source",
    ...options,
  });

/**
 * Get Conversion Rate Cards V2
 */
export const getConversionRateCardsV2ApiV1ConversionRateCardsV2Get = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetConversionRateCardsV2ApiV1ConversionRateCardsV2GetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetConversionRateCardsV2ApiV1ConversionRateCardsV2GetResponses,
    GetConversionRateCardsV2ApiV1ConversionRateCardsV2GetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/conversion-rate/cards-v2",
    ...options,
  });

/**
 * Get Conversion Rate Dashboard
 *
 * ENDPOINT EM USO NA PÁGINA Taxa de Conversão - Card KPIs
 */
export const getConversionRateDashboardApiV1ConversionRateDashboardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetConversionRateDashboardApiV1ConversionRateDashboardGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetConversionRateDashboardApiV1ConversionRateDashboardGetResponses,
    GetConversionRateDashboardApiV1ConversionRateDashboardGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/conversion-rate/dashboard",
    ...options,
  });

/**
 * Get Conversion Rate Demographics
 */
export const getConversionRateDemographicsApiV1ConversionRateDemographicsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetConversionRateDemographicsApiV1ConversionRateDemographicsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetConversionRateDemographicsApiV1ConversionRateDemographicsGetResponses,
    GetConversionRateDemographicsApiV1ConversionRateDemographicsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/conversion-rate/demographics",
    ...options,
  });

/**
 * Get Conversion Rate Demographics V2
 */
export const getConversionRateDemographicsV2ApiV1ConversionRateDemographicsV2Get =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetConversionRateDemographicsV2ApiV1ConversionRateDemographicsV2GetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetConversionRateDemographicsV2ApiV1ConversionRateDemographicsV2GetResponses,
      GetConversionRateDemographicsV2ApiV1ConversionRateDemographicsV2GetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/conversion-rate/demographics-v2",
      ...options,
    });

/**
 * Get Conversion Rate Full
 *
 * ENDPOINT EM USO NA PÁGINA Taxa de Conversão - Card CATEGORIAS/PRODUTOS/ORIGEM-MÍDIA/CAMPANHA (UTM)
 */
export const getConversionRateFullApiV1ConversionRateFullGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetConversionRateFullApiV1ConversionRateFullGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetConversionRateFullApiV1ConversionRateFullGetResponses,
    GetConversionRateFullApiV1ConversionRateFullGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/conversion-rate/full",
    ...options,
  });

/**
 * Get Conversion Rate Utm Campaigns
 */
export const getConversionRateUtmCampaignsApiV1ConversionRateUtmCampaignsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetConversionRateUtmCampaignsApiV1ConversionRateUtmCampaignsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetConversionRateUtmCampaignsApiV1ConversionRateUtmCampaignsGetResponses,
    GetConversionRateUtmCampaignsApiV1ConversionRateUtmCampaignsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/conversion-rate/utm-campaigns",
    ...options,
  });

/**
 * Get Daily Control
 *
 * # ENDPOINT EM USO NA PÁGINA Visão Geral - Card CONTROLE DIÁRIO
 */
export const getDailyControlApiV1DailyControlCardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDailyControlApiV1DailyControlCardGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetDailyControlApiV1DailyControlCardGetResponses,
    GetDailyControlApiV1DailyControlCardGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/daily-control/card",
    ...options,
  });

/**
 * Get Google Analytics Conversion Rate Cards Kpis
 */
export const getGoogleAnalyticsConversionRateCardsKpisApiV1GoogleAnalyticsConversionRateCardsKpisGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoogleAnalyticsConversionRateCardsKpisApiV1GoogleAnalyticsConversionRateCardsKpisGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetGoogleAnalyticsConversionRateCardsKpisApiV1GoogleAnalyticsConversionRateCardsKpisGetResponses,
      GetGoogleAnalyticsConversionRateCardsKpisApiV1GoogleAnalyticsConversionRateCardsKpisGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/google-analytics/conversion-rate/cards-kpis",
      ...options,
    });

/**
 * Get Sales Funnel
 *
 * # ENDPOINT EM USO NA PÁGINA Visão Geral - Card FUNIL DE VENDAS
 */
export const getSalesFunnelApiV1SalesFunnelCardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSalesFunnelApiV1SalesFunnelCardGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSalesFunnelApiV1SalesFunnelCardGetResponses,
    GetSalesFunnelApiV1SalesFunnelCardGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sales-funnel/card",
    ...options,
  });

/**
 * Get Sales Funnel Stage 1 Breakdown
 */
export const apiV1SalesFunnelStage1BreakdownGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1SalesFunnelStage1BreakdownGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ApiV1SalesFunnelStage1BreakdownGetResponses,
    ApiV1SalesFunnelStage1BreakdownGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sales-funnel/stage-1-breakdown",
    ...options,
  });

/**
 * Proxy Ads Dashboard Chart
 *
 * Proxy for ADS Dashboard Charts.
 */
export const proxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGetResponses,
    ProxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/ads-dashboard/{platform}/charts/{chart}",
    ...options,
  });

/**
 * Proxy Ads Dashboard Kpi
 *
 * Proxy for ADS Dashboard KPIs.
 */
export const proxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGetResponses,
    ProxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/ads-dashboard/{platform}/kpis/{metric}",
    ...options,
  });

/**
 * Proxy Ads Dashboard Table
 *
 * Proxy for ADS Dashboard Tables.
 */
export const proxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGetResponses,
    ProxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/ads-dashboard/{platform}/tables/{table}",
    ...options,
  });

/**
 * Get Available Months
 */
export const getAvailableMonthsApiV1BenchmarkAvailableMonthsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAvailableMonthsApiV1BenchmarkAvailableMonthsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAvailableMonthsApiV1BenchmarkAvailableMonthsGetResponses,
    GetAvailableMonthsApiV1BenchmarkAvailableMonthsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/benchmark/available-months",
    ...options,
  });

/**
 * Get Data
 */
export const getDataApiV1BenchmarkDataPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDataApiV1BenchmarkDataPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GetDataApiV1BenchmarkDataPostResponses,
    GetDataApiV1BenchmarkDataPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/benchmark/data",
    ...options,
  });

/**
 * Finalize Update
 */
export const finalizeUpdateApiV1BenchmarkFinalizeUpdatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    FinalizeUpdateApiV1BenchmarkFinalizeUpdatePostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    FinalizeUpdateApiV1BenchmarkFinalizeUpdatePostResponses,
    FinalizeUpdateApiV1BenchmarkFinalizeUpdatePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/benchmark/finalize-update",
    ...options,
  });

/**
 * Get Historical Data
 */
export const getHistoricalDataApiV1BenchmarkHistoricalDataPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHistoricalDataApiV1BenchmarkHistoricalDataPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    GetHistoricalDataApiV1BenchmarkHistoricalDataPostResponses,
    GetHistoricalDataApiV1BenchmarkHistoricalDataPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/benchmark/historical-data",
    ...options,
  });

/**
 * Get Participation Report
 */
export const getParticipationReportApiV1BenchmarkParticipationReportPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetParticipationReportApiV1BenchmarkParticipationReportPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    GetParticipationReportApiV1BenchmarkParticipationReportPostResponses,
    GetParticipationReportApiV1BenchmarkParticipationReportPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/benchmark/participation-report",
    ...options,
  });

/**
 * Get Segments
 */
export const getSegmentsApiV1BenchmarkSegmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSegmentsApiV1BenchmarkSegmentsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSegmentsApiV1BenchmarkSegmentsGetResponses,
    GetSegmentsApiV1BenchmarkSegmentsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/benchmark/segments",
    ...options,
  });

/**
 * Sync Account
 */
export const syncAccountApiV1BenchmarkSyncAccountPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SyncAccountApiV1BenchmarkSyncAccountPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SyncAccountApiV1BenchmarkSyncAccountPostResponses,
    SyncAccountApiV1BenchmarkSyncAccountPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/benchmark/sync-account",
    ...options,
  });

/**
 * Update Account
 */
export const updateAccountApiV1BenchmarkUpdateAccountPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAccountApiV1BenchmarkUpdateAccountPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    UpdateAccountApiV1BenchmarkUpdateAccountPostResponses,
    UpdateAccountApiV1BenchmarkUpdateAccountPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/benchmark/update-account",
    ...options,
  });

/**
 * Get Update Queue
 */
export const getUpdateQueueApiV1BenchmarkUpdateQueuePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUpdateQueueApiV1BenchmarkUpdateQueuePostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    GetUpdateQueueApiV1BenchmarkUpdateQueuePostResponses,
    GetUpdateQueueApiV1BenchmarkUpdateQueuePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/benchmark/update-queue",
    ...options,
  });

/**
 * Get Historical Ads Performance
 *
 * ENDPOINT EM USO NA PÁGINA Histórico - Card DADOS HISTÓRICOS DE PERFORMANCE
 */
export const getHistoricalAdsPerformanceApiV1HistoricalAdsPerformanceGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHistoricalAdsPerformanceApiV1HistoricalAdsPerformanceGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetHistoricalAdsPerformanceApiV1HistoricalAdsPerformanceGetResponses,
    GetHistoricalAdsPerformanceApiV1HistoricalAdsPerformanceGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/historical/ads-performance",
    ...options,
  });

/**
 * Get Historical Google Ads Chart
 */
export const getHistoricalGoogleAdsChartApiV1HistoricalGoogleAdsChartGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHistoricalGoogleAdsChartApiV1HistoricalGoogleAdsChartGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetHistoricalGoogleAdsChartApiV1HistoricalGoogleAdsChartGetResponses,
    GetHistoricalGoogleAdsChartApiV1HistoricalGoogleAdsChartGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/historical/google-ads/chart",
    ...options,
  });

/**
 * Get Historical Google Ads Table
 */
export const getHistoricalGoogleAdsTableApiV1HistoricalGoogleAdsTableGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHistoricalGoogleAdsTableApiV1HistoricalGoogleAdsTableGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetHistoricalGoogleAdsTableApiV1HistoricalGoogleAdsTableGetResponses,
    GetHistoricalGoogleAdsTableApiV1HistoricalGoogleAdsTableGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/historical/google-ads/table",
    ...options,
  });

/**
 * Get Historical Meta Ads Chart
 */
export const getHistoricalMetaAdsChartApiV1HistoricalMetaAdsChartGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHistoricalMetaAdsChartApiV1HistoricalMetaAdsChartGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetHistoricalMetaAdsChartApiV1HistoricalMetaAdsChartGetResponses,
    GetHistoricalMetaAdsChartApiV1HistoricalMetaAdsChartGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/historical/meta-ads/chart",
    ...options,
  });

/**
 * Get Historical Meta Ads Table
 */
export const getHistoricalMetaAdsTableApiV1HistoricalMetaAdsTableGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHistoricalMetaAdsTableApiV1HistoricalMetaAdsTableGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetHistoricalMetaAdsTableApiV1HistoricalMetaAdsTableGetResponses,
    GetHistoricalMetaAdsTableApiV1HistoricalMetaAdsTableGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/historical/meta-ads/table",
    ...options,
  });

/**
 * Get Media Performance Aov Conversion
 */
export const getMediaPerformanceAovConversionApiV1MediaPerformanceAovConversionGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceAovConversionApiV1MediaPerformanceAovConversionGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceAovConversionApiV1MediaPerformanceAovConversionGetResponses,
      GetMediaPerformanceAovConversionApiV1MediaPerformanceAovConversionGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/aov-conversion",
      ...options,
    });

/**
 * Get Media Performance Cards
 */
export const getMediaPerformanceCardsApiV1MediaPerformanceCardsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMediaPerformanceCardsApiV1MediaPerformanceCardsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetMediaPerformanceCardsApiV1MediaPerformanceCardsGetResponses,
    GetMediaPerformanceCardsApiV1MediaPerformanceCardsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/media-performance/cards",
    ...options,
  });

/**
 * Get Media Performance Channel Groups
 */
export const getMediaPerformanceChannelGroupsApiV1MediaPerformanceChannelGroupsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceChannelGroupsApiV1MediaPerformanceChannelGroupsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceChannelGroupsApiV1MediaPerformanceChannelGroupsGetResponses,
      GetMediaPerformanceChannelGroupsApiV1MediaPerformanceChannelGroupsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/channel-groups",
      ...options,
    });

/**
 * Get Media Performance General Performance
 */
export const getMediaPerformanceGeneralPerformanceApiV1MediaPerformanceGeneralPerformanceGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceGeneralPerformanceApiV1MediaPerformanceGeneralPerformanceGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceGeneralPerformanceApiV1MediaPerformanceGeneralPerformanceGetResponses,
      GetMediaPerformanceGeneralPerformanceApiV1MediaPerformanceGeneralPerformanceGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/general-performance",
      ...options,
    });

/**
 * Get Media Performance Investment Cps
 */
export const getMediaPerformanceInvestmentCpsApiV1MediaPerformanceInvestmentCpsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceInvestmentCpsApiV1MediaPerformanceInvestmentCpsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceInvestmentCpsApiV1MediaPerformanceInvestmentCpsGetResponses,
      GetMediaPerformanceInvestmentCpsApiV1MediaPerformanceInvestmentCpsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/investment-cps",
      ...options,
    });

/**
 * Get Media Performance Investment Revenue
 */
export const getMediaPerformanceInvestmentRevenueApiV1MediaPerformanceInvestmentRevenueGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceInvestmentRevenueApiV1MediaPerformanceInvestmentRevenueGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceInvestmentRevenueApiV1MediaPerformanceInvestmentRevenueGetResponses,
      GetMediaPerformanceInvestmentRevenueApiV1MediaPerformanceInvestmentRevenueGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/investment-revenue",
      ...options,
    });

/**
 * Get Media Performance Investment Roas
 */
export const getMediaPerformanceInvestmentRoasApiV1MediaPerformanceInvestmentRoasGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceInvestmentRoasApiV1MediaPerformanceInvestmentRoasGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceInvestmentRoasApiV1MediaPerformanceInvestmentRoasGetResponses,
      GetMediaPerformanceInvestmentRoasApiV1MediaPerformanceInvestmentRoasGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/investment-roas",
      ...options,
    });

/**
 * Get Media Performance Investment Sessions
 */
export const getMediaPerformanceInvestmentSessionsApiV1MediaPerformanceInvestmentSessionsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceInvestmentSessionsApiV1MediaPerformanceInvestmentSessionsGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceInvestmentSessionsApiV1MediaPerformanceInvestmentSessionsGetResponses,
      GetMediaPerformanceInvestmentSessionsApiV1MediaPerformanceInvestmentSessionsGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/investment-sessions",
      ...options,
    });

/**
 * Get Media Performance Revenue Conversion
 */
export const getMediaPerformanceRevenueConversionApiV1MediaPerformanceRevenueConversionGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceRevenueConversionApiV1MediaPerformanceRevenueConversionGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceRevenueConversionApiV1MediaPerformanceRevenueConversionGetResponses,
      GetMediaPerformanceRevenueConversionApiV1MediaPerformanceRevenueConversionGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/revenue-conversion",
      ...options,
    });

/**
 * Get Media Performance Session Origin Media
 */
export const getMediaPerformanceSessionOriginMediaApiV1MediaPerformanceSessionOriginMediaGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceSessionOriginMediaApiV1MediaPerformanceSessionOriginMediaGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceSessionOriginMediaApiV1MediaPerformanceSessionOriginMediaGetResponses,
      GetMediaPerformanceSessionOriginMediaApiV1MediaPerformanceSessionOriginMediaGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/session-origin-media",
      ...options,
    });

/**
 * Get Media Performance Sessions Aov
 */
export const getMediaPerformanceSessionsAovApiV1MediaPerformanceSessionsAovGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceSessionsAovApiV1MediaPerformanceSessionsAovGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceSessionsAovApiV1MediaPerformanceSessionsAovGetResponses,
      GetMediaPerformanceSessionsAovApiV1MediaPerformanceSessionsAovGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/sessions-aov",
      ...options,
    });

/**
 * Get Media Performance Sessions Breakdown
 */
export const getMediaPerformanceSessionsBreakdownApiV1MediaPerformanceSessionsBreakdownGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceSessionsBreakdownApiV1MediaPerformanceSessionsBreakdownGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceSessionsBreakdownApiV1MediaPerformanceSessionsBreakdownGetResponses,
      GetMediaPerformanceSessionsBreakdownApiV1MediaPerformanceSessionsBreakdownGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/sessions-breakdown",
      ...options,
    });

/**
 * Get Media Performance Sessions Conversion
 */
export const getMediaPerformanceSessionsConversionApiV1MediaPerformanceSessionsConversionGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceSessionsConversionApiV1MediaPerformanceSessionsConversionGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceSessionsConversionApiV1MediaPerformanceSessionsConversionGetResponses,
      GetMediaPerformanceSessionsConversionApiV1MediaPerformanceSessionsConversionGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/sessions-conversion",
      ...options,
    });

/**
 * Get Media Performance Sessions Revenue
 */
export const getMediaPerformanceSessionsRevenueApiV1MediaPerformanceSessionsRevenueGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceSessionsRevenueApiV1MediaPerformanceSessionsRevenueGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceSessionsRevenueApiV1MediaPerformanceSessionsRevenueGetResponses,
      GetMediaPerformanceSessionsRevenueApiV1MediaPerformanceSessionsRevenueGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/sessions-revenue",
      ...options,
    });

/**
 * Get Media Performance Sessions Roas
 */
export const getMediaPerformanceSessionsRoasApiV1MediaPerformanceSessionsRoasGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMediaPerformanceSessionsRoasApiV1MediaPerformanceSessionsRoasGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetMediaPerformanceSessionsRoasApiV1MediaPerformanceSessionsRoasGetResponses,
      GetMediaPerformanceSessionsRoasApiV1MediaPerformanceSessionsRoasGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-performance/sessions-roas",
      ...options,
    });

/**
 * List Segments
 */
export const listSegmentsApiV1SegmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListSegmentsApiV1SegmentsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListSegmentsApiV1SegmentsGetResponses,
    ListSegmentsApiV1SegmentsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/segments",
    ...options,
  });

/**
 * Get Loja Virtual Analytics
 *
 * # ENDPOINT EM USO NA PÁGINA /dashboard - Card LOJA VIRTUAL (ANALYTICS)
 */
export const getLojaVirtualAnalyticsApiV1LojaVirtualAnalyticsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetLojaVirtualAnalyticsApiV1LojaVirtualAnalyticsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetLojaVirtualAnalyticsApiV1LojaVirtualAnalyticsGetResponses,
    GetLojaVirtualAnalyticsApiV1LojaVirtualAnalyticsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/loja-virtual-analytics",
    ...options,
  });

/**
 * Get Products Cards
 *
 * ENDPOINT EM USO NA PÁGINA Produtos - Card KPIs
 */
export const getProductsCardsApiV1ProductsCardsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProductsCardsApiV1ProductsCardsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProductsCardsApiV1ProductsCardsGetResponses,
    GetProductsCardsApiV1ProductsCardsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/products/cards",
    ...options,
  });

/**
 * Get Products Dashboard Full
 *
 * ENDPOINT EM USO NA PÁGINA Produtos /dashboard/products - Card PRODUTOS MAIS VENDIDOS
 */
export const getProductsDashboardFullApiV1ProductsDashboardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProductsDashboardFullApiV1ProductsDashboardGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProductsDashboardFullApiV1ProductsDashboardGetResponses,
    GetProductsDashboardFullApiV1ProductsDashboardGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/products/dashboard",
    ...options,
  });

/**
 * Get Products General Item Performance
 */
export const getProductsGeneralItemPerformanceApiV1ProductsGeneralItemPerformanceGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetProductsGeneralItemPerformanceApiV1ProductsGeneralItemPerformanceGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetProductsGeneralItemPerformanceApiV1ProductsGeneralItemPerformanceGetResponses,
      GetProductsGeneralItemPerformanceApiV1ProductsGeneralItemPerformanceGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/products/general-item-performance",
      ...options,
    });

/**
 * Get Products Revenue Trend
 *
 * ENDPOINT EM USO NA PÁGINA Produtos - Gráfico de Evolução dos Produtos Mais Vendidos
 */
export const getProductsRevenueTrendApiV1ProductsRevenueTrendGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProductsRevenueTrendApiV1ProductsRevenueTrendGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProductsRevenueTrendApiV1ProductsRevenueTrendGetResponses,
    GetProductsRevenueTrendApiV1ProductsRevenueTrendGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/products/revenue-trend",
    ...options,
  });

/**
 * Get Products Top Categories Revenue Trend
 */
export const getProductsTopCategoriesRevenueTrendApiV1ProductsTopCategoriesRevenueTrendGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetProductsTopCategoriesRevenueTrendApiV1ProductsTopCategoriesRevenueTrendGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetProductsTopCategoriesRevenueTrendApiV1ProductsTopCategoriesRevenueTrendGetResponses,
      GetProductsTopCategoriesRevenueTrendApiV1ProductsTopCategoriesRevenueTrendGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/products/top-categories-revenue-trend",
      ...options,
    });

/**
 * Get Products Top Category Sales Endpoint
 */
export const apiProductsTopCategorySalesEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiProductsTopCategorySalesEndpointData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ApiProductsTopCategorySalesEndpointResponses,
    ApiProductsTopCategorySalesEndpointErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/products/top-category-sales",
    ...options,
  });

/**
 * Get Revenue Dashboard
 *
 * ENDPOINT EM USO NA PÁGINA Receita - Card RECEITA TOTAL, RECEITA POR DIA,
 * RECEITA POR DIA DA SEMANA, RECEITA POR HORAS, RECEITA POR MÊS
 */
export const getRevenueDashboardApiV1RevenueDashboardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRevenueDashboardApiV1RevenueDashboardGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetRevenueDashboardApiV1RevenueDashboardGetResponses,
    GetRevenueDashboardApiV1RevenueDashboardGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/revenue/dashboard",
    ...options,
  });

/**
 * Get Sales By Channel
 *
 * Obter vendas por canal de aquisição
 */
export const getSalesByChannelApiV1SalesByChannelGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSalesByChannelApiV1SalesByChannelGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSalesByChannelApiV1SalesByChannelGetResponses,
    GetSalesByChannelApiV1SalesByChannelGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sales/by-channel",
    ...options,
  });

/**
 * Get Sales By Device
 *
 * Obter vendas por dispositivo
 */
export const getSalesByDeviceApiV1SalesByDeviceGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSalesByDeviceApiV1SalesByDeviceGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSalesByDeviceApiV1SalesByDeviceGetResponses,
    GetSalesByDeviceApiV1SalesByDeviceGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sales/by-device",
    ...options,
  });

/**
 * Get Sales By Geography
 *
 * Obter vendas por geografia
 */
export const getSalesByGeographyApiV1SalesByGeographyGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetSalesByGeographyApiV1SalesByGeographyGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetSalesByGeographyApiV1SalesByGeographyGetResponses,
    GetSalesByGeographyApiV1SalesByGeographyGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sales/by-geography",
    ...options,
  });

/**
 * Get Daily Performance
 *
 * Obter performance diária por canal
 */
export const getDailyPerformanceApiV1SalesDailyPerformanceGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetDailyPerformanceApiV1SalesDailyPerformanceGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    GetDailyPerformanceApiV1SalesDailyPerformanceGetResponses,
    GetDailyPerformanceApiV1SalesDailyPerformanceGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sales/daily-performance",
    ...options,
  });

/**
 * Get Sales Metrics
 *
 * Obter métricas detalhadas de vendas
 */
export const getSalesMetricsApiV1SalesMetricsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSalesMetricsApiV1SalesMetricsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSalesMetricsApiV1SalesMetricsGetResponses,
    GetSalesMetricsApiV1SalesMetricsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sales/metrics",
    ...options,
  });

/**
 * Get Sales Overview
 *
 * Obter visão geral das vendas agregadas
 */
export const getSalesOverviewApiV1SalesOverviewGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSalesOverviewApiV1SalesOverviewGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSalesOverviewApiV1SalesOverviewGetResponses,
    GetSalesOverviewApiV1SalesOverviewGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sales/overview",
    ...options,
  });

/**
 * Get Sales Trends
 *
 * Obter tendências de vendas ao longo do tempo
 */
export const getSalesTrendsApiV1SalesTrendsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSalesTrendsApiV1SalesTrendsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSalesTrendsApiV1SalesTrendsGetResponses,
    GetSalesTrendsApiV1SalesTrendsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/sales/trends",
    ...options,
  });

/**
 * Get Top Category Sales
 */
export const getTopCategorySalesApiV1TopCategorySalesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTopCategorySalesApiV1TopCategorySalesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetTopCategorySalesApiV1TopCategorySalesGetResponses,
    GetTopCategorySalesApiV1TopCategorySalesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/top-category-sales",
    ...options,
  });

/**
 * Get Top Selling Products
 *
 * Endpoint para obter dados do card PRODUTOS MAIS VENDIDOS
 */
export const getTopSellingProductsApiV1TopSellingProductsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTopSellingProductsApiV1TopSellingProductsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetTopSellingProductsApiV1TopSellingProductsGetResponses,
    GetTopSellingProductsApiV1TopSellingProductsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/top-selling-products",
    ...options,
  });

/**
 * Get All Pages
 *
 * # ENDPOINT EM USO NA PÁGINA /dashboard/pages - Card TODAS AS PÁGINAS
 */
export const getAllPagesApiV1PagesAllPagesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAllPagesApiV1PagesAllPagesGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAllPagesApiV1PagesAllPagesGetResponses,
    GetAllPagesApiV1PagesAllPagesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/pages/all-pages",
    ...options,
  });

/**
 * Get Category By City
 */
export const getCategoryByCityApiV1CategoryByCityGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCategoryByCityApiV1CategoryByCityGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCategoryByCityApiV1CategoryByCityGetResponses,
    GetCategoryByCityApiV1CategoryByCityGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/category-by-city",
    ...options,
  });

/**
 * Get Category By State
 */
export const getCategoryByStateApiV1CategoryByStateGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCategoryByStateApiV1CategoryByStateGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCategoryByStateApiV1CategoryByStateGetResponses,
    GetCategoryByStateApiV1CategoryByStateGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/category-by-state",
    ...options,
  });

/**
 * Get Devices Sales
 *
 * Proxy para o card VENDAS POR DISPOSITIVOS.
 */
export const getDevicesSalesApiV1DevicesSalesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDevicesSalesApiV1DevicesSalesGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetDevicesSalesApiV1DevicesSalesGetResponses,
    GetDevicesSalesApiV1DevicesSalesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/devices-sales",
    ...options,
  });

/**
 * Get Devices States
 *
 * # ENDPOINT EM USO NA PÁGINA Visão Geral - Card VENDAS POR DISPOSITIVOS e VENDAS POR ESTADO
 */
export const getDevicesStatesApiV1DevicesStatesCardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDevicesStatesApiV1DevicesStatesCardGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetDevicesStatesApiV1DevicesStatesCardGetResponses,
    GetDevicesStatesApiV1DevicesStatesCardGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/devices-states/card",
    ...options,
  });

/**
 * Get Internal Search
 *
 * # ENDPOINT EM USO NA PÁGINA Visão Geral - Card PESQUISA INTERNA
 */
export const getInternalSearchApiV1InternalSearchCardGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInternalSearchApiV1InternalSearchCardGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetInternalSearchApiV1InternalSearchCardGetResponses,
    GetInternalSearchApiV1InternalSearchCardGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/internal-search/card",
    ...options,
  });

/**
 * Get Landing Pages
 *
 * # ENDPOINT EM USO NA PÁGINA /dashboard/pages - Card PÁGINA DE ENTRADA
 */
export const getLandingPagesApiV1PagesLandingPageGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLandingPagesApiV1PagesLandingPageGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetLandingPagesApiV1PagesLandingPageGetResponses,
    GetLandingPagesApiV1PagesLandingPageGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/pages/landing-page",
    ...options,
  });

/**
 * Get Pages Source Medium
 *
 * # ENDPOINT EM USO NA PÁGINA /dashboard/pages - Card ORIGEM / MÍDIA
 */
export const getPagesSourceMediumApiV1PagesSourceMediumGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPagesSourceMediumApiV1PagesSourceMediumGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetPagesSourceMediumApiV1PagesSourceMediumGetResponses,
    GetPagesSourceMediumApiV1PagesSourceMediumGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/pages/source-medium",
    ...options,
  });

/**
 * Get Regions Products By City
 */
export const getRegionsProductsByCityApiV1RegionsProductsByCityGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRegionsProductsByCityApiV1RegionsProductsByCityGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetRegionsProductsByCityApiV1RegionsProductsByCityGetResponses,
    GetRegionsProductsByCityApiV1RegionsProductsByCityGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-products-by-city",
    ...options,
  });

/**
 * Get Regions Sales
 *
 * Proxy para o card VENDAS POR ESTADO (Regiões).
 */
export const getRegionsSalesApiV1RegionsSalesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetRegionsSalesApiV1RegionsSalesGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetRegionsSalesApiV1RegionsSalesGetResponses,
    GetRegionsSalesApiV1RegionsSalesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-sales",
    ...options,
  });

/**
 * Get Regions Sales By City
 *
 * Proxy para VENDAS POR CIDADE.
 */
export const getRegionsSalesByCityApiV1RegionsSalesByCityGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRegionsSalesByCityApiV1RegionsSalesByCityGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetRegionsSalesByCityApiV1RegionsSalesByCityGetResponses,
    GetRegionsSalesByCityApiV1RegionsSalesByCityGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-sales/by-city",
    ...options,
  });

/**
 * Get Regions Sales By State
 *
 * Proxy para VENDAS POR ESTADO.
 */
export const getRegionsSalesByStateApiV1RegionsSalesByStateGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRegionsSalesByStateApiV1RegionsSalesByStateGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetRegionsSalesByStateApiV1RegionsSalesByStateGetResponses,
    GetRegionsSalesByStateApiV1RegionsSalesByStateGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-sales/by-state",
    ...options,
  });

/**
 * Get Regions Sales Overview
 *
 * Proxy para VISÃO GERAL DE REGIÕES.
 */
export const getRegionsSalesOverviewApiV1RegionsSalesOverviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRegionsSalesOverviewApiV1RegionsSalesOverviewGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetRegionsSalesOverviewApiV1RegionsSalesOverviewGetResponses,
    GetRegionsSalesOverviewApiV1RegionsSalesOverviewGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-sales/overview",
    ...options,
  });

/**
 * Proxy Regions Categories
 */
export const proxyRegionsCategoriesApiV1RegionsDashboardCategoriesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProxyRegionsCategoriesApiV1RegionsDashboardCategoriesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProxyRegionsCategoriesApiV1RegionsDashboardCategoriesGetResponses,
    ProxyRegionsCategoriesApiV1RegionsDashboardCategoriesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-dashboard/categories",
    ...options,
  });

/**
 * Proxy Regions Category Matrix
 */
export const proxyRegionsCategoryMatrixApiV1RegionsDashboardCategoryMatrixGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ProxyRegionsCategoryMatrixApiV1RegionsDashboardCategoryMatrixGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      ProxyRegionsCategoryMatrixApiV1RegionsDashboardCategoryMatrixGetResponses,
      ProxyRegionsCategoryMatrixApiV1RegionsDashboardCategoryMatrixGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/regions-dashboard/category-matrix",
      ...options,
    });

/**
 * Proxy Regions Cities
 */
export const proxyRegionsCitiesApiV1RegionsDashboardCitiesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProxyRegionsCitiesApiV1RegionsDashboardCitiesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProxyRegionsCitiesApiV1RegionsDashboardCitiesGetResponses,
    ProxyRegionsCitiesApiV1RegionsDashboardCitiesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-dashboard/cities",
    ...options,
  });

/**
 * Proxy Regions Items
 */
export const proxyRegionsItemsApiV1RegionsDashboardItemsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProxyRegionsItemsApiV1RegionsDashboardItemsGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProxyRegionsItemsApiV1RegionsDashboardItemsGetResponses,
    ProxyRegionsItemsApiV1RegionsDashboardItemsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-dashboard/items",
    ...options,
  });

/**
 * Proxy Regions States
 */
export const proxyRegionsStatesApiV1RegionsDashboardStatesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProxyRegionsStatesApiV1RegionsDashboardStatesGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProxyRegionsStatesApiV1RegionsDashboardStatesGetResponses,
    ProxyRegionsStatesApiV1RegionsDashboardStatesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-dashboard/states",
    ...options,
  });

/**
 * Proxy Regions Summary
 */
export const proxyRegionsSummaryApiV1RegionsDashboardSummaryGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ProxyRegionsSummaryApiV1RegionsDashboardSummaryGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    ProxyRegionsSummaryApiV1RegionsDashboardSummaryGetResponses,
    ProxyRegionsSummaryApiV1RegionsDashboardSummaryGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/regions-dashboard/summary",
    ...options,
  });

/**
 * Continue Agent Chat
 */
export const continueAgentChatApiV1AiAgentsChatPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ContinueAgentChatApiV1AiAgentsChatPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ContinueAgentChatApiV1AiAgentsChatPostResponses,
    ContinueAgentChatApiV1AiAgentsChatPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/ai-agents/chat",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Fetch Agent Conversation History
 */
export const fetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      FetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGetData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      FetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGetResponses,
      FetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGetErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/ai-agents/{platform}/conversations/{conversation_id}/history",
      ...options,
    });

/**
 * Fetch Agent Insight Get
 */
export const fetchAgentInsightGetApiV1AiAgentsPlatformInsightGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    FetchAgentInsightGetApiV1AiAgentsPlatformInsightGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    FetchAgentInsightGetApiV1AiAgentsPlatformInsightGetResponses,
    FetchAgentInsightGetApiV1AiAgentsPlatformInsightGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/ai-agents/{platform}/insight",
    ...options,
  });

/**
 * Fetch Agent Insight
 */
export const fetchAgentInsightApiV1AiAgentsPlatformInsightPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    FetchAgentInsightApiV1AiAgentsPlatformInsightPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    FetchAgentInsightApiV1AiAgentsPlatformInsightPostResponses,
    FetchAgentInsightApiV1AiAgentsPlatformInsightPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/ai-agents/{platform}/insight",
    ...options,
  });

/**
 * Continue Chat
 *
 * Continua o chat com o LLM sobre um insight específico
 */
export const continueChatApiV1AiInsightsChatPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ContinueChatApiV1AiInsightsChatPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ContinueChatApiV1AiInsightsChatPostResponses,
    ContinueChatApiV1AiInsightsChatPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/ai-insights/chat",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Generate Insights
 *
 * Gera insights de IA baseados nos dados fornecidos
 */
export const generateInsightsApiV1AiInsightsGenerateInsightsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GenerateInsightsApiV1AiInsightsGenerateInsightsPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    GenerateInsightsApiV1AiInsightsGenerateInsightsPostResponses,
    GenerateInsightsApiV1AiInsightsGenerateInsightsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/ai-insights/generate-insights",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Implementation Steps
 *
 * Obtém passos de implementação para um insight específico
 */
export const getImplementationStepsApiV1AiInsightsImplementationStepsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetImplementationStepsApiV1AiInsightsImplementationStepsPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    GetImplementationStepsApiV1AiInsightsImplementationStepsPostResponses,
    GetImplementationStepsApiV1AiInsightsImplementationStepsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/ai-insights/implementation-steps",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Analyses
 *
 * Histórico de análises da conta selecionada.
 */
export const listAnalysesApiV1DiagnosticAnalysesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListAnalysesApiV1DiagnosticAnalysesGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListAnalysesApiV1DiagnosticAnalysesGetResponses,
    ListAnalysesApiV1DiagnosticAnalysesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/diagnostic/analyses",
    ...options,
  });

/**
 * Delete Analysis
 */
export const deleteAnalysisApiV1DiagnosticAnalysesAnalysisIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAnalysisApiV1DiagnosticAnalysesAnalysisIdDeleteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAnalysisApiV1DiagnosticAnalysesAnalysisIdDeleteResponses,
    DeleteAnalysisApiV1DiagnosticAnalysesAnalysisIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/diagnostic/analyses/{analysis_id}",
    ...options,
  });

/**
 * Get Analysis
 *
 * Uma análise com o resultado mais recente de cada tipo de página.
 */
export const getAnalysisApiV1DiagnosticAnalysesAnalysisIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAnalysisApiV1DiagnosticAnalysesAnalysisIdGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAnalysisApiV1DiagnosticAnalysesAnalysisIdGetResponses,
    GetAnalysisApiV1DiagnosticAnalysesAnalysisIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/diagnostic/analyses/{analysis_id}",
    ...options,
  });

/**
 * Analyze Page
 *
 * Dispara a auditoria de uma página (home, categoria ou produto).
 */
export const analyzePageApiV1DiagnosticAnalyzePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AnalyzePageApiV1DiagnosticAnalyzePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AnalyzePageApiV1DiagnosticAnalyzePostResponses,
    AnalyzePageApiV1DiagnosticAnalyzePostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/diagnostic/analyze",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Job Status
 *
 * Polling do progresso da auditoria.
 */
export const getJobStatusApiV1DiagnosticJobsJobIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetJobStatusApiV1DiagnosticJobsJobIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetJobStatusApiV1DiagnosticJobsJobIdGetResponses,
    GetJobStatusApiV1DiagnosticJobsJobIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/diagnostic/jobs/{job_id}",
    ...options,
  });

/**
 * Resolve Conversation
 *
 * Resolve a conversa do usuário (get-or-create) e retorna o histórico.
 *
 * Fonte da verdade do histórico: o Nexus. O frontend não guarda estado —
 * chama este endpoint ao abrir a tela e recebe a conversa + mensagens.
 */
export const resolveConversationApiV1MediaChatConversationGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ResolveConversationApiV1MediaChatConversationGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ResolveConversationApiV1MediaChatConversationGetResponses,
    ResolveConversationApiV1MediaChatConversationGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/media-chat/conversation",
    ...options,
  });

/**
 * List Conversations
 *
 * Lista as conversas da conta selecionada (multi-chat).
 */
export const listConversationsApiV1MediaChatConversationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListConversationsApiV1MediaChatConversationsGetData,
    ThrowOnError
  >,
) =>
  (options?.client ?? client).get<
    ListConversationsApiV1MediaChatConversationsGetResponses,
    ListConversationsApiV1MediaChatConversationsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/media-chat/conversations",
    ...options,
  });

/**
 * Start Conversation
 *
 * Cria uma conversa nova (botão 'Nova conversa'). 409 se atingiu o limite.
 */
export const startConversationApiV1MediaChatConversationsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    StartConversationApiV1MediaChatConversationsPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    StartConversationApiV1MediaChatConversationsPostResponses,
    StartConversationApiV1MediaChatConversationsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/media-chat/conversations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Conversation
 */
export const deleteConversationApiV1MediaChatConversationsConversationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteConversationApiV1MediaChatConversationsConversationIdDeleteData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).delete<
      DeleteConversationApiV1MediaChatConversationsConversationIdDeleteResponses,
      DeleteConversationApiV1MediaChatConversationsConversationIdDeleteErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-chat/conversations/{conversation_id}",
      ...options,
    });

/**
 * Rename Conversation
 */
export const renameConversationApiV1MediaChatConversationsConversationIdPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RenameConversationApiV1MediaChatConversationsConversationIdPatchData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).patch<
      RenameConversationApiV1MediaChatConversationsConversationIdPatchResponses,
      RenameConversationApiV1MediaChatConversationsConversationIdPatchErrors,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v1/media-chat/conversations/{conversation_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * Ask
 */
export const askApiV1MediaChatConversationsConversationIdAskPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AskApiV1MediaChatConversationsConversationIdAskPostData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    AskApiV1MediaChatConversationsConversationIdAskPostResponses,
    AskApiV1MediaChatConversationsConversationIdAskPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/media-chat/conversations/{conversation_id}/ask",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get History
 */
export const getHistoryApiV1MediaChatConversationsConversationIdHistoryGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetHistoryApiV1MediaChatConversationsConversationIdHistoryGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetHistoryApiV1MediaChatConversationsConversationIdHistoryGetResponses,
    GetHistoryApiV1MediaChatConversationsConversationIdHistoryGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/media-chat/conversations/{conversation_id}/history",
    ...options,
  });

/**
 * Get Job Status
 */
export const getJobStatusApiV1MediaChatJobsJobIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetJobStatusApiV1MediaChatJobsJobIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetJobStatusApiV1MediaChatJobsJobIdGetResponses,
    GetJobStatusApiV1MediaChatJobsJobIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/media-chat/jobs/{job_id}",
    ...options,
  });

/**
 * List Agency Teams
 */
export const apiV1TeamsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ApiV1TeamsGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiV1TeamsGetResponses,
    ApiV1TeamsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/teams",
    ...options,
  });

/**
 * Create Agency Team
 */
export const apiV1TeamsPost = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1TeamsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApiV1TeamsPostResponses,
    ApiV1TeamsPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/teams",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get My Team Scope
 */
export const apiV1TeamsMyScopeGet = <ThrowOnError extends boolean = false>(
  options?: Options<ApiV1TeamsMyScopeGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiV1TeamsMyScopeGetResponses,
    ApiV1TeamsMyScopeGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/teams/my-scope",
    ...options,
  });

/**
 * Delete Agency Team
 */
export const apiV1TeamsTeamIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1TeamsTeamIdDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ApiV1TeamsTeamIdDeleteResponses,
    ApiV1TeamsTeamIdDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/teams/{team_id}",
    ...options,
  });

/**
 * Get Agency Team
 */
export const apiV1TeamsTeamIdGet = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1TeamsTeamIdGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ApiV1TeamsTeamIdGetResponses,
    ApiV1TeamsTeamIdGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/teams/{team_id}",
    ...options,
  });

/**
 * Update Agency Team
 */
export const apiV1TeamsTeamIdPut = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1TeamsTeamIdPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ApiV1TeamsTeamIdPutResponses,
    ApiV1TeamsTeamIdPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/teams/{team_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Agency Team Members
 */
export const apiV1TeamsTeamIdMembersPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1TeamsTeamIdMembersPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ApiV1TeamsTeamIdMembersPutResponses,
    ApiV1TeamsTeamIdMembersPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/teams/{team_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Agency Team Accounts
 */
export const apiV1TeamsTeamIdAccountsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1TeamsTeamIdAccountsPutData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    ApiV1TeamsTeamIdAccountsPutResponses,
    ApiV1TeamsTeamIdAccountsPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/teams/{team_id}/accounts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Team Consolidated Overview
 */
export const apiV1TeamsTeamIdOverviewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1TeamsTeamIdOverviewGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ApiV1TeamsTeamIdOverviewGetResponses,
    ApiV1TeamsTeamIdOverviewGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/teams/{team_id}/overview",
    ...options,
  });

/**
 * Submit Feedback
 */
export const apiV1FeedbackPost = <ThrowOnError extends boolean = false>(
  options: Options<ApiV1FeedbackPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApiV1FeedbackPostResponses,
    ApiV1FeedbackPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/feedback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Feedbacks
 */
export const apiV1AdminFeedbackGet = <ThrowOnError extends boolean = false>(
  options?: Options<ApiV1AdminFeedbackGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ApiV1AdminFeedbackGetResponses,
    ApiV1AdminFeedbackGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/feedback",
    ...options,
  });

/**
 * Update Feedback Status
 */
export const apiV1AdminFeedbackFeedbackIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApiV1AdminFeedbackFeedbackIdPatchData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ApiV1AdminFeedbackFeedbackIdPatchResponses,
    ApiV1AdminFeedbackFeedbackIdPatchErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v1/admin/feedback/{feedback_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
